import precisionMatching from '../assests/images/flipcard1.png';
import tailoredProposals from '../assests/images/flipcard2.png';
import comprehensiveVetting from '../assests/images/flipcard3.png';
import effortlessConnection from '../assests/images/flipcard4.png';
import avtar from '../assests/images/avtar.jpg';
import grossSalaryIcon from "../assests/images/gross-salary.png";
import federalTaxIcon from "../assests/images/federal-tax.png";
import stateTaxIcon from "../assests/images/federal-tax.png";
import ficaIcon from "../assests/images/fica.png";
import netTakeHomeIcon from "../assests/images/net-takehome.png";
import ChartNoAxesCombined from "../assests/images/Increase.png";
import Rocket from "../assests/images/Rocket.png";
import Building from "../assests/images/Company.png";
import { images } from './imagespath/images';
import FeatureHeroImg from "../assests/images/FeaturesHero.png";
import clock from "../assests/images/Clock.svg";
import banknotes from "../assests/images/Banknotes.svg";
import decrease from "../assests/images/Decrease.svg";
import goodquality from "../assests/images/Good Quality.svg";
import article_img_2 from "../assests/images/article_img_2.png";
import article_img_3 from "../assests/images/article_img_3.png";
import article_img_4 from "../assests/images/article_img_4.png";
import article_img_5 from "../assests/images/article_img_5.png";
import AdobeStock_blog from "../assests/images/AdobeStock.png"
import flagUSA from "../assests/images/usa.png";
import flagIndia from "../assests/images/india.png";
import flagAustralia from "../assests/images/australia.png";
import flagSingapore from "../assests/images/singapore.png";
import flagMalaysia from "../assests/images/malaysia.png";
import flagQatar from "../assests/images/qatar.png";
import flagUAE from "../assests/images/uae.png";
import flagFrance from "../assests/images/france.png";
import flagCanada from "../assests/images/canada.png";
import flagBrazil from "../assests/images/brazil.png";
import vendorIcon from "../assests/images/vendorIcon.png";
import buyersIcon from "../assests/images/buyersIcon.png";
import marketplaceIcon from "../assests/images/marketplaceIcon.png";
import AvatarNetwork from "../assests/images/avatar-network.svg";
import AdobeStock from "../assests/images/AdobeStock.png";
import AdobeStock_2 from "../assests/images/AdobeStock_2.png";
import growthIcon from "../assests/images/about3-1.svg";
import startupIcon from "../assests/images/about3-2.svg";
import enterpriseIcon from "../assests/images/about3-3.svg";
import corevalue1 from "../assests/images/about4-1.png";
import corevalue2 from "../assests/images/about4-2.png";
import corevalue3 from "../assests/images/about4-3.png";
import corevalue4 from "../assests/images/about4-4.png";
import corevalue5 from "../assests/images/about4-5.png";

export const serviceCards = [
  {
    title: "One-Stop platform",
    frontDescription: "Monthly Plans: Unlimited access & insights",
    image: precisionMatching,
    description: "Our advanced algorithm analyzes your preferences to find the most compatible matches with high accuracy.",
    buttonText: "View Plans & Pricing",
    navigationPath: "/plans"
  },
  {
    title: "Access to verified partners",
    frontDescription: "Quality Leads: Pre-qualified buyer connections",
    image: tailoredProposals,
    description: "Receive personalized marriage proposals curated specifically for your unique requirements and expectations.",
    buttonText: "View Plans & Pricing",
    navigationPath: "/plans"
  },
  {
    title: "Real-time cost and service benchmarks",
    frontDescription: "",
    image: comprehensiveVetting,
    description: "Every profile undergoes rigorous verification to ensure authenticity and match your criteria.",
    buttonText: "Learn More",
    navigationPath: "/demand-generation"
  },
  {
    title: "Country-specific compliance data",
    frontDescription: "",
    image: effortlessConnection,
    description: "Our platform makes communication simple and secure, helping you build meaningful connections.",
    buttonText: "Get Started",
    navigationPath: "/advertising"
  }
];

export const homecomp5Data = [
  { id: 1, text: "Enterprises planning international expansion and growing their global reach." },
  { id: 2, text: "Growth leaders and expansion experts seeking seamless international expansion." },
  { id: 3, text: "Businesses exploring new opportunities in global markets." },
];

export const testimonials = [
  {
    testimonial: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua quis nostrud exercitation ullamco.',
    name: 'Maxin Will',
    role: 'Product Manager',
    image: avtar
  },
  {
    testimonial: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.',
    name: 'Sarah Lynn',
    role: 'UX Designer',
    image: avtar
  },
  {
    testimonial: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos.',
    name: 'Jason Roy',
    role: 'CTO',
    image: avtar
  }
];

export const steps = [
  {
    id: 'step1',
    number: '1',
    title: 'Tell Us What You Need',
    description: 'Select your service category and target country. Thhiya instantly provides decision-ready insights backed by real data, transparent pricing, compliance benchmarks, and verified market intelligence you can trust.',
  },
  {
    id: 'step2',
    number: '2',
    title: 'Receive Actionable  Insights Instantly',
    description: 'Our platform connects you with top pre-vetted partners tailored to your needs. Save hours of research by completing a single form and receiving curated recommendations in minutes. Without the cost of low-quality leads or time-consuming outreach.',
  },
  {
    id: 'step3',
    number: '3',
    title: 'Let Thhiya Recommend the Best Partners ',
    description: 'Make informed decisions with full control over your privacy. We share your details only when you choose to connect, ensuring every partnership delivers value while safeguarding your information.',
  },
];






/*===========================
        Insights Page
============================= */
export const filterData = {
  country: [  "United States",
  "India",
  "Australia",
  "Singapore",
  "Malaysia",
  "Qatar",
  "UAE",
  "France",
  "Canada",
  "Brazil",
  "Argentina",
  "Chile"
],
  employeeType: ["Full-time", "Part-time", "Intern", "Contract"],
  payrollFrequency: ["Monthly", "Bi-weekly", "Weekly"],
  companySize: ["1-10", "11-50", "51-200", "200+"],
  salaryBand: ["<10k", "10k-50k", "50k-100k", "100k+"],
  keyPriorities: ["Hiring", "Retention", "Expansion"],
  services: [
    "EOR/PEO/AOR Services",
    "Incorporation/Entity Setup",
    "Staffing/Talent Acquisition",
    "Global Payroll",
    "HRIS (Human Resources Information System)",
    "Accounting Services",
    "Tax Services",
    "Compliance Services",
    "M&A Services",
    "Software Solutions",
    "MSP (Managed Service Provider)"
  ]
};

export const businessGuideContent = {
  defaultCountry: "United States",
  countries: {
    "United States": {
      title: "United States - Complete Business Services Guide",
      subtitle: "Streamline Your US Expansion with Tailored Solutions",
      description: "Navigating US business services can be complex. Thhiya simplifies your expansion with data-driven insights, transparent pricing, and pre-vetted partners across all our service categories.",
      flag: images.USFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Growth Leader",
          text: "Scaling teams across the US states with efficient operations and compliance.",
        },
        {
          icon: images.Rocket,
          title: "Startups",
          text: "Establishing US entities or hiring remotely with minimal friction.",
        },
        {
          icon: images.Building,
          title: "Enterprises",
          text: "Optimizing compliance, payroll, and HR tech across multiple locations.",
        },
      ],
    },
    "UAE": {
      title: "The UAE - Complete Business Services Guide",
      subtitle: "Streamline Your UAE Expansion with Tailored Solutions",
      description: "Navigating the UAE’s employment and HR landscape can be complex. Thhiya simplifies your expansion with data-driven insights, transparent pricing, and vetted providers across EOR, PEO, and related services, tailored to the UAE context.",
      flag: images.UAEFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Growth Leader",
          text: "Expanding teams into the UAE mainland or free zones.",
        },
        {
          icon: images.Rocket,
          title: "Startups",
          text: "Launching a legal entity or hiring remotely.",
        },
        {
          icon: images.Building,
          title: "Enterprises",
          text: "Optimizing compliance, payroll, and HR systems in the UAE.",
        },
      ],
    },
    "Singapore": {
      title: "Singapore - Complete Business Services Guide",
      subtitle: "Streamline Your Singapore Expansion with Tailored Solutions",
      description: "Expanding your business into Singapore offers incredible opportunities, but navigating incorporation, compliance, payroll, and HR can still feel complex. Thhiya simplifies your journey with data-driven insights, transparent pricing, and trusted partners across every service area.",
      flag: images.SingaporeFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Growth Leader",
          text: "Building teams across Singapore.",
        },
        {
          icon: images.Rocket,
          title: "Startups",
          text: "Setting up a local entity or hiring remote talent.",
        },
        {
          icon: images.Building,
          title: "Enterprises",
          text: "Optimizing compliance, payroll, and HR technology in the Singapore market.",
        },
      ],
    },
    "Qatar": {
      title: "Qatar - Complete Business Services Guide",
      subtitle: "Simplify Your Qatar Expansion with Expert-Led Solutions",
      description: "Doing business in Qatar requires navigating entity structures, sponsorship rules, labour laws, payroll, tax compliance and many other aspects. Thhiya helps you expand confidently with transparent insights, practical solutions, and trusted local expertise across every business service category.",
      flag: images.QatarFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Startups & scale-ups",
          text: "Seeking fast entry into Qatar’s market.",
        },
        {
          icon: images.Rocket,
          title: "Global",
          text: "Enterprises expanding into the Middle East.",
        },
        {
          icon: images.Building,
          title: "Investors & founders",
          text: "Seeking compliance-ready structures and staffing solutions.",
        },
      ],
    },
    "Malaysia": {
      title: "Malaysia - Complete Business Services Guide",
      subtitle: "Streamline Your Malaysia Expansion with Tailored Solutions",
      description: "Navigating Malaysia’s employment and HR landscape can be tricky. Thhiya simplifies your expansion with data-driven insights, transparent pricing, and vetted providers across EOR, PEO, and related services.",
      flag: images.MalaysiaFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Growth Leader",
          text: "Scaling teams across Malaysia.",
        },
        {
          icon: images.Rocket,
          title: "Startups",
          text: "Establishing a legal entity or hiring remotely.",
        },
        {
          icon: images.Building,
          title: "Enterprises",
          text: "Optimizing compliance, payroll, and HR tech.",
        },
      ],
    },
    "India": {
      title: "India - Complete Business Services Guide",
      subtitle: "Simplify Your India Expansion with Expert-Led Solutions",
      description: "Expanding into India can be complex due to varying state regulations, GST compliance, and labour laws. Thhiya streamlines your growth with real-time compliance data, transparent pricing, and pre-vetted partners across our full suite of services, so that you can scale confidently and efficiently.",
      flag: images.IndiaFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Global Business Leaders",
          text: "Scaling teams across Indian states and cities.",
        },
        {
          icon: images.Rocket,
          title: "Startups",
          text: "Expanding into India or hiring remote talent.",
        },
        {
          icon: images.Building,
          title: "Enterprises",
          text: "Optimizing compliance, HR, payroll, and compliance systems in India.",
        },
      ],
    },
    "France": {
      title: "France - Complete Business Services Guide",
      subtitle: "Simplify Your France Expansion with Expert-Led Solutions",
      description: "Expanding into France can be complex with its labour laws, social charges, and regulatory framework - setting up and managing operations can be challenging without the right partner. Thhiya simplifies your expansion into France by handling the processes of incorporation, payroll, HR and tax. We ensure your business stays fully compliant while giving you the flexibility to focus on growth.",
      flag: images.FranceFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Start-ups & SMEs",
          text: "Entering France for the first time.",
        },
        {
          icon: images.Rocket,
          title: "Multinationals",
          text: "Expanding their operations and hiring staff.",
        },
        {
          icon: images.Building,
          title: "Remote-first",
          text: "Companies that want entity-free hiring through EOR/PEO.",
        },
      ],
    },
    "Canada": {
      title: "Canada - Complete Business Services Guide",
      subtitle: "Simplify Your Canada Expansion with Expert-Led Solutions",
      description: "Navigating Canada’s employment, compliance, and HR landscape can be complex. Thhiya simplifies your expansion with data-driven insights, transparent pricing, and verified providers across EOR, PEO, and related services.",
      flag: images.CanadaFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Growth Leader",
          text: "Scaling teams across Canada.",
        },
        {
          icon: images.Rocket,
          title: "Startups",
          text: "Hiring remotely or setting up their first Canadian entity.",
        },
        {
          icon: images.Building,
          title: "Enterprises",
          text: "Optimizing compliance, payroll, and HR tech solutions.",
        },
      ],
    },
    "Brazil": {
      title: "Brazil - Complete Business Services Guide",
      subtitle: "Streamline Your Brazil Expansion with Local Expertise",
      description: "Establishing your business in Brazil comes with complex labour, tax, and compliance dynamics. Thhiya simplifies this with real-time insights, clear pricing, and trusted partners across essential service categories.",
      flag: images.BrazilFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Growth Leader",
          text: "Operating or expanding across Brazilian states.",
        },
        {
          icon: images.Rocket,
          title: "Startups",
          text: "Entering LATAM markets or hiring remotely.",
        },
        {
          icon: images.Building,
          title: "Enterprises",
          text: "Optimizing payroll, HR systems, or legal compliance.",
        },
      ],
    },
    "Australia": {
      title: "Australia - Complete Business Services Guide",
      subtitle: "Streamline Your Australia Expansion with Tailored Solutions",
      description: "Navigating business services in Australia can feel overwhelming. Thhiya simplifies your expansion using data-based insights, clear pricing, and trusted partners across all service areas.",
      flag: images.AustraliaFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Growth Leaders",
          text: "Expanding teams across Australian states.",
        },
        {
          icon: images.Rocket,
          title: "Startups",
          text: "Setting up local entities or hiring remotely in Australia.",
        },
        {
          icon: images.Building,
          title: "Enterprises",
          text: "Optimising compliance, payroll, and HR technology in the Australian market.",
        },
      ],
    },
        "Argentina": {
      title: "Argentina - Complete Business Services Guide",
      subtitle: "Streamline Your Argentina Expansion with Tailored Solutions",
      description: "Navigating Argentina’s employment, compliance, and HR landscape can be complex. Thhiya simplifies your expansion with data-driven insights, transparent pricing, and verified providers across EOR, PEO, and related services.",
      flag: images.ArgentinaFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Growth Leaders",
          text: "Scaling teams across Argentina.",
        },
        {
          icon: images.Rocket,
          title: "Startups",
          text: "Hiring remotely or setting up their first Argentine entity",
        },
        {
          icon: images.Building,
          title: "Enterprises",
          text: "Optimizing compliance, payroll, and HR tech solutions",
        },
      ],
    },
        "Chile": {
      title: "Chile - Complete Business Services Guide",
      subtitle: "Streamline Your Chile Expansion with Tailored Solutions",
      description: "Navigating Chile’s employment, compliance, and HR landscape has its own complexities. This guide gives you data-driven insight, cost benchmarks, and regulatory context for EOR/PEO, incorporation, payroll, compliance, etc., in Chile.",
      flag: images.ChileFlag,
      sections: [
        {
          icon: images.ChartNoAxesCombined,
          title: "Growth Leaders",
          text: "Scaling teams across Chile.",
        },
        {
          icon: images.Rocket,
          title: "Startups",
          text: "Hiring remotely or planning local operations.",
        },
        {
          icon: images.Building,
          title: "Enterprises",
          text: "Optimizing compliance, payroll, and HR tech solutions.",
        },
      ],
    },
  },
  getContent: function (country) {
    return this.countries[country] || this.countries[this.defaultCountry];
  },
  getAvailableCountries: function () {
    return Object.keys(this.countries);
  },
};




const salaryIcons = {
  setupFee: images.ChartNoAxesCombined,
  monthlyFee: images.Rocket,
  employment: images.Building,
  insurance: images.USFlag,
  benefits: images.IndiaFlag
};

export const salaryData = {
  services: {
    "EOR/PEO/AOR": {
      breakdown: {
        "United States": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, PEO, and AOR solutions for US businesses.",
          description: "Best for: Hiring employees in the United States without a local entity.",
          items: [
            { label: "EOR/PEO Service Fee", amount: "$200-$800", percent: "10-15%", icon: grossSalaryIcon },
            { label: "Onboarding/Setup Fee", amount: "$500-$2,000 (one-time)", percent: "", icon: federalTaxIcon },
            { label: "FICA (Social Security & Medicare)", amount: "$382.50(if $5,000 salary)", percent: "7.6%", icon: stateTaxIcon },
            { label: "FUTA (Federal Unemployment Tax)", amount: "~$35", percent: "~0.6%", icon: ficaIcon },
            { label: "SUTA (State Unemployment Tax)", amount: "$50-$350", percent: "1-6%", icon: ficaIcon },
            { label: "Workers Compensation", amount: "$25-$150", percent: "", icon: netTakeHomeIcon },
            { label: "State Disability Insurance", amount: "$20-$50", percent: "0.5-1%", icon: netTakeHomeIcon },
            { label: "Health Insurance", amount: "$400-$700", percent: "70%", icon: netTakeHomeIcon },
            { label: "Other Mandatory Payroll Deductions", amount: "Varies", percent: "", icon: netTakeHomeIcon },
            { label: "Termination/Offboard Fee", amount: "$300-$1,000", percent: "", icon: netTakeHomeIcon },
            { label: "Security Deposit", amount: "1-3 months", percent: "", icon: netTakeHomeIcon },
          ]
        },

        "UAE": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organisation, and Agent of Record solutions.",
          description: "Best for: Hiring local (Emirati) or expatriate staff swiftly without the hassle of incorporating or supporting existing entities with HR infrastructure.",
          items: [
            { label: "EOR/PEO Service Fee", amount: "$300-800", percent: "20%", icon: grossSalaryIcon },
            { label: "Onboarding / Setup Fee", amount: "Varies", percent: "", icon: federalTaxIcon },
            { label: "Employer Contributions", amount: "", percent: "12.5%", icon: stateTaxIcon },
            { label: "For Expatriates", amount: "None", percent: "", icon: ficaIcon },
            { label: "Medical Insurance", amount: "Varies", percent: "", icon: netTakeHomeIcon },
            { label: "Severance / Gratuity", amount: "Varies", percent: "", icon: netTakeHomeIcon },
          ]
        },

        "Singapore": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organisation, and Agent of Record solutions.",
          description: "Best for: Quick hiring without creating an entity.",
          items: [
            { label: "EOR/PEO Service Fee", amount: "SG$60-$350", percent: "10-20%", icon: grossSalaryIcon },
            { label: "Onboarding/Setup Fee", amount: "SG$500-$5,000 (one-time)", percent: "", icon: federalTaxIcon },
            { label: "CPF (Social Security)", amount: " up to SG$7,400", percent: "17-20%", icon: stateTaxIcon },
            { label: "Health Insurance", amount: "Varies", percent: "", icon: ficaIcon },
            { label: "Other Payroll Deductions", amount: "Varies", percent: "", icon: netTakeHomeIcon },
            { label: "Termination/Offboard Fee", amount: "SG$300-$1,000 (one-time)", percent: "", icon: netTakeHomeIcon },
            { label: "Security Deposit", amount: "1-3 months", percent: "", icon: netTakeHomeIcon },
          ]
        },
        "Qatar": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organisation, and Agent of Record solutions.",
          description: "Best for: Hiring Qatari employees legally without setting up a legal entity.",
          items: [
            { label: "EOR/PEO Monthly Fee", amount: "QAR 800-QAR 1,500", percent: "8-12%", icon: grossSalaryIcon },
            { label: "Setup Fee", amount: "QAR 1,500-3,000(one-time)", percent: "", icon: federalTaxIcon },
            { label: "Social Security (Employee)", amount: "", percent: "5%", icon: stateTaxIcon },
            { label: "Social Security (Employer)", amount: "", percent: "10%", icon: ficaIcon },
            { label: "Health Insurance", amount: "QAR 150-500", percent: "", icon: netTakeHomeIcon },
            { label: "Work Permit/Visa", amount: "QAR 500-1,200", percent: "", icon: netTakeHomeIcon },
            { label: "End of Service Benefit", amount: "3 weeks per year", percent: "", icon: netTakeHomeIcon },
            { label: "Workers Compensation", amount: "QAR 50-200", percent: "", icon: netTakeHomeIcon },
            { label: "Termination/Offboarding", amount: "QAR 500-1,500 (one-time)", percent: "", icon: netTakeHomeIcon },
            { label: "Security Deposit", amount: "1-2 months", percent: "", icon: netTakeHomeIcon },
          ]
        },
        "Malaysia": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organisation, and Agent of Record solutions.",
          description: "Best for: Hiring Malaysian employees legally without setting up a legal entity.",
          items: [
            { label: "EOR/PEO Service Fee", amount: "$288-$800", percent: "~10-15%", icon: grossSalaryIcon },
            { label: "EPF Contribution(local employee)", amount: "QAR 1,500-3,000(one-time)", percent: "12%", icon: federalTaxIcon },
            { label: "EPF (foreign employees, from Oct 2025)", amount: "", percent: "2%", icon: stateTaxIcon },
            { label: "SOCSO(Employer)", amount: "", percent: "~1.75%", icon: ficaIcon },
            { label: "EIS (Employer)", amount: "QAR 150-500", percent: "~0.2%", icon: netTakeHomeIcon },
            { label: "Total Statutory(local)", amount: "QAR 500-1,200", percent: "~14-17%", icon: netTakeHomeIcon },
            { label: "Total Statutory(foreign, post Oct 2025)", amount: "", percent: "~7-8%", icon: netTakeHomeIcon },

          ]
        },
        "India": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organization, and Agent of Record solutions.",
          description: "Best for: Hiring Indian employees legally without setting up a legal entity.",
          items: [
            { label: "Setup Fee", amount: "₹10,000-₹25,000", percent: "10-15%", icon: grossSalaryIcon },
            { label: "Onboarding/Setup Fee", amount: "₹20,000-₹60,000 (one-time)", percent: "", icon: federalTaxIcon },
            { label: "PF (Provident Fund)", amount: "₹1,800 (of ₹30,000 salary)", percent: "12%", icon: stateTaxIcon },
            { label: "ESI (Health Insurance)", amount: "₹525 (of ₹21,000 salary)", percent: "3.25%", icon: ficaIcon },
            { label: "Professional Tax", amount: "₹200-₹2,500", percent: "", icon: netTakeHomeIcon },
            { label: "Gratuity", amount: "", percent: "4.81%", icon: netTakeHomeIcon },
            { label: "Workers Compensation", amount: "₹100-₹700", percent: "", icon: netTakeHomeIcon },
            { label: "State Insurance", amount: "₹200-₹800", percent: "", icon: netTakeHomeIcon },
            { label: "Health Insurance", amount: "₹500-₹2,500", percent: "", icon: netTakeHomeIcon },
            { label: "Other Deductions", amount: "Varies", percent: "", icon: netTakeHomeIcon },
            { label: "Termination/Off boarding", amount: "₹8,000-₹25,000(one-time)", percent: "", icon: netTakeHomeIcon },
            { label: "Security Deposit", amount: "1 to 2 months' salary (refundable)", percent: "", icon: netTakeHomeIcon },
          ]
        },
        "France": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organisation, and Agent of Record solutions.",
          description: "Best for: Hiring France employees without a local entity.",
          items: [
            { label: "Setup Fee", amount: "EUR 600-1,500", percent: "~10-15%", icon: grossSalaryIcon },
            { label: "Employer Social Security Contributions", amount: "", percent: "~40-45%", icon: federalTaxIcon },
            { label: "Employer Social Security Contributions", amount: "", percent: "~7%", icon: stateTaxIcon },
            { label: "Unemployment Insurance", amount: "", percent: "~4.0%", icon: ficaIcon },
            { label: "Accident-at-Work Contribution", amount: "", percent: "~0.17%", icon: netTakeHomeIcon },
            { label: "Total Employer Costs", amount: "", percent: "~50-55%", icon: netTakeHomeIcon },
          ]
        },
        "Canada": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organisation, and Agent of Record solutions",
          description: "Best for: Hiring Canadian  employees without a local entity.",
          items: [
            { label: "EOR/PEO Service Fee", amount: "USD 350-900", percent: "10-15%", icon: grossSalaryIcon },
            { label: "Onboarding/Setup Fee", amount: "Varies", percent: "", icon: federalTaxIcon },
            { label: "CPP Contribution(Employer)", amount: "", percent: "5.95%", icon: stateTaxIcon },
            { label: "EI Contribution(Employer)", amount: "", percent: "2.28%", icon: ficaIcon },
            { label: "Workers Compensation", amount: "Varies", percent: "1-3%", icon: netTakeHomeIcon },
            { label: "Health Tax/Premiums (ifapplicable)", amount: "Varies", percent: "", icon: netTakeHomeIcon },
            { label: "Total Statutory Contributions", amount: "", percent: "", icon: netTakeHomeIcon },
            { label: "Termination / Offboarding Fee", amount: "", percent: "", icon: netTakeHomeIcon },
            { label: "Security Deposit", amount: "", percent: "", icon: netTakeHomeIcon },
          ]
        },
        "Brazil": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organisation, and Agent of Record solutions.",
          description: "Best for: Hiring Brazilian employees without a local entity.",
          items: [
            { label: "EOR/PEO Fee", amount: "USD 40 to 800 (BRL 2,000 to 4,000)", percent: "8-12%", icon: grossSalaryIcon },
            { label: "INSS (Employee)", amount: "8 to 11% of salary", percent: "8-11%", icon: federalTaxIcon },
            { label: "INSS (Employer)", amount: "20% of salary", percent: "20%", icon: stateTaxIcon },
            { label: "FGTS", amount: "8% of salary", percent: "8%", icon: ficaIcon },
            { label: "13th Salary", amount: "1 month's salary/year", percent: "~8.33%", icon: netTakeHomeIcon },
            { label: "Vacation Pay", amount: "1 month + 1/3 bonus", percent: "~11%", icon: netTakeHomeIcon },
            { label: "Health Insurance", amount: "BRL 200 to 600", percent: "", icon: netTakeHomeIcon },
          ]
        },
        "Australia": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organisation, and Agent of Record solutions.",
          description: "Best for: Hiring Australian employees without a local entity.",
          items: [
            { label: "EOR/PEO Service Fee", amount: "AU$300-$900", percent: "10-16%", icon: grossSalaryIcon },
            { label: "Onboarding/Setup Fee", amount: "AU$800-$2,500(one-time)", percent: "", icon: federalTaxIcon },
            { label: "Superannuation", amount: "", percent: "11.5%", icon: stateTaxIcon },
            { label: "Payroll Tax", amount: "", percent: "4.75-6.85%", icon: ficaIcon },
            { label: "WorkCover/Workers Comp", amount: "AU$40-$200", percent: "", icon: netTakeHomeIcon },
            { label: "State Payroll Levies", amount: "AU$10-$50", percent: "0.2-1%", icon: netTakeHomeIcon },
            { label: "Health Insurance", amount: "Varies", percent: "", icon: netTakeHomeIcon },
            { label: "Other Deductions", amount: "Varies", percent: "", icon: netTakeHomeIcon },
            { label: "Termination/Offboard", amount: "AU$350-$1,000", percent: "", icon: netTakeHomeIcon },
            { label: "Ding Fee", amount: "(one-time)", percent: "", icon: netTakeHomeIcon },
            { label: "Security Deposit", amount: "1-3 months", percent: "", icon: netTakeHomeIcon },
          ]
        },
        "Argentina": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organisation, and Agent of Record solutions.",
          description: "Best for: Hiring Argentine employees without a local entity.",
          items: [
            { label: "EOR/PEO Service Fee", amount: "ARS 179 - ARS 599", percent: "10-15%", icon: grossSalaryIcon },
            { label: "Onboarding/Setup Fee", amount: "Varies, often included", percent: "", icon: federalTaxIcon },
            { label: "Social Security (Employer)", amount: "", percent: "24%-26.4% ", icon: stateTaxIcon },
            { label: "Workers’ Compensation (ART)", amount: "", percent: "2-4%", icon: netTakeHomeIcon },
            { label: "Termination / Offboarding Fee", amount: "Varies", percent: "", icon: netTakeHomeIcon },
            { label: "Security Deposit", amount: "Sometimes required", percent: "", icon: netTakeHomeIcon },
          ]
        },
        "Chile": {
          title: "EOR/PEO/AOR Services",
          subtitle: "Employer of Record, Professional Employer Organisation, and Agent of Record solutions.",
          description: "Best for: Hiring Chilean employees without a local entity.",
          items: [
            { label: "EOR/PEO Service Fee", amount: "CLP 350 - CLP 900", percent: "10-15%", icon: grossSalaryIcon },
            { label: "Onboarding/Setup Fee", amount: "Varies, often included", percent: "", icon: federalTaxIcon },
            { label: "Pension (AFP) Employer Contribution", amount: "", percent: "2.3%", icon: stateTaxIcon },
            { label: "Unemployment Insurance (Employer)", amount: "", percent: "2.4", icon: netTakeHomeIcon },
            { label: "Work Accident Insurance", amount: "", percent: "Avg. 1-3%", icon: netTakeHomeIcon },
            { label: "Health Insurance (FONASA/ISAPRE)", amount: "Collected from employee salary (7%)", percent: "", icon: netTakeHomeIcon },
            { label: "Total Statutory Contributions", amount: "", percent: "6-8%", icon: netTakeHomeIcon },
            { label: "Termination/Offboard", amount: "Varies, provider-dependent", percent: "", icon: netTakeHomeIcon },
            { label: "Security Deposit", amount: "Sometimes required", percent: "", icon: netTakeHomeIcon },
          ]
        },
      }
    },

    "Incorporation/Entity Setup": {
      breakdown: {
        "United States": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: Startups (VC-backed) or SMEs seeking tax flexibility.",
          items: [
            { label: "Pick the Right Entity", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Choose Your State Wisely", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Name & Registered Agent", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "File Core Documents", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Draft Agreements", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Get an EIN", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Register for Taxes, Permits & Licenses", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Set Up a Bank Account", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Annual Compliance", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },

          ]
        },
        "UAE": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: VC-backed startups and SMEs seeking credibility, liability protection, and tax flexibility in the UAE.",
          items: [
            { label: "Pick the Right Entity", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Reserve a Name", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Appoint Shareholders & Local Agent", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "File Incorporation Documents", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Get Trade Licence & Registration", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Register for Taxes & Authorities", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Open Bank Account", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Maintain Annual Compliance", amount: "$50-600", percent: "", icon: federalTaxIcon },
          ]
        },
        "Singapore": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: Startups (VC-backed) or SMEs seeking tax flexibility.",
          items: [
            { label: "Pick the Right Entity", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Select Company Name", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Appoint Director(s)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Appoint Secretary", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Set Paid-Up Capital", amount: "Minimum SG$1", percent: "", icon: grossSalaryIcon },
            { label: "Register a Local Address", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Prepare and Submit Documents", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Obtain UEN", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Qatar": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: Startups (VC-backed) or SMEs seeking tax flexibility.",
          items: [
            { label: "Pick the Right Entity", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Choose Location", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Name Reservation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Local Partner/Agent", amount: "", percent: "", icon: federalTaxIcon },
            { label: "File Documents", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Capital Requirements", amount: "Minimum QAR 200,000", percent: "", icon: federalTaxIcon },
            { label: "Trade License", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Bank Account Setup", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Compliance", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Malaysia": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: Startups (VC-backed) or SMEs seeking tax flexibility.",
          items: [
            { label: "Pick the Right Entity", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Reserve a Name", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Appoint Directors & Secretary", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "File Incorporation Documents", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Get the Certificate of Incorporation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Register for Taxes & Other Legalities", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Open a Bank Account", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Maintain Annual Compliance", amount: "", percent: "", icon: federalTaxIcon },

          ]
        },
        "India": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: Startups (VC-backed) or SMEs seeking tax flexibility.",
          items: [
            { label: "Pick the Right Entity", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Choose Your State", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Name & Registered Agent", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "File Core Documents", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Draft Agreements", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Get PAN & TAN", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Register for Taxes, Permits", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Set Up a Bank Account", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Compliance", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "France": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: Startups (VC-backed) or SMEs seeking tax flexibility.",
          items: [
            { label: "Pick the Right Entity", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Choose Your Location", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Name & Registered Agent", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "File Core Documents", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Draft Agreements", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Get Tax Numbers", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Register for Taxes, Permits", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Set Up a Bank Account", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Compliance", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Canada": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: Startups (VC-backed) or SMEs seeking tax flexibility.",
          items: [
            { label: "Pick the Right Entity", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Name Search & Reservation", amount: "CAD 13 to 75", percent: "", icon: federalTaxIcon },
            { label: "Appoint Directors", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "File Incorporation Documents", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Get Certificate of Incorporation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Register for Taxes", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Open a Bank Account", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Maintain Annual Compliance", amount: "", percent: "", icon: federalTaxIcon },

          ]
        },
        "Brazil": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: Startups (VC-backed) or SMEs seeking tax flexibility.",
          items: [
            { label: "Pick the Right Entity", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Choose Location", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Name Reservation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "CNPJ Registration", amount: "", percent: "", icon: federalTaxIcon },
            { label: "File Documents", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Capital Requirements", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Municipal License", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Bank Account Setup", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Compliance", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },

        "Australia": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and company structure services.",
          description: "Best for: Startups (VC-backed) or SMEs seeking tax flexibility.",
          items: [
            { label: "Pick the Right Entity", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Choose Your State/Territory", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Name & Registered Office", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "File Core Documents", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Draft Agreements", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Get an ABN & TFN", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Register for GST & PAYG", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Set Up a Bank Account", amount: "", percent: "", icon: federalTaxIcon },

            { label: "Annual Compliance", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Argentina": {
          title: "Incorporation/Entity Setup",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: Startups (VC-backed) or SMEs seeking tax flexibility.",
          items: [
            { label: "Pick the Right Entity : Most businesses choose a Sociedad Anónima (SA) o Sociedad de Responsabilidad Limitada (SRL) for limited liability.  ", amount: "", percent: "1", icon: grossSalaryIcon },
            { label: "Name Reservation : Register and reserve the company name with the Public Registry.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Appoint Director : Board of Directors must include at least one Argentina-resident member.", amount: "", percent: " ", icon: stateTaxIcon },
            { label: "File Incorporation Documents : Submit Articles of Incorporation and capital deposit (min. ARS 100,000 ≈ USD 200).", amount: "", percent: "", icon: netTakeHomeIcon },
            { label: "Get Certificate of Incorporation : Issued after approval,  usually within 7 to 15 business days.", amount: "", percent: "", icon: netTakeHomeIcon },
            { label: "Register for taxes : Obtain a CUIT (tax ID) from AFIP and register for VAT, payroll, and corporate tax.", amount: "", percent: "", icon: netTakeHomeIcon },
            { label: "Open a Bank Account : Provide incorporation certificate, bylaws, and shareholder documents.", amount: "", percent: "", icon: netTakeHomeIcon },
            { label: "Maintain Annual Compliance : File annual returns, maintain corporate books, and submit tax filings.", amount: "", percent: "", icon: netTakeHomeIcon },
          ]
        },
      }
    },
    "Staffing/Talent Acquisition": {
      breakdown: {
        "United States": {
          title: "Staffing/Talent Acquisition",
          subtitle: "Recruitment, talent sourcing, and workforce solutions.",
          description: "Best for: Scaling teams quickly with compliant hiring.",
          items: [
            { label: "Define Roles", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Hire for Fit", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Smart Sourcing", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Stay Compliant", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Fair Compensation", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Protect Data", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Train & Develop", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Track Compliance", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },

          ]
        },
        "UAE": {
          title: "Staffing/Talent Acquisition",
          subtitle: "Recruitment, talent sourcing, and workforce solutions.",
          description: "Best for: Quickly growing your team while staying fully compliant with UAE laws.",
          items: [
            { label: "Define roles", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Hire for fit", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Smart Sourcing", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Ensure Compliance", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Fair Compensation", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Protect Data", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Train & Develop", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Track Compliance", amount: "$50-600", percent: "", icon: federalTaxIcon },
          ]
        },
        "Singapore": {
          title: "Staffing/Talent Acquisition",
          subtitle: "Recruitment, talent sourcing, and workforce solutions.",
          description: "Best for: Scaling teams quickly with compliant hiring.",
          items: [
            { label: "Define Roles", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Hire for Fit", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Smart Sourcing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Stay Compliant", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Fair Compensation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Protect Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Train & Develop", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Track Compliance", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Qatar": {
          title: "Staffing/Talent Acquisition",
          subtitle: "Business entity formation and corporate structuring services.",
          description: "Best for: Startups (VC-backed) seeking foreign investment or SMEs looking to establish a presence in Qatar.",
          items: [
            { label: "Define Roles", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Qatarisation Compliance", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Recruitment Sources", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Visa & Work Permits", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Employment Contracts", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Salary Benchmarking", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Background Checks", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding Process", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Probation Management", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Malaysia": {
          title: "Staffing/Talent Acquisition",
          subtitle: "Recruitment, talent sourcing, and workforce solutions.",
          description: "Best for: Scaling teams quickly with compliant hiring.",
          items: [
            { label: "Define Roles", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Hire for fit", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Smart sourcing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Stay compliant", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Fair compensation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll and benefits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Protect data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Train and develop", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Track compliance", amount: "", percent: "", icon: federalTaxIcon },

          ]
        },
        "India": {
          title: "Staffing/Talent Acquisition",
          subtitle: "Recruitment, talent sourcing, and workforce solutions.",
          description: "Best for: Scaling teams quickly with compliant hiring.",
          items: [
            { label: "Define Roles", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Hire for Fit", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Smart Sourcing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Stay Compliant", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Fair Compensation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Protect Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Train & Develop", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Track Compliance", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "France": {
          title: "Staffing/Talent Acquisition",
          subtitle: "Recruitment, talent sourcing, and workforce solutions.",
          description: "Best for:Scaling teams quickly with compliant hiring.",
          items: [
            { label: "Define Roles", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Hire for Fit", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Smart Sourcing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Stay Compliant", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Fair Compensation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Protect Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Train & Develop", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Track Compliance", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Canada": {
          title: "Staffing/Talent Acquisition",
          subtitle: "Recruitment, talent sourcing, and workforce solutions.",
          description: "Best for: Scaling teams quickly with compliant hiring.",
          items: [
            { label: "Define Roles", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Hire for Fit", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Smart Sourcing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Stay Compliant", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Fair Compensation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll and Benefits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Protect Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Train and Develop", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Track Compliance", amount: "", percent: "", icon: federalTaxIcon },

          ]
        },
        "Brazil": {
          title: "Staffing/Talent Acquisition",
          subtitle: "Recruitment, talent sourcing, and workforce solutions.",
          description: "Best for: Scaling teams quickly with compliant hiring.",
          items: [
            { label: "Define Roles", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Legal Compliance", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Recruitment Sources", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Work Permits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Employment Contracts", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Salary Benchmarking", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Background Checks", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding Process", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Probation Management", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },

        "Australia": {
          title: "Staffing/Talent Acquisition ",
          subtitle: "Recruitment, talent sourcing, and workforce solutions.",
          description: "Best for: Scaling teams quickly with compliant hiring.",
          items: [
            { label: "Define Roles", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Hire for Fit", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Smart Sourcing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Stay Compliant", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Fair Compensation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Protect Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Train & Develop", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Track Compliance", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Argentina": {
          title: "Staffing/Talent Acquisition ",
          subtitle: "Recruitment, talent sourcing, and workforce solutions.",
          description: "Best for: Scaling teams quickly with compliant hiring.",
          items: [
            { label: "Define Roles : Draft clear job descriptions aligned with Argentine market standards.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Hire for Fit : Focus on diversity and cultural alignment — Argentina is highly multicultural.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Smart Sourcing : Use platforms like Bumeran, Zonajobs, LinkedIn, or local agencies.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Stay Compliant : Provide written contracts (in Spanish) and register employees with AFIP.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Fair Compensation : Meet or exceed the minimum wage (ARS 308,200/month as of May 2025).", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits : Include social security, ART, vacation, sick leave, and statutory holidays.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Protect Data : Comply with Ley 25.326 on data privacy.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Train & Develop : Offer safety and compliance training required by labor laws.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Track Compliance : Maintain records for 10 years and follow collective bargaining updates.", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        }
      }
    },

    "Global Payroll": {
      breakdown: {
        "United States": {
          title: "Global Payroll",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "Social Security (FICA)", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Medicare (FICA)", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "Additional Medicare", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },
            { label: "Federal Income Tax", amount: "$50-600", percent: "", icon: federalTaxIcon },
            { label: "State Income Tax", amount: "$500-2,000", percent: "", icon: grossSalaryIcon },


          ]
        },
        "UAE": {
          title: "Global Payroll",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "Social Security (Emiratis)", amount: "", percent: "5%", icon: grossSalaryIcon },
            { label: "DEWS / End-of-Service Plan", amount: "", percent: "5.83%-8.33%", icon: federalTaxIcon },
            { label: "Unemployment Insurance", amount: "AED 5 to 10 per month", percent: "", icon: grossSalaryIcon },
          ]
        },
        "Singapore": {
          title: "Global Payroll",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "CPF (Central Provident Fund)", amount: "up to SG$1,258/month", percent: "20%", icon: grossSalaryIcon },
            { label: "Skill Development Levy (SDL)", amount: "SG$2 to $12/month", percent: "", icon: federalTaxIcon },
            { label: "SRS (Supplementary Retirement Scheme)", amount: "SG$35,700 cap", percent: "Up to 15%", icon: grossSalaryIcon },
            { label: "Income Tax", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Insurance (Foreigners)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Other levies", amount: "", percent: "", icon: federalTaxIcon },

          ]
        },
        "Qatar": {
          title: "Global Payroll",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "Social Security", amount: "", percent: "5%", icon: grossSalaryIcon },
            { label: "Income Tax", amount: "", percent: "0%", icon: federalTaxIcon },
            { label: "Health Insurance", amount: "QAR 150-500/month", percent: "", icon: grossSalaryIcon },
            { label: "End of Service Benefit", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Other Benefits", amount: "Varies", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Malaysia": {
          title: "Global Payroll",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "EPF (Retirement Savings)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Foreign employees: 2% from Q4 2025", amount: "", percent: "", icon: federalTaxIcon },
            { label: "SOCSO (Social Security)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "EIS (Unemployment Insurance)", amount: "", percent: "", icon: federalTaxIcon },
            { label: "HRDF (Training Levy)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "EPF (Retirement Savings)", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Foreign employees: 2% from Q4 2025", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "India": {
          title: "Global Payroll",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "Provident Fund (PF)", amount: "", percent: "12%", icon: grossSalaryIcon },
            { label: "ESI (Health Ins.)", amount: "", percent: "3.25%", icon: federalTaxIcon },
            { label: "Professional Tax", amount: "₹200-₹2,500/month", percent: "", icon: grossSalaryIcon },
            { label: "Income Tax", amount: "Based on slabs", percent: "", icon: federalTaxIcon },
            { label: "Gratuity", amount: "", percent: "4.81%", icon: grossSalaryIcon },
            { label: "Bonus", amount: "", percent: "8.33%", icon: federalTaxIcon },
            { label: "Other Benefits", amount: "Varies", percent: "Varies", icon: grossSalaryIcon },

          ]
        },
        "France": {
          title: "Global Payroll",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "Health Insurance (Assurance Maladie)", amount: "", percent: "~13%", icon: grossSalaryIcon },
            { label: "Pension (Retraite)", amount: "$50-600", percent: "~15%", icon: federalTaxIcon },
            { label: "Unemployment Insurance", amount: "$500-2,000", percent: "~4.0%", icon: grossSalaryIcon },
            { label: "Family Allowance", amount: "$50-600", percent: "~5.25%", icon: federalTaxIcon },
            { label: "Accident-at-Work", amount: "$500-2,000", percent: "~0.17%", icon: grossSalaryIcon },
            { label: "Other Social Charges", amount: "Varies", percent: "Varies", icon: federalTaxIcon },

          ]
        },
        "Canada": {
          title: "Global Payroll",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "CPP (Canada Pension Plan)", amount: "", percent: "5.95%", icon: grossSalaryIcon },
            { label: "EI (Employment Insurance)", amount: "", percent: "2.28%", icon: federalTaxIcon },
            { label: "Workers Compensation", amount: "", percent: "1-3%", icon: grossSalaryIcon },
            { label: "Provincial Health Taxes (if applicable)", amount: "Varies", percent: "", icon: federalTaxIcon },
            { label: "Income Tax Withholding", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Brazil": {
          title: "Global Payroll",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "INSS (Social Security)", amount: "8-11%", percent: "20%", icon: grossSalaryIcon },
            { label: "Income Tax (IRRF)", amount: "0-27.5%", percent: "", icon: federalTaxIcon },
            { label: "FGTS", amount: "", percent: "8%", icon: grossSalaryIcon },
            { label: "13th Salary", amount: "", percent: "~8.33%", icon: federalTaxIcon },
            { label: "Vacation + 1/3", amount: "", percent: "~11%", icon: grossSalaryIcon },
            { label: "Other Benefits", amount: "Varies", percent: "", icon: federalTaxIcon },

          ]
        },

        "Australia": {
          title: "Global Payroll ",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "Superannuation", amount: "NA", percent: "11%", icon: grossSalaryIcon },
            { label: "Income Tax (PAYG)", amount: "Based on ATO tax tables", percent: "", icon: federalTaxIcon },
            { label: "Medicare Levy", amount: "", percent: "2%", icon: grossSalaryIcon },
            { label: "Payroll Tax", amount: "", percent: "4.75-6.85%", icon: federalTaxIcon },
            { label: "WorkCover/Workers’ Comp", amount: "", percent: "0.5-2%", icon: grossSalaryIcon },
            { label: "Trade Union Fees", amount: "Varies", percent: "", icon: federalTaxIcon },


          ]
        },
        "Argentina": {
          title: "Global Payroll ",
          subtitle: "End-to-end payroll processing, compliance, and employee benefits management.",
          description: "Best for: Multi-jurisdiction payroll processing and compliance.",
          items: [
            { label: "Social Security", amount: "", percent: "~24-26.4% ", icon: grossSalaryIcon },
            { label: "ART Insurance", amount: "", percent: "2-4%", icon: federalTaxIcon },
            { label: "Income Tax Withholding", amount: "", percent: "N/A", icon: grossSalaryIcon },
            { label: "Union Contribution", amount: "", percent: "2-4%", icon: federalTaxIcon },

          ]
        }
      }
    },

    "HRIS (Human Resources Information System)": {
      breakdown: {
        "United States": {
          title: "HRIS (Human Resources Information System)",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: HR technology platforms and workforce management systems.",
          items: [
            { label: "Centralised Employee Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits Automation", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time & Attendance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding and Offboarding", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee Self-Service Portals", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Advanced Reporting & Analytics", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "UAE": {
          title: "HRIS (Human Resources Information System)",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: Digitising HR operations with a unified system managing workforce data, compliance, payroll, and employee engagement.",
          items: [
            { label: "Centralised employee data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll automation & compliance", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time & attendance management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding & offboarding", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee self-service portal", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Reporting & analytics", amount: "", percent: "", icon: grossSalaryIcon },
          ]
        },
        "Singapore": {
          title: "HRIS (Human Resources Information System)",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: HR technology platforms and workforce management systems",
          items: [
            { label: "Centralised Employee Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits Automation", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time & Attendance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding and Offboarding", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee Self-Service Portals", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Advanced Reporting & Analytics", amount: "", percent: "", icon: federalTaxIcon },


          ]
        },
        "Qatar": {
          title: "HRIS (Human Resources Information System)",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: HR technology platforms and workforce management systems.",
          items: [
            { label: "Centralised Employee Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits Automation", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time & Attendance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding/Offboarding", amount: "", percent: "", icon: federalTaxIcon },
            { label: "WPS Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee Self-Service", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Arabic Language Support", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Malaysia": {
          title: "HRIS (Human Resources Information System)",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: HR technology platforms and workforce management systems.",
          items: [
            { label: "Centralised employee data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll and benefits automation", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time and attendance management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding and offboarding", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Regulator compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee self-service portal", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Advanced reporting and Analytics", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "India": {
          title: "HRIS (Human Resources Information System)",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: HR technology platforms and workforce management systems.",
          items: [
            { label: "Centralised Employee Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits Automation", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time & Attendance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding/Offboarding", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee Self-Service Portals", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Advanced Reporting & Analytics", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "France": {
          title: "HRIS (Human Resources Information System)",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: HR technology platforms and workforce management systems.",
          items: [
            { label: "Centralised Employee Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits Automation", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time & Attendance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding/Offboarding", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee Self-Service Portals", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Advanced Reporting & Analytics", amount: "", percent: "", icon: federalTaxIcon },

          ]
        },
        "Canada": {
          title: "HRIS (Human Resources Information System)",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: HR technology platforms and workforce management systems.",
          items: [
            { label: "Centralised employee data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll and benefits automation", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time and attendance management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding and offboarding", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Regulatory compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee self-service portal", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Advanced reporting and analytics", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Brazil": {
          title: "HRIS (Human Resources Information System)",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: HR technology platforms and workforce management systems.",
          items: [
            { label: "Centralised Employee Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits Automation", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time & Attendance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding/Offboarding", amount: "", percent: "", icon: federalTaxIcon },
            { label: "eSocial Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee Self-Service", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Portuguese Language Support", amount: "", percent: "", icon: federalTaxIcon },

          ]
        },

        "Australia": {
          title: "HRIS (Human Resources Information System) ",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: HR technology platforms and workforce management systems.",
          items: [
            { label: "Centralised Employee Data", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits Automation", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time & Attendance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding and Offboarding", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee Self-Service Portals", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Advanced Reporting & Analytics", amount: "", percent: "", icon: federalTaxIcon },


          ]
        },
        "Argentina": {
          title: "HRIS (Human Resources Information System) ",
          subtitle: "Modernizing HR operations with integrated platforms that manage workforce data, compliance, payroll, and employee experience",
          description: "Best for: HR technology platforms and workforce management systems.",
          items: [
            { label: "Centralised Employee Data : Stores employee records, CUIT, tax forms, contracts, and performance history, ensuring compliance with AFIP and Argentina’s Data Protection Law (Law 25.326).", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Benefits Automation : Automates payroll, social security (pension, healthcare), income tax deductions, and union contributions; integrates with benefits management.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Time & Attendance Management: Tracks hours, shifts, overtime, and vacation accruals while complying with Argentina’s labor standards.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Onboarding and Offboarding : Digitizes hiring workflows, tax registrations, and ensures compliant termination processes, including severance calculations.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Regulatory Compliance : Updates automatically with changes in labor codes, social security rates, and reporting obligations.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee Self-Service Portals : Allows employees to access payslips, tax certificates, vacation balances, and benefits details.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Advanced Reporting & Analytics : Generates payroll, tax, turnover, and compliance reports to support HR decision-making.", amount: "", percent: "", icon: federalTaxIcon },
          ]
        }
      }
    },

    "Accounting Services": {
      breakdown: {
        "United States": {
          title: "Accounting Services",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for: Financial reporting, bookkeeping, and accounting compliance.",
          items: [
            { label: "Bookkeeping", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Tax Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Integration", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Invoice & Payment Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Trail", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Budgeting & Forecasting", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integrations", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "UAE": {
          title: "Accounting Services",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for: Financial reporting, bookkeeping, and statutory compliance in the UAE.",
          items: [
            { label: "Bookkeeping", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Tax Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Invoice & Payment Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Trail", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Budgeting & Forecasting", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integrations", amount: "", percent: "", icon: grossSalaryIcon },
          ]
        },
        "Singapore": {
          title: "Accounting Services",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for: HR technology platforms and workforce management systems",
          items: [
            { label: "Bookkeeping", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Tax Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Invoice & Payment Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Trail", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Budgeting & Forecasting", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integrations", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Qatar": {
          title: "Accounting Services",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for: Financial reporting, bookkeeping, and accounting compliance.",
          items: [
            { label: "Bookkeeping", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Tax Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Social Security Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Invoice Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Arabic Documentation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Banking Integration", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Malaysia": {
          title: "Accounting Services",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for: Financial reporting, bookkeeping, and accounting compliance.",
          items: [
            { label: "Bookkeeping", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Tax Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Invoice & Payment Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Trail", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Budgeting & Forecasting", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integrations", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "India": {
          title: "Accounting Services",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for: Financial reporting, bookkeeping, and accounting compliance.",
          items: [
            { label: "Bookkeeping", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Tax Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Invoice  Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Trail", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Budgeting & Forecasting", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integrations", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "France": {
          title: "Accounting Services",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for: Financial reporting, bookkeeping, and accounting compliance.",
          items: [
            { label: "Bookkeeping", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting", amount: "", percent: "", icon: federalTaxIcon },
            { label: "VAT & Indirect Taxes", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Invoice  Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Trail", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Budgeting & Forecasting", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Banking Integration", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Canada": {
          title: "Accounting Services",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for:  Financial reporting, bookkeeping, and accounting compliance.",
          items: [
            { label: "Bookkeeping", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Tax Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Invoice & Payment Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Trail", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Budgeting & Forecasting", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integrations", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Brazil": {
          title: "Accounting Services",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for: Financial reporting, bookkeeping, and accounting compliance.",
          items: [
            { label: "Bookkeeping", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Tax Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Invoice  Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Trail", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Portuguese Documentation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Banking Integration", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },

        "Australia": {
          title: "Accounting Services ",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for:  Financial reporting, bookkeeping, and accounting compliance.",
          items: [
            { label: "Bookkeeping", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting", amount: "", percent: "", icon: federalTaxIcon },
            { label: "BAS & Tax Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Invoice & Payment Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Trail", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Budgeting & Forecasting", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integrations", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Argentina": {
          title: "Accounting Services ",
          subtitle: "Complete accounting services from bookkeeping to budgeting and forecasting",
          description: "Best for:  Financial reporting, bookkeeping, and accounting compliance.",
          items: [
            { label: "Bookkeeping : Tracks income, expenses, and invoices; complies with Argentine GAAP or IFRS standards.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Reporting : Prepares Profit & Loss (P&L), balance sheet, and cash flow statements per local regulations.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Tax Compliance : Handles VAT (IVA), corporate income tax, payroll remittances, and annual returns with AFIP and provincial authorities.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Integration : Syncs with payroll systems to ensure accurate social security, ART, and tax reporting.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Invoice & Payment Management : Issues electronic invoices (Factura Electrónica), manages supplier payments, and monitors receivables/payables.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Trail : Maintains accurate financial records for CRA and AFIP audits.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Budgeting & Forecasting : Provides cash flow projections and forecasts to improve financial decisions.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integrations : Connects with HRIS, banking systems, CRMs, and accounting tools like Contabilium, QuickBooks, Xero, or Tango Gestión.", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        }
      }
    },

    "Tax Services": {
      breakdown: {
        "United States": {
          title: "Tax Services",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Tax compliance, planning, and optimisation strategies.",
          items: [
            { label: "Tax Preparation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Filing", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Deduction Optimization e", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Estimated Payments", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Sales & Franchise Tax", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Audit Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "UAE": {
          title: "Tax Services",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Managing tax compliance, strategic planning, and optimising liabilities in the UAE.",
          items: [
            { label: "Corporate Tax Registration & Filing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Transfer Pricing & TP", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Documentation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit & Record Maintenance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Qualifying Free Zone Person (QFZP) Advisory", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Domestic Minimum Top-up Tax (DMTT)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Advisory & Strategy", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Residency Certificates & Compliance Reviews", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Corporate Tax Registration & Filing", amount: "", percent: "", icon: grossSalaryIcon },
          ]
        },
        "Singapore": {
          title: "Tax Services",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Tax compliance, planning, and optimisation strategies",
          items: [
            { label: "Tax Preparation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Filing", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Deduction Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Estimated Payments", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "GST Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Qatar": {
          title: "Tax Services",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Tax compliance, planning, and optimisation strategies.",
          items: [
            { label: "Corporate Tax Preparation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Filing", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Withholding Tax Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Transfer Pricing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Double Tax Treaty Benefits", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Zakat Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Free Zone Incentives", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Malaysia": {
          title: "Tax Services",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Tax compliance, planning, and optimisation strategies.",
          items: [
            { label: "Tax Preparation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Filing", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Deduction Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Estimated Payments", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Sales & Service Tax (SST)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "India": {
          title: "Tax Services",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Tax compliance, planning, and optimization strategies.",
          items: [
            { label: "Tax Preparation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Filing", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Deduction Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Estimated Payments", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "GST/Franchise Tax", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "France": {
          title: "Tax Services",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Tax compliance, planning, and optimisation strategies.",
          items: [
            { label: "Tax Preparation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Filing", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Deduction Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Estimated Payments", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "VAT Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Canada": {
          title: "Tax Services",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Tax compliance, planning, and optimisation strategies.",
          items: [
            { label: "Tax Preparation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Filing", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Deduction Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Estimated Payments", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "GST/HST & PST/QST", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Brazil": {
          title: "Tax Services",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Tax compliance, planning, and optimisation strategies.",
          items: [
            { label: "Corporate Tax (IRPJ)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Social Contribution (CSLL)", amount: "", percent: "", icon: federalTaxIcon },
            { label: "PIS/COFINS", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "ICMS (State VAT)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Withholding Tax", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Transfer Pricing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Treaties", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Simples Nacional", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },

        "Australia": {
          title: "Tax Services ",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Tax compliance, planning, and optimisation strategies.",
          items: [
            { label: "Tax Preparation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Filing", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Deduction Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Estimated Payments", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "GST & State Levies", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Argentina": {
          title: "Tax Services ",
          subtitle: "International tax and compliance services including preparation and filing.",
          description: "Best for: Tax compliance, planning, and optimisation strategies.",
          items: [
            { label: "Tax Preparation : Gathers financial data and prepares corporate income tax returns (Impuesto a las Ganancias), VAT, and other filings in line with AFIP regulations.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Filing : Submits returns electronically via AFIP’s online platform or authorized software.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Deduction Optimization : Identifies deductions and credits (e.g., R&D, innovation incentives) to reduce taxable income.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Estimated Payments : Calculates and schedules advance tax payments to avoid interest or penalties.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Monitoring : Tracks tax law changes and updates to stay compliant with federal and provincial requirements.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Support : Prepares documentation and provides assistance during AFIP audits or provincial inspections.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax : Handles withholding, transfer pricing, and tax treaty planning for cross-border operations.", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
      }
    },

    "Compliance Services": {
      breakdown: {
        "United States": {
          title: "Compliance Services",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Licensing & Permits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Filings & Reports", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Policy & Procedure Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee & Payroll Compliance", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Data Security & Privacy", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Training & Certification", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation & Support", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "UAE": {
          title: "Compliance Services",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for: Navigating regulatory requirements, labour laws, and risk management in the UAE.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Licensing & Permits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Documentation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Annual Filings & Reports", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Policy & Procedure Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee & Payroll Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Security & Privacy", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Training & Certification", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation & Support", amount: "", percent: "", icon: grossSalaryIcon },
          ]
        },
        "Singapore": {
          title: "Compliance Services",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Licensing & Permits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Filings & Reports", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Policy & Procedure Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee & Payroll Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Security & Privacy", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Training & Certification", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation & Support", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Qatar": {
          title: "Compliance Services",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for:Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "WPS Compliance", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Labour Law Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Social Security Filing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Immigration Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Arabic Documentation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Industry-Specific Licenses", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Readiness", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Malaysia": {
          title: "Compliance Services",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Licensing & Permits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Filings & Reports", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Policy & Procedure Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee & Payroll Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Security & Privacy", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Training & Certification", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation & Support", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "India": {
          title: "Compliance Services",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for: Regulatory compliance, labor law adherence, and risk management.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Licensing & Permits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Filings & Reports", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Policy & Procedure Updatesx", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Security & Privacy", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Training & Certification", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation & Support", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "France": {
          title: "Compliance Services",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Labour Law Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Payroll & Social Security Filing", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Corporate Governance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "GDPR & Data Protection ", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Licensing & Permits", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Policy Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Canada": {
          title: "Compliance Services",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Licensing & Permits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Filings & Reports", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Policy & Procedure Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee & Payroll Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Security & Privacy", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Training & Certification", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation & Support", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Brazil": {
          title: "Compliance Services",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "eSocial Compliance", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Labour Law Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Immigration Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Environmental Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Industry Licenses", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Protection", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Readiness", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },

        "Australia": {
          title: "Compliance Services ",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Licensing & Permits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Filings & Reports", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Policy & Procedure Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee & Payroll Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Security & Privacy", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Training & Certification", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation & Support", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Argentina": {
          title: "Compliance Services ",
          subtitle: "Compliance functions that helps navigate federal regulations, employment standards, and risk management.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Registration : Registers the company with the Public Registry, obtains CUIT, and opens tax accounts with AFIP.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Licensing & Permits : Secures industry-specific permits (e.g., import/export, food, construction, healthcare) and municipal business licenses.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Filings & Reports : Submits annual returns, corporate tax filings, and renewal applications to maintain good standing.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Monitoring : Tracks updates from AFIP, Ministry of Labor, and provincial agencies.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Policy & Procedure Updates : Ensures internal policies align with labor codes, union agreements, and privacy regulations.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee & Payroll Compliance : Ensures proper classification, correct deductions, and adherence to labor standards.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Security & Privacy : Implements policies to comply with Argentina’s Personal Data Protection Law.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Training & Certification", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation & Support : Offers mandatory training (workplace safety, anti-harassment, AML, privacy compliance.", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
      }
    }, 

    "M&A Services": {
      breakdown: {
        "United States": {
          title: "M&A Services",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Licensing & Permits", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Annual Filings & Reports", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Policy & Procedure Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Employee & Payroll Compliance", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Data Security & Privacy", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Training & Certification", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Preparation & Support", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "UAE": {
          title: "M&A Services",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for:  Mergers, acquisitions, and corporate transaction support.",
          items: [
            { label: "Strategy & Target Search", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Due Diligence", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Valuation & Deal Structuring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Negotiation Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financing & Tax Planning", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Post-Closing Services", amount: "", percent: "", icon: grossSalaryIcon },
          ]
        },
        "Singapore": {
          title: "M&A Services",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for: Mergers, acquisitions, and corporate transaction support.",
          items: [
            { label: "Strategy & Target Search", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Due Diligence ", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Valuation & Deal Structuring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Negotiation Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financing & Tax Planning", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Post-Closing Services", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Qatar": {
          title: "M&A Services",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "WPS Compliance", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Labour Law Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Social Security Filing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Immigration Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Arabic Documentation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Industry-Specific Licenses", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Readiness", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Malaysia": {
          title: "M&A Services",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for: Mergers, acquisitions, and corporate transaction support.",
          items: [
            { label: "Strategy & Target Search", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Due Diligence", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Valuation & Deal Structuring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Negotiation Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financing & Tax Planning", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Post-Closing Services", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "India": {
          title: "M&A Services",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for: Mergers, acquisitions, and corporate transaction support.",
          items: [
            { label: "Strategy & Target Search", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Due Diligence", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Valuation & Deal Structuring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Negotiation Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financing & Tax Planning", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Post-Closing Services", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "France": {
          title: "M&A Services",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for: Mergers, acquisitions, and corporate transaction support.",
          items: [
            { label: "Strategy & Target Search", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financial Due Diligence", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Legal Due Diligence", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Valuation & Deal Structuring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Negotiation Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Post-Merger Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Planning", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Canada": {
          title: "M&A Services",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for: Mergers, acquisitions, and corporate transaction support.",
          items: [
            { label: "Strategy & Target Search", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Due Diligence", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Valuation & Deal Structuring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Negotiation Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financing & Tax Planning", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Post-Closing Services", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Brazil": {
          title: "M&A Services",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for: Mergers, acquisitions, and corporate transaction support.",
          items: [
            { label: "Strategy & Target Search", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Due Diligence", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Regulatory Approvals", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Valuation & Structuring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Labor Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Tax Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financing Coordination", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Post-Merger Integration", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },

        "Australia": {
          title: "M&A Services ",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for: Mergers, acquisitions, and corporate transaction support.",
          items: [
            { label: "Strategy & Target Search : Defines acquisition strategy, screens targets for fit and valuation.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Due Diligence : Uncovers legal, financial, employment, and compliance risks during investigation.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Valuation & Deal Structuring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Negotiation Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financing & Tax Planning", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Post-Closing Services", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Argentina": {
          title: "M&A Services ",
          subtitle: "M&A service functions to support strategic mergers, acquisitions, and post-merger integrations.",
          description: "Best for: Mergers, acquisitions, and corporate transaction support.",
          items: [
            { label: "Strategy & Target Search : Defines strategic goals, identifies ideal merger or acquisition targets, and evaluates cultural, financial, and regulatory compatibility under Argentine commercial law.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Due Diligence : Conducts financial, legal, tax, and operational audits — including company registry reviews, AFIP tax compliance checks, and sector-specific licensing verification — to assess risks and validate valuations. ", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Valuation & Deal Structuring : Provides accurate company valuations and structures transactions (e.g., share purchase, asset acquisition, or joint venture) in line with Argentina’s General Companies Law (Ley General de Sociedades No. 19.550.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Negotiation Support : Assists with negotiation strategies, drafting term sheets, and finalizing share or asset purchase agreements while navigating complex local regulations.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Compliance : Ensures compliance with antitrust laws (CNDC), foreign investment rules, and sectoral regulations (e.g., telecom, banking, or energy).", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Financing & Tax Planning : Advises on financing options (private equity, venture capital, or local lenders) and optimizes tax planning for domestic and cross-border deals under AFIP guidelines.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Management : Guides post-merger integration of staff, systems, and operations, ensuring cultural alignment and effective communication.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Post-Closing Services : Provides ongoing compliance support, reporting, and performance tracking to ensure transactions meet strategic and contractual goals.", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
      }
    },

    "Software Solutions": {
      breakdown: {
        "United States": {
          title: "Software Solutions",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "ERP (Enterprise Resource Planning)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "HRIS (Human Resources Information System)", amount: "", percent: "", icon: federalTaxIcon },
            { label: "CRM (Customer Relationship Management)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Accounting & Tax Software", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Collaboration & Productivity Tools", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity Solutions", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Integration Platforms (APIs)", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "UAE": {
          title: "Software Solutions",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Navigating regulatory requirements, labour laws, and risk management in the UAE.",
          items: [
            { label: "ERP (Enterprise Resource Planning)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "HRIS (Human Resources Information System)", amount: "", percent: "", icon: federalTaxIcon },
            { label: "CRM (Customer Relationship Management)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Accounting & Tax Software", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Collaboration & Productivity Tools", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity Solutions", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Platforms (APIs)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "ERP (Enterprise Resource Planning)", amount: "", percent: "", icon: grossSalaryIcon },
          ]
        },
        "Singapore": {
          title: "Software Solutions",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Business management software and technology platforms.",
          items: [
            { label: "ERP (Enterprise Resource Planning)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "HRIS (Human Resources Information System)", amount: "", percent: "", icon: federalTaxIcon },
            { label: "CRM (Customer Relationship Management)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Accounting & Tax Software", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Collaboration Tools", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity Solutions", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Platforms (APIs)", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Qatar": {
          title: "Software Solutions",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "Entity Registration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "WPS Compliance", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Labour Law Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Social Security Filing", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Immigration Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Regulatory Updates", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Arabic Documentation", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Industry-Specific Licenses", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Readiness", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Malaysia": {
          title: "Software Solutions",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Business management software and technology platforms.",
          items: [
            { label: "ERP (Enterprise Resource Planning)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "HRIS (Human Resources Information System)", amount: "", percent: "", icon: federalTaxIcon },
            { label: "CRM (Customer Relationship Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Accounting & Tax Software", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Collaboration & Productivity Tools", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity Solutions", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Platforms (APIs)", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "India": {
          title: "Software Solutions",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Business management software and technology platforms.",
          items: [
            { label: "ERP", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "HRIS", amount: "", percent: "", icon: federalTaxIcon },
            { label: "CRM", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Accounting & Tax Software", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Collaboration Tools", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity Solutions", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Platforms (APIs)", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "France": {
          title: "Software Solutions",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Business management software and technology platforms.",
          items: [
            { label: "ERP", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "HRIS", amount: "", percent: "", icon: federalTaxIcon },
            { label: "CRM", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Accounting & Tax Software", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Collaboration Tools", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity Solutions", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Platforms (APIs)", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Canada": {
          title: "Software Solutions",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Business management software and technology platforms.",
          items: [
            { label: "ERP (Enterprise Resource Planning)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "HRIS (Human Resources Information System)", amount: "", percent: "", icon: federalTaxIcon },
            { label: "CRM (Customer Relationship Management)", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Accounting & Tax Software", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Collaboration & Productivity Tools", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity Solutions", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Platforms (APIs)", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Brazil": {
          title: "Software Solutions",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Business management software and technology platforms.",
          items: [
            { label: "ERP Systems", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "HRIS Platforms", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Accounting Software", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "eSocial Tools", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "NFe Systems", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Banking Integration", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "CRM Solutions", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cloud Solutions", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },

        "Australia": {
          title: "Software Solutions ",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Business management software and technology platforms.",
          items: [
            { label: "ERP", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "HRIS", amount: "", percent: "", icon: federalTaxIcon },
            { label: "CRM", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Accounting & Tax Software", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "GST & State Levies", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Argentina": {
          title: "Software Solutions ",
          subtitle: "Software solutions that align with the country’s  compliance and operational standards.",
          description: "Best for: Business management software and technology platforms.",
          items: [
            { label: "ERP : Integrates finance, supply chain, operations, and reporting with compliance to Argentine GAAP and AFIP tax rules (e.g., VAT, payroll taxes).", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "HRIS : Automates HR, payroll, benefits, and compliance workflows aligned with local labor laws and social security contributions.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "CRM : Manages sales, marketing, and support with multi-language and multi-currency capabilities for domestic and Mercosur markets.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Accounting & Tax Software : Handles invoicing, bookkeeping, and tax filings (IVA, corporate tax, social security) in line with AFIP and provincial requirements.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Collaboration & Productivity Tools : Supports project management and hybrid team operations across Argentina and global markets.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity Solutions : Protects data and systems while complying with Argentina’s Personal Data Protection Law (Ley 25.326).", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Integration Platforms (APIs) : Connects ERP, HRIS, and accounting systems for automated reporting and real-time analytics.", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
      }
    },

    "MSP (Managed Service Provider)": {
      breakdown: {
        "United States": {
          title: "MSP (Managed Service Provider)",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Regulatory compliance, labour law adherence, and risk management.",
          items: [
            { label: "IT Infrastructure Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity & Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Help Desk & Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Compliance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Vendor & License Management", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Network Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Strategic IT Consulting", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "UAE": {
          title: "MSP (Managed Service Provider)",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Comprehensive IT and business process outsourcing solutions.",
          items: [
            { label: "IT Infrastructure Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity & Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Help Desk & Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Vendor & License Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Network Optimization", amount: "", percent: "", icon: grossSalaryIcon },
          ]
        },
        "Singapore": {
          title: "MSP (Managed Service Provider)",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Comprehensive IT and business process outsourcing solutions.",
          items: [
            { label: "IT Infrastructure Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity & Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Help Desk & Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Vendor & License Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Network Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Strategic IT Consulting", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Qatar": {
          title: "MSP (Managed Service Provider)",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Comprehensive IT and business process outsourcing solutions.",
          items: [
            { label: "IT Infrastructure", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity Services", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Compliance Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Help Desk Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Network Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Vendor Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Strategic IT Consulting", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Malaysia": {
          title: "MSP (Managed Service Provider)",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Comprehensive IT and business process outsourcing solutions.",
          items: [
            { label: "IT Infrastructure Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity & Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Help Desk & Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Vendor & License Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Network Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Strategic IT Consulting", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "India": {
          title: "MSP (Managed Service Provider)",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Comprehensive IT and business process outsourcing solutions.",
          items: [
            { label: "IT Infrastructure Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity & Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Help Desk & Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Vendor & License Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Network Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Strategic IT Consulting", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "France": {
          title: "MSP (Managed Service Provider)",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Comprehensive IT and business process outsourcing solutions.",
          items: [
            { label: "IT Infrastructure Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity & Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Help Desk & Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Vendor & License Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Network Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Strategic IT Consulting", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Canada": {
          title: "MSP (Managed Service Provider)",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Comprehensive IT and business process outsourcing solutions.",
          items: [
            { label: "IT Infrastructure Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity & Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Help Desk & Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Vendor & License Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Network Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Strategic IT Consulting", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },
        "Brazil": {
          title: "MSP (Managed Service Provider)",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Comprehensive IT and business process outsourcing solutions.",
          items: [
            { label: "IT Infrastructure", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity Services", amount: "", percent: "", icon: federalTaxIcon },
            { label: "LGPD Compliance", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Help Desk Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Network Optimization", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Vendor Management", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Digital Transformation", amount: "", percent: "", icon: grossSalaryIcon },

          ]
        },

        "Australia": {
          title: "MSP (Managed Service Provider) ",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Comprehensive IT and business process outsourcing solutions.",
          items: [
            { label: "IT Infrastructure Management", amount: " ", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity & Monitoring", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Help Desk & Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "GST & State Levies", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Monitoring", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Audit Support", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "International Tax", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
        "Argentina": {
          title: "MSP (Managed Service Provider) ",
          subtitle: "MSP solutions for SMEs, startups, and large enterprises.",
          description: "Best for: Comprehensive IT and business process outsourcing solutions.",
          items: [
            { label: "IT Infrastructure Management : Manages servers, cloud environments, and networks in compliance with data residency and local IT regulations.", amount: " ", percent: "", icon: grossSalaryIcon },
            { label: "Cybersecurity & Monitoring : Provides 24/7 security monitoring, incident response, and risk mitigation aligned with data protection laws.", amount: "", percent: "", icon: federalTaxIcon },
            { label: "Help Desk & Support : Offers multilingual IT support (Spanish/English) across Argentina.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Data Backup & Recovery : Ensures secure, geo-redundant backups within Argentina and rapid disaster recovery.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Compliance Management : Maintains compliance with AML laws, Ley 25.326, and industry-specific regulations (e.g., fintech, healthcare).", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Vendor & License Management : Streamlines software licenses, renewals, and vendor agreements to minimize costs and risks.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Network Optimization : Improves network performance, speed, and security for remote, hybrid, and multi-office teams.", amount: "", percent: "", icon: grossSalaryIcon },
            { label: "Strategic IT Consulting : Provides digital transformation strategies, cloud migration support, and cost-optimization roadmaps.", amount: "", percent: "", icon: grossSalaryIcon },


          ]
        },
      }
    },




    // ✅ Other services remain same pattern
  },

  getSalaryData: function (service, country) {
    try {
      const serviceData = this.services[service] || this.services["EOR/PEO/AOR"];
      const countryData = serviceData.breakdown[country] || serviceData.breakdown["United States"];

      return {
        title: countryData.title,
        subtitle: countryData.subtitle,
        description: countryData.description,
        breakdown: countryData.items
      };
    } catch (error) {
      console.error("Error getting salary data:", error);
      return this.getSalaryData("EOR/PEO/AOR", "United States");
    }
  }
};



const insightImages = {
  us: images.USFlag,
  india: images.IndiaFlag,
  liberty: images.LibertyImage,
  global: images.GlobalHiringImage
};

export const payrollInsightsData = {
  services: {
    "EOR/PEO/AOR": {
      "United States": {
        heading: "Hidden US EOR/PEO/AOR Insights",
        image: insightImages.liberty,
        items: [
          {
            "title": "State Registration Maze",
            "description": "Each state requires different EOR registrations, some taking 60+ days to process."
          },
          {
            "title": "Benefits Portability Gap",
            "description": "Switching EOR providers can disrupt employee health insurance mid-year."
          },
          {
            "title": "Termination Liability",
            "description": "EOR remains liable for unemployment claims even after the contract ends."
          }
        ]
      },
      "UAE": {
        heading: "Hidden UAE EOR/PEO/AOR Insights",
        image: images.Burj_Khalifa_Image,
        items: [
          {
            "title": "",
            "description": "Transition smoothly from EOR to a full local entity as operations grow."
          },
          {
            "title": "",
            "description": "Onboarding in days; expat hiring includes visa and work permit support."
          },
          {
            "title": "",
            "description": "Comply with MoHRE labour laws, Wage Protection System, and Saudation quotas where applicable."
          },
          {
            "title": "",
            "description": "Handle benefits: annual leave, sick leave, maternity/paternity leave, flight tickets, and end-of-service gratuity."
          },
          {
            "title": "",
            "description": "Manage terminations, notice periods, severance, and dispute resolution under UAE labour law."
          }
        ]
      },
      "Singapore": {
        heading: "Hidden Singapore EOR/PEO/AOR Insights",
        image: images.Merlion_Image,
        items: [

          {
            "title": "Work Pass Processing times",
            "description": "Employment pass (EP) and S pass approvals can take 3 to 8 weeks; delays may occur if the MoM (Ministry of Manpower) requires extra documentation."
          },
          {
            "title": "CPF Registration",
            "description": "Switching EOR/PEO providers can lead to short-term delays in the Central Provident Fund (CPF) contributions if transfers are not coordinated well."
          },
          {
            "title": "Termination Rules",
            "description": "Employers must follow the Employment Act’s notice period and termination guidelines."
          },
          {
            "title": "Mandatory Medical Insurance",
            "description": "For S pass and work permit holders, employers must maintain valid medical insurance as per MoM requirements."
          },
          {
            "title": "Skill Development Levy (SDL)",
            "description": "Payable monthly for all employees, including part-time staff."
          },
          {
            "title": "Overtime Rules",
            "description": "Employees earning below SG$2,600 a month are entitled to regulated overtime pay."
          },
          {
            "title": "",
            "description": "From Jan 2025, the minimum qualifying salary for new Employment Pass holders is SG$5,600 (higher for the finance sector)."
          }
        ]
      },
      "Qatar": {
        heading: "Hidden Qatar EOR/PEO/AOR Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [
          {
            "title": "",
            "description": "All foreign workers must be sponsored under a Qatari entity or EOR."
          },
          {
            "title": "",
            "description": "Visa approvals can take longer around Ramadan and national events."
          },
          {
            "title": "",
            "description": "Exiting an EOR arrangement requires careful planning to transfer to a local entity."
          },
          {
            "title": "",
            "description": "Medical insurance and end-of-service benefits must be budgeted upfront."
          }
        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia EOR/PEO/AOR Insights",
        image: images.Petronas_Twin_Towers_Image,
        items: [
          {
            "title": "Local hires",
            "description": "onboard in 2 to 3 days; foreign employees: 7 to 12 weeks with pass support."
          },
          {
            "title": "EOR handles",
            "description": "EPF, SOCSO, EIS, HRDF, PCB, statutory leaves, notice periods, severance, and dispute risks."
          },
          {
            "title": "",
            "description": "Malaysia offers 8 to 16 annual leave days, 14 to 22 sick days, 98 maternity days, and ~11 to 14 public holidays (state-dependent)."
          }
        ]
      },
      "India": {
        heading: "Hidden India EOR/PEO/AOR Insights",
        image: images.Taj_mahal_Image,
        items: [
          {
            "title": "State Labor License Complexity",
            "description": "Each state requires different labor registrations, and some take 45 to 90 days to process."
          },
          {
            "title": "PF Transfer Issues",
            "description": "Employee PF portability can be disrupted when switching from one EOR provider to another."
          },
          {
            "title": "Contract Labor Act",
            "description": "EOR arrangements may trigger contractor licensing requirements in some states."
          }
        ]
      },
      "France": {
        heading: "Hidden France EOR/PEO/AOR Insights",
        image: images.Eiffel_Tower_Image,
        items: [

          {
            "title": "",
            "description": "Employer social contribution can add almost half the salary cost, making budgeting crucial."
          },
          {
            "title": "",
            "description": "Different EOR providers follow different pricing models; what looks cheaper upfront may cost more in the long term."
          },
          {
            "title": "",
            "description": "Work permits such as the Talent Passport can be expedited for high-skilled hires, but standard ones involve embassy & prefecture delays."
          },
          {
            "title": "",
            "description": "As a part of the “standard package”, local employees expect meal vouchers and often a 14th-month salary."
          }


        ]
      },
      "Canada": {
        heading: "Hidden Canada EOR/PEO/AOR Insights",
        image: images.CN_tower_Image,
        items: [

          {
            "title": "Fast Onboarding",
            "description": "Hire locals in as little as 3 to 5 days; foreign workers in 8 to 16 weeks with LMIA or work permit support."
          },
          {
            "title": "Compliance Handled",
            "description": "Providers manage CPP, EI, workers’ comp, provincial health taxes, and payroll taxes."
          },
          {
            "title": "Standard Benefits",
            "description": "Includes 2 weeks’ vacation, 10+ statutory holidays, sick leave, and maternity/paternity leave per provincial laws."
          },
          {
            "title": "Work Culture",
            "description": "Standard workweek is 40 hours; overtime rules vary by province."
          },
          {
            "title": "Scalable Solution",
            "description": "Seamless transition from EOR to full entity setup as operations expand."
          }


        ]
      },
      "Brazil": {
        heading: "Hidden Brazil EOR/PEO/AOR Insights",
        image: images.Christ_the_Redeemer_Image,
        items: [

          {
            "title": "",
            "description": "CLT (labour law) compliance is extremely strict with heavy penalties."
          },
          {
            "title": "",
            "description": "Foreign workers need work permits through the Ministry of Labour."
          },
          {
            "title": "",
            "description": "Exiting EOR requires careful FGTS and benefit transfer planning. Labour court cases are common - proper documentation is critical."
          },
          {
            "title": "",
            "description": "Union agreements may apply depending on employee category."
          }


        ]
      },
      "Australia": {
        heading: "Hidden Australia EOR/PEO/AOR Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

          {
            "title": "State Registration Nuances",
            "description": "While Australia has national Fair Work laws, payroll tax and workers’ compensation registration differ by state or territory, sometimes taking 4 to 8 weeks to complete."
          },
          {
            "title": "Superannuation Transfer Delays",
            "description": "Switching EOR/PEO providers can cause interruptions in superannuation contributions if fund transfer processes are slow."
          },
          {
            "title": "Redundancy Obligations",
            "description": "Employers must comply with redundancy pay rules under the Fair Work Act, which apply even if an EOR/PEO contract ends."
          },
          {
            "title": "Visa Sponsorship Limitations",
            "description": "Not all EOR providers are authorised to sponsor visas; you may need to engage a separate migration agent."
          },
          {
            "title": "Long Service Leave Variations",
            "description": "Entitlements differ between states (e.g., NSW grants after 10 years, Victoria after 7 years)."
          },
          {
            "title": "Payroll Tax Thresholds",
            "description": "Each state has its own payroll tax threshold and rates, which can create unexpected costs for multi-state teams."
          },
          {
            "title": "Fair Work Information Statement",
            "description": "A Fair Work Information Statement must be issued to all employees at hiring."
          }


        ]
      },
            "Argentina": {
        heading: "Hidden Australia EOR/PEO/AOR Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

          {
            "title": "Fast onboarding",
            "description": "While Australia has national Fair Work laws, payroll tax and workers’ compensation registration differ by state or territory, sometimes taking 4 to 8 weeks to complete."
          },
          {
            "title": "Compliance handled",
            "description": "Switching EOR/PEO providers can cause interruptions in superannuation contributions if fund transfer processes are slow."
          },
          {
            "title": "Standard benefits",
            "description": "Employers must comply with redundancy pay rules under the Fair Work Act, which apply even if an EOR/PEO contract ends."
          },
          {
            "title": "Work culture",
            "description": "Not all EOR providers are authorised to sponsor visas; you may need to engage a separate migration agent."
          },
          {
            "title": "Scalable solution",
            "description": "Entitlements differ between states (e.g., NSW grants after 10 years, Victoria after 7 years)."
          }


        ]
      },
      "Chile": {
        heading: "Hidden Australia EOR/PEO/AOR Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

          {
            "title": "State Registration Nuances",
            "description": "While Australia has national Fair Work laws, payroll tax and workers’ compensation registration differ by state or territory, sometimes taking 4 to 8 weeks to complete."
          },
          {
            "title": "Superannuation Transfer Delays",
            "description": "Switching EOR/PEO providers can cause interruptions in superannuation contributions if fund transfer processes are slow."
          },
          {
            "title": "Redundancy Obligations",
            "description": "Employers must comply with redundancy pay rules under the Fair Work Act, which apply even if an EOR/PEO contract ends."
          },
          {
            "title": "Visa Sponsorship Limitations",
            "description": "Not all EOR providers are authorised to sponsor visas; you may need to engage a separate migration agent."
          },
          {
            "title": "Long Service Leave Variations",
            "description": "Entitlements differ between states (e.g., NSW grants after 10 years, Victoria after 7 years)."
          },
          {
            "title": "Payroll Tax Thresholds",
            "description": "Each state has its own payroll tax threshold and rates, which can create unexpected costs for multi-state teams."
          },
          {
            "title": "Fair Work Information Statement",
            "description": "A Fair Work Information Statement must be issued to all employees at hiring."
          }


        ]
      }
    },
    "Incorporation/Entity Setup": {
      "United States": {
        heading: "Hidden US Incorporation/Entity Setup Insights",
        image: insightImages.liberty,
        items: [

          {
            "title": "Delaware Advantage Myth",
            "description": "Delaware benefits mainly apply to large corporations; small businesses often do better in their home state."
          },
          {
            "title": "Franchise Tax Surprise",
            "description": "Delaware charges a minimum $175/year franchise tax regardless of activity."
          },
          {
            "title": "Foreign Qualification Trap",
            "description": "Doing business in non-formation states requires expensive foreign qualifications."
          }


        ]
      },
      "UAE": {
        heading: "Hidden UAE Incorporation/Entity Setup Insights",
        image: images.Burj_Khalifa_Image,
        items: [

          {
            "title": "",
            "description": "Free zones offer excellent incentives like tax exemptions and simplified setup."
          },
          {
            "title": "",
            "description": "Mainland gives a broader business scope but may require a local partnership."
          },
          {
            "title": "",
            "description": "Fast processing: Free zones often issue a trade licence in 3 to 7 working days."
          },
          {
            "title": "",
            "description": "Strong credibility with clients and partners."
          },
          {
            "title": "",
            "description": "Licensing cost varies by emirate and business activity."
          }


        ]
      },
      "Singapore": {
        heading: "Hidden Singapore Incorporation/Entity Setup Insights",
        image: images.Merlion_Image,
        items: [


          {
            "title": "Local Director Requirement",
            "description": "Mandatory for company registration."
          },
          {
            "title": "AGM Rules",
            "description": "Companies must hold AGMs and file annual returns, even if dormant."
          },
          {
            "title": "BizFile+ Updates",
            "description": "Any changes (name, address, officers) must be updated in BizFile+ promptly."
          },
          {
            "title": "S Pass/Employment Pass",
            "description": "International founders often require employment passes before assuming an official role."
          },
          {
            "title": "Audit Requirement",
            "description": "Companies must be audited unless exempt (criteria based on turnover/assets/employees)."
          },
          {
            "title": "",
            "description": "Foreign companies often use Singapore as a regional HQ due to 100+ double tax treaties."
          }


        ]
      },
      "Qatar": {
        heading: "Hidden Qatar Incorporation/Entity Setup Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [

          {
            "title": "",
            "description": "Mainland entities usually require 51% local Qatari partners."
          },
          {
            "title": "",
            "description": "Free zones allow 100% foreign ownership, but activity restrictions apply."
          },
          {
            "title": "",
            "description": "Bank account opening often takes longer than incorporation itself."
          },
          {
            "title": "",
            "description": "Company names must comply with the rules of the Arabic language."
          }


        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia Incorporation/Entity Setup Insights",
        image: images.Petronas_Twin_Towers_Image,
        items: [

          {
            "title": "",
            "description": "100% foreign ownership permitted in most industries (except agriculture, banking, education, oil & gas)."
          },
          {
            "title": "",
            "description": "Sdn Bhd offers limited liability + better investor credibility."
          },
          {
            "title": "MyCoID Approvals",
            "description": "5 to 10 business days (among the fastest in ASEAN)."
          }


        ]
      },
      "India": {
        heading: "Hidden India Incorporation/Entity Setup Insights",
        image: images.Taj_mahal_Image,
        items: [

          {
            "title": "MCA Approval Delays",
            "description": "Incorporation can take 10 to 30 days; name approval is often the biggest bottleneck."
          },
          {
            "title": "GST Registration Trap",
            "description": "Businesses in e-commerce or interstate trade require GST even if turnover is low."
          },
          {
            "title": "State-specific Professional Tax",
            "description": "Multistate teams require compliance with different PT rules."
          },
          {
            "title": "Gratuity/Bonus Laws",
            "description": "Statutory payments are owed even to small teams after one year."
          }


        ]
      },
      "France": {
        heading: "Hidden France Incorporation/Entity Setup Insights",
        image: images.Eiffel_Tower_Image,
        items: [

          {
            "title": "",
            "description": "SAS offers flexibility for investors, while SARL is stricter but suits small teams."
          },
          {
            "title": "",
            "description": "Opening a corporate bank account is often the biggest bottleneck due to strict AML checks."
          },
          {
            "title": "",
            "description": "Certain industries need extra permits or licenses."
          }

        ]
      },
      "Canada": {
        heading: "Hidden Canada Incorporation/Entity Setup Insights",
        image: images.CN_tower_Image,
        items: [


          {
            "title": "Full Foreign Ownership",
            "description": "Non-residents can own 100% of a Canadian corporation, but some sectors, like telecom, transport, or banking, may have restrictions."
          },
          {
            "title": "Residency Requirements",
            "description": "Federal corporations and many provinces mandate 25% resident directors, but BC, Alberta, and Quebec have no residency rule, making them attractive for foreign founders."
          },
          {
            "title": "Funding Access",
            "description": "Incorporating improves access to Canadian grants, loans, and investor networks."
          },
          {
            "title": "Fast Processing",
            "description": "Federal incorporations can often be processed in under 1 business day if documents are in order."
          },
          {
            "title": "Liability Protection",
            "description": "Corporations shield owners from most personal liabilities tied to the business."
          }




        ]
      },
      "Brazil": {
        heading: "Hidden Brazil Incorporation/Entity Setup Insights",
        image: images.Christ_the_Redeemer_Image,
        items: [

          {
            "title": "",
            "description": "Foreign ownership restrictions exist in certain sectors (media, aviation)."
          },
          {
            "title": "",
            "description": "Some states offer tax incentives for new businesses."
          },
          {
            "title": "",
            "description": "Bank account opening requires the physical presence of a legal representative."
          },
          {
            "title": "",
            "description": "Environmental licenses may be required depending on business activity."
          }


        ]
      },
      "Australia": {
        heading: "Hidden Australia Incorporation/Entity Setup Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

          {
            "title": "Name Reservation Mishaps",
            "description": "Misspelling your company name during registration may cost you additional ASIC fees later for a new reservation."
          },
          {
            "title": "Director Residency Requirement",
            "description": "At least one company director must be a resident of Australia."
          },
          {
            "title": "Constitution vs Replaceable Rules",
            "description": "Not setting a formal Company Constitution (opting for default replaceable rules) could limit your ability to manage ownership rights or governance flexibility later."
          },
          {
            "title": "ABN/GST/TFN Overlook",
            "description": "Forgetting to register for an Australian Business Number (ABN) or Tax File Number (TFN), or missing GST registration when your turnover exceeds AU$75,000, can trigger fines and backdated obligations."
          },
          {
            "title": "Director ID Requirement",
            "description": "Company directors must now obtain a Director ID before incorporation (ATO requirement)."
          }


        ]
      }
    },
        "Staffing/Talent Acquisition": {
      "United States": {
        heading: "Hidden US Staffing/Talent Acquisition Insights",
            image: insightImages.liberty,
            items: [
              {
                "title": "Visa Sponsorship Costs",
                "description": "H-1B sponsorship can cost $5,000-15,000 in legal and filing fees."
              },
              {
                "title": "Non-Compete Enforcement",
                "description": "State laws vary dramatically - California bans most non-competes entirely."
              },
              {
                "title": "Co-Employment Risk",
                "description": "Misclassified contractors can create unexpected employment liability."
              }
            ]
      },
      "UAE": {
        heading: "Hidden UAE Staffing/Talent Acquisition Insights",
        image: images.Burj_Khalifa_Image,
        items: [
          {
            "title": "Emiratisation Quotas",
            "description": "Hiring Emiratis may require quotas or an Emiratisation strategy."
          },
          {
            "title": "Expat Costs",
            "description": "For expats: factor in visa, insurance, and labour permit costs."
          },
          {
            "title": "Contractor Misclassification",
            "description": "Misclassifying staff as contractors can lead to fines."
          },
          {
            "title": "Talent Shortages",
            "description": "High-demand sectors (tech, finance) face talent shortages."
          },
          {
            "title": "Data Handling Penalties",
            "description": "Improper data handling can result in penalties."
          }
        ]
      },
      "Singapore": {
        heading: "Hidden Singapore Staffing/Talent Acquisition Insights",
        image: images.Merlion_Image,
        items: [


          {
            "title": "",
            "description": "Fair Consideration Framework requires jobs to be listed on the MyCareersFuture portal before EP applications."
          },
          {
            "title": "",
            "description": "Salary benchmarking is critical; MoM publishes sectoral minimum qualifying salaries for EP/S pass."
          },
          {
            "title": "",
            "description": "S Pass minimum qualifying salary = SG$3,650/month in 2025."
          }


        ]
      },
      "Qatar": {
        heading: "Hidden Qatar Staffing/Talent Acquisition Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [

          {
            "title": "",
            "description": "Recruitment agencies must be licensed by the Ministry of Labour."
          },
          {
            "title": "",
            "description": "“Qatarisation” requires certain roles to be filled by locals."
          },
          {
            "title": "",
            "description": "Employers cannot charge recruitment fees to candidates."
          },
          {
            "title": "",
            "description": "High turnover is common in service-heavy industries."
          }


        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia Staffing/Talent Acquisition Insights",
        image: images.Petronas_Twin_Towers_Image,
        items: [
          {
            "title": "Foreign Hires",
            "description": "Require levies, permits, and medical/insurance add-ons."
          },
          {
            "title": "Probation",
            "description": "3 to 6 months; notice required even during probation."
          },
          {
            "title": "Talent Gaps",
            "description": "High demand in tech, finance, and engineering."
          },
          {
            "title": "Retention Strategy",
            "description": "Upskilling and flexible work improve retention."
          }
        ]
          },
          "India": {
            heading: "Hidden India Staffing/Talent Acquisition Insights",
            image: images.Taj_mahal_Image,
            items: [
              {
                "title": "Referrals Work Best",
                "description": "In India, employee referrals drive higher retention."
              },
              {
                "title": "Remote Talent",
                "description": "Tier-II cities/small towns offer exceptional skill and lower cost."
              },
              {
                "title": "Compliance Is Critical",
                "description": "Missed PF/ESI or offer letter filings can trigger government action."
              },
              {
                "title": "Training Credits",
                "description": "Central/state skill development grants are often underutilised by new companies."
              }
            ]
      },
      "France": {
        heading: "Hidden France Staffing/Talent Acquisition Insights",
        image: images.Eiffel_Tower_Image,
        items: [

          {
            "title": "",
            "description": "Trial periods are legally limited and vary by role; employers can't extend them indefinitely."
          },
          {
            "title": "",
            "description": "Recruiting bilingual talent is competitive and comes at a premium salary cost."
          },
          {
            "title": "",
            "description": "Employers cannot charge candidates recruitment fees; it's illegal."
          },
          {
            "title": "",
            "description": "Work permits for non-EU hires must be secured before arrival."
          },
          {
            "title": "",
            "description": "Replacement guarantees are common in agency contracts, especially for executive hiring."
          }


        ]
      },
      "Canada": {
        heading: "Hidden Canada Staffing/Talent Acquisition Insights",
        image: images.CN_tower_Image,
        items: [


          {
            "title": "Foreign Hires",
            "description": "Work permits and LMIA processes add cost and time; plan 8 to 16 weeks for processing."
          },
          {
            "title": "Contract Clarity",
            "description": "Misclassifying employees as contractors can trigger penalties from CRA."
          },
          {
            "title": "Retention Focus",
            "description": "Upskilling and flexible work policies improve retention, especially for tech and skilled roles."
          },
          {
            "title": "Talent Shortages",
            "description": "Roles in tech, healthcare, and skilled trades are highly competitive, requiring faster hiring cycles."
          },
          {
            "title": "Remote Hiring",
            "description": "Remote-first models are common; verify compliance with the employee’s home province laws."
          },
          {
            "title": "Privacy Risks",
            "description": "Mishandling employee data under PIPEDA can lead to significant fines and legal action."
          }




        ]
      },
      "Brazil": {
        heading: "Hidden Brazil Staffing/Talent Acquisition Insights",
        image: images.Christ_the_Redeemer_Image,
        items: [

          {
            "title": "",
            "description": "Labour courts heavily favour employees in disputes."
          },
          {
            "title": "",
            "description": "Termination costs can be very high (FGTS fine + notice period)."
          },
          {
            "title": "",
            "description": "Union agreements may override standard employment terms."
          },
          {
            "title": "",
            "description": "High turnover in service industries, especially retail."
          }


        ]
      },
      "Australia": {
        heading: "Hidden Australia Staffing/Talent Acquisition Insights",
        image: images.Sydney_Opera_House_Image,
          items: [

            {
              "title": "Visa Sponsorship Costs",
              "description": "If a company wants to sponsor a worker’s visa (like Subclass 482 or 186), it can cost around AU$5k to 10k in government fees and lawyer charges. Median salary for skilled visa sponsorship = AU$70,000+ per year (as of 2025)."
            },
            {
              "title": "Non-Compete Enforcement",
              "description": "Non-compete agreements are only valid if they are fair in terms of time, place, and limits. If the rules are too strict, Australian courts usually cancel them."
            },
            {
              "title": "Sham Contracting Risk",
              "description": "Calling someone a “contractor” when they are working like an employee can lead to big fines from the Fair Work Ombudsman."
            }


          ]
      }
    },
        "Global Payroll": {
      "United States": {
        heading: "Hidden US Global Payroll Insights",
        image: insightImages.liberty,
        items: [
              {
                "title": "Nexus Trap",
                "description": "Running payroll in a state where your team works (even remotely) without registering causes hidden tax liability."
              },
              {
                "title": "SUI Rate Shock",
                "description": "Each new hire in a new state resets your unemployment rate, increasing the cost unexpectedly."
              },
              {
                "title": "Multi-state Edge",
                "description": "Many providers do not calculate reciprocal tax agreements, leading to over-withholding."
              }
            ]
          },
      "UAE": {
        heading: "Hidden UAE Global Payroll Insights",
        image: images.Burj_Khalifa_Image,
        items: [

          {
            "title": "",
            "description": "No personal income tax, both Emiratis and expatriates benefit from tax-free salaries."
          },
          {
            "title": "",
            "description": "Dubai's WPS (Wage Protection System) must be used for salary payments; compliance is mandatory."
          },
          {
            "title": "",
            "description": "Payroll must account for gratuity (if not using DEWS), different free zone schemes, and Emiratisation levies."
          },
          {
            "title": "",
            "description": "For Emiratis, social contributions fund the GPSSA pension scheme. Employers and employees both contribute, with government support for lower-income brackets."
          },
          {
            "title": "",
            "description": "Expatriates have no mandatory social security or pension contributions, but employers must still handle DEWS or gratuity and manage visa-related payroll obligations."
          }


        ]
      },
      "Singapore": {
        heading: "Hidden Singapore Global Payroll Insights",
        image: images.Merlion_Image,
        items: [


  {
    "title": "",
    "description": "CPF must be filled monthly by the 14th; even one day late will result in penalties."
  },
  {
    "title": "",
    "description": "Non-resident director's fees are subject to withholding tax."
  },
  {
    "title": "IR8A/IR21 e-filing deadline",
    "description": " March 1st annually via myTax Portal."
  }


        ]
      },
      "Qatar": {
        heading: "Hidden Qatar Global Payroll Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [
          {
            "title": "",
            "description": "Payroll must comply with the Wage Protection System (WPS)."
          },
          {
            "title": "",
            "description": "Non-compliance with WPS results in heavy penalties & visa bans."
          },
          {
            "title": "End-of-service gratuity:",
            "description": " minimum 3 weeks per year of service."
          }
        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia Global Payroll Insights",
        image: images.Petronas_Twin_Towers_Image,
            items: [
              {
                "title": "",
                "description": "Contributions must be timely to avoid penalties."
              },
              {
                "title": "",
                "description": "HRD levy supports training; claims require documentation and deadlines."
              },
              {
                "title": "",
                "description": "Overtime must comply with strict working-hour limits (8h/day or 45h/week, overtime up to 104h/month)."
              }
            ]
          },
      "India": {
        heading: "Hidden India Global Payroll Insights",
        image: images.Taj_mahal_Image,
        items: [

          {
            "title": "India’s mandatory payroll deductions",
            "description": " include PF, ESI, professional tax, and income tax (TDS). They vary by state and salary band."
          },
          {
            "title": "Multi-State Payroll Complexity:",
            "description": "Different professional tax rates across states (₹200 to ₹2,500 annually)."
          },
          {
            "title": "PF Ceiling Changes",
            "description": "PF contributions are capped at ₹1,800/month for salaries above ₹15,000 basic."
          },
          {
            "title": "Tax Regime Choice",
            "description": "Employees can choose between the old and the new tax regime annually."
          }


        ]
      },
      "France": {
        heading: "Hidden France Global Payroll Insights",
        image: images.Eiffel_Tower_Image,
        items: [

          {
            "title": "",
            "description": "Employer costs go beyond 40-45% social charges; some collective agreements add industry-specific obligations."
          },
          {
            "title": "",
            "description": "The monthly DSN report is central; even small errors can lead to penalties or blocked compliance."
          },
          {
            "title": "",
            "description": "Payroll is tightly linked to employee trust in France; any mistake in payslips can damage their reputation."
          },
          {
            "title": "",
            "description": "Certain payroll costs are often overlooked by new employers."
          }


        ]
      },
      "Canada": {
        heading: "Hidden Canada Global Payroll Insights",
        image: images.CN_tower_Image,
        items: [

          {
            "title": "Multi-Province Complexity",
            "description": "Payroll tax rates, vacation accruals, and statutory holidays differ by province; automation helps avoid errors."
          },
          {
            "title": "Remote Workers",
            "description": "Tax obligations are tied to the employee’s province of residence, not the company’s headquarters."
          },
          {
            "title": "Misclassification Risks",
            "description": "Treating employees as contractors incorrectly can trigger CRA audits and penalties."
          },
          {
            "title": "Vacation Tracking",
            "description": "Minimums vary from 2 weeks (federal standard) to 3 weeks or more in provinces like Saskatchewan after certain years of service."
          }


        ]
      },
      "Brazil": {
        heading: "Hidden Brazil Global Payroll Insights",
        image: images.Christ_the_Redeemer_Image,
            items: [

              {
                "title": "",
                "description": "The eSocial system requires real-time reporting of all employment events."
              },
              {
                "title": "",
                "description": "Late payments trigger automatic fines and labour court exposure."
              },
              {
                "title": "",
                "description": "Union dues may be mandatory depending on the category."
              },
              {
                "title": "",
                "description": "Meal vouchers and transportation vouchers are often tax-exempt."
              }


            ]
          },
      "Australia": {
        heading: "Hidden Australia Global Payroll Insights",
        image: images.Sydney_Opera_House_Image,
        items: [


          {
            "title": "Payroll Tax Trap",
            "description": "Every state and territory has its own rules for payroll tax. If a business hires people in different states, it may suddenly have to pay extra taxes."
          },
          {
            "title": "Superannuation Compliance",
            "description": "Employers must put 11% of a worker’s normal pay into their retirement fund (super). If they pay late or miss payments, they face big fines."
          },
          {
            "title": "Fringe Benefits Tax (FBT)",
            "description": "Extra perks for employees, like company cars, housing, or free meals, are taxed separately and can quietly increase costs for employers."
          },
          {
            "title": "",
            "description": "Single Touch Payroll (STP) Phase 2 requires reporting of income, tax, and super in detail directly to the ATO."
          }

        ]
      }
    },
        "HRIS (Human Resources Information System)": {
      "United States": {
        heading: "Hidden US HRIS Insights",
        image: insightImages.liberty,
        items: [
  {
    "title": "Integration Complexity",
    "description": "Connecting HRIS to existing payroll/benefits systems often costs 2-3x the software price."
  },
  {
    "title": "Compliance Auto-Updates",
    "description": "Not all systems automatically update for changing labour laws across states."
  },
  {
    "title": "Data Security Liability",
    "description": "HRIS breaches can expose SSNs, salary data, creating significant legal exposure."
  }
        ]
      },
      "UAE": {
        heading: "Hidden UAE HRIS Insights",
        image: images.Burj_Khalifa_Image,
        items: [
 
  {
    "title": "",
    "description": "Leading platforms include Zimyo, Darwinbox, peopleHum, Bayzat, GreytHR, ZenHR, SAP SuccessFactors, Oracle HCM Cloud, and more. These cater to compliance, multilingual support, and payroll automation needs."
  },
  {
    "title": "",
    "description": "HRIS usage ensures: WPS compliance, unified data storage, simplified leave and shift tracking, and accurate end-of-service processing."
  },
  {
    "title": "",
    "description": "Analytics features aid in monitoring Emiratisation quotas and workforce trends."
  }


        ]
      },
      "Singapore": {
        heading: "Hidden Singapore HRIS Insights",
        image: images.Merlion_Image,
        items: [


  {
    "title": "",
    "description": "Integration with CPF, SDL and IRAS can be costly."
  },
  {
    "title": "",
    "description": "Bad implementation may double overall costs."
  }


        ]
      },
      "Qatar": {
        heading: "Hidden Qatar HRIS Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [
  {
    "title": "",
    "description": "Integration with WPS reporting is essential."
  },
  {
    "title": "",
    "description": "Arabic language support is often needed for compliance docs."
  },
  {
    "title": "",
    "description": "Labour authorities may ask for employee records during inspections."
  },
  {
    "title": "",
    "description": "Integration with WPS payroll files is essential."
  },
  {
    "title": "",
    "description": "In-country hosting may be required for sensitive data."
  }
        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia HRIS Insights",
        image: images.Petronas_Twin_Towers_Image,
        items: [

  {
    "title": "",
    "description": "Malaysia’s top HRIS platforms, such as Kakitangan, Swingvy, Talenox, BrioHR, peopleHum, Akrivia HCM, and AltHR, offer powerful features to support HR teams of all sizes."
  },
  {
    "title": "",
    "description": "Centralised employee data, attendance, leave, and payroll management."
  },
  {
    "title": "",
    "description": "Automated statutory compliance with EPF, SOCSO, EIS, HRDF, and PAYE."
  },
  {
    "title": "",
    "description": "Benefits administration, onboarding workflows, and performance tracking."
  },
  {
    "title": "",
    "description": "Employee self-service portals, mobile apps, and integration with banks/accounting tools."
  },
  {
    "title": "",
    "description": "Analytics dashboards to inform strategic HR decisions."
  },
  {
    "title": "",
    "description": "Cloud-based platforms with real-time regulatory updates and PDPA compliance."
  }


        ]
      },
      "India": {
        heading: "Hidden India HRIS Insights",
        image: insightImages.liberty,
        items: [
  {
    "title": "Compliance Integration Complexity",
    "description": "Indian labor law updates require frequent system updates."
  },
  {
    "title": "Local Language Support",
    "description": "Many systems lack regional language support for non-English speaking employees."
  },
  {
    "title": "Aadhaar Integration",
    "description": "Newer systems integrate with Aadhaar for identity verification."
  }
        ]
      },
      "France": {
        heading: "Hidden France HRIS Insights",
        image: images.Eiffel_Tower_Image,
        items: [


  {
    "title": "",
    "description": "Many HRIS tools must be customised for French law (labour codes+collective agreements)."
  },
  {
    "title": "",
    "description": "DNA integration is crucial; not all global HRIS tools provide it."
  },
  {
    "title": "",
    "description": "Biometric attendance is common in retail & construction to comply with work-hour limits."
  },
  {
    "title": "",
    "description": "Companies must store HR data inside the EU to meet GDPR rules."
  }




        ]
      },
      "Canada": {
        heading: "Hidden Canada HRIS Insights",
        image: images.CN_tower_Image,
        items: [
  {
    "title": "",
    "description": "Canada’s leading HRIS platforms, such as Ceridian Dayforce, ADP Workforce Now, Humi, BambooHR, Rippling, and Payworks, typically offer:"
  },
  {
    "title": "",
    "description": "Centralised management of employee data, time, leave, and payroll."
  },
  {
    "title": "",
    "description": "Automated compliance with federal and provincial tax rules (CRA, CPP, EI, and QPP in Quebec)."
  },
  {
    "title": "",
    "description": "Integrated benefits administration, performance management, and onboarding workflows."
  },
  {
    "title": "",
    "description": "Employee self-service portals and mobile apps for accessibility."
  },
  {
    "title": "",
    "description": "Cloud-based platforms with real-time updates to regulations and tax rates."
  },
  {
    "title": "",
    "description": "Data privacy compliance with PIPEDA and provincial privacy laws."
  }




        ]
      },
      "Brazil": {
        heading: "Hidden Brazil HRIS Insights",
        image: images.Christ_the_Redeemer_Image,
        items: [


  {
    "title": "",
    "description": "eSocial integration is mandatory and complex."
  },
  {
    "title": "",
    "description": "Portuguese language support is essential for employee adoption."
  },
  {
    "title": "",
    "description": "Labour inspectors may request employee records during audits."
  },
  {
    "title": "",
    "description": "Data localisation requirements may apply to employee data."
  }




        ]
      },
      "Australia": {
        heading: "Hidden Australia HRIS Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

  {
    "title": "High Setup Costs",
    "description": "Linking HRIS with payroll and super systems can cost more than buying the software."
  },
  {
    "title": "Complex Award Rules",
    "description": "HRIS usually can’t read Australia’s award rules on their own, so extra setup or tools are needed."
  },
  {
    "title": "Slow Updates",
    "description": "Some HRIS don’t update quickly when Fair Work laws or agreements change."
  },
  {
    "title": "Data Risks",
    "description": "If hacked, HRIS can leak personal info like TFNs, pay, and super details, leading to big legal problems."
  }




        ]
      }
    },
        "Accounting Services": {
      "United States": {
        heading: "Hidden US Accounting Services Insights",
        image: insightImages.liberty,
        items: [
  {
    "title": "Sales Tax Nexus",
    "description": "Remote work can trigger sales tax obligations in the employee's home state."
  },
  {
    "title": "R&D Credit Complexity",
    "description": "Many startups miss significant R&D tax credits due to poor documentation."
  },
  {
    "title": "409A Valuation Timing",
    "description": "Stock option grants require current 409A valuations to avoid tax penalties."
  }
        ]
      },
      "UAE": {
        heading: "Hidden UAE Accounting Services Insights",
        image: images.Burj_Khalifa_Image,
        items: [
  {
    "title": "IFRS Mandatory",
    "description": "Companies must apply IFRS for financial reporting; this ensures transparency and comparability."
  },
  {
    "title": "Free Zone Tax Incentives",
    "description": "Free Zone entities designated as Qualifying Free Zone Persons (QFZPs) may enjoy 0% corporate tax on qualifying income, provided they maintain substance and meet criteria."
  },
  {
    "title": "Corporate Tax Regime",
    "description": "Standard corporate tax is 0% up to AED 375,000, and 9% thereafter. This applies to both mainland and Free Zone companies (for non-qualifying income)."
  },
  {
    "title": "Bookkeeping Penalties",
    "description": "Non-compliance with record-keeping (last 5 years) can result in fines starting from AED 5,000."
  }
        ]
      },
      "Singapore": {
        heading: "Hidden Singapore Accounting Services Insights",
        image: images.Merlion_Image,
        items: [

  
  {
    "title": "",
    "description": "Dormant companies must still file Annual returns."
  },
  {
    "title": "",
    "description": "IRAS may request audits even for exempted firms."
  }


        ]
      },
      "Qatar": {
        heading: "Hidden Qatar Accounting Services Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [
  {
    "title": "",
    "description": "IFRS is mandatory for most entities."
  },
  {
    "title": "",
    "description": "Annual audit required for all LLCs."
  },
  {
    "title": "",
    "description": "The tax authority (GTA) is strict on record-keeping."
  },
  {
    "title": "",
    "description": "Delayed filings attract high penalties from authorities."
  },
  {
    "title": "",
    "description": "Books must be kept in Arabic (or with Arabic translations)."
  }
        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia Accounting Services Insights",
        image: images.Petronas_Twin_Towers_Image,
        items: [
  {
    "title": "R&D Tax Benefits",
    "description": "Double deductions for eligible R&D expenses or Investment Tax Allowance (ITA) to offset taxable income."
  },
  {
    "title": "Pioneer Status Incentive (PS)",
    "description": "Up to 70% tax exemption on statutory income for 5 years for approved activities."
  },
  {
    "title": "Malaysia Digital (MD)",
    "description": "Tax incentive reduced tax rates (0 to 10%) or 60 to 100% ITA for businesses leveraging promoted digital technologies."
  }
        ]
      },
      "India": {
        heading: "Hidden India Accounting Services Insights",
        image: images.Taj_mahal_Image,
        items: [
  {
    "title": "GST Reconciliation Complexity",
    "description": "Multiple returns (GSTR-1, GSTR-3B, GSTR-9) require careful coordination."
  },
  {
    "title": "TDS Compliance Burden",
    "description": "Multiple TDS sections with different rates and deadlines."
  },
  {
    "title": "Transfer Pricing Documentation",
    "description": "Required for related party transactions above thresholds."
  }
        ]
      },
      "France": {
        heading: "Hidden France Accounting Services Insights",
        image: images.Eiffel_Tower_Image,
        items: [
  {
    "title": "",
    "description": "French GAAP differs from IFRS; reconciliation may be required for multinational groups."
  },
  {
    "title": "",
    "description": "Late filing of accounts leads to fines and may trigger tax audits."
  },
  {
    "title": "",
    "description": "France requires annual statutory accounts to be filed with the Commercial Court Registry."
  },
  {
    "title": "",
    "description": "Many businesses underestimate the time required for VAT filings and refund claims."
  }


        ]
      },
      "Canada": {
        heading: "Hidden Canada Accounting Services Insights",
        image: images.CN_tower_Image,
        items: [

          {
            "title": "SR&ED Tax Incentives",
            "description": "Refundable or non-refundable credits for eligible research and development expenses."
          },
          {
            "title": "Investment Tax Credits (ITCs)",
            "description": "Tax breaks for adopting innovative technologies or clean energy solutions."
          },
          {
            "title": "Small Business Deduction (SBD)",
            "description": "Reduced federal corporate tax rate (9% on the first CAD 500,000 of active business income)."
          },
          {
            "title": "Digital Transformation Grants",
            "description": "Several provinces offer grants and subsidies to help SMEs adopt cloud-based accounting platforms."
          }


        ]
      },
      "Brazil": {
        heading: "Hidden Brazil Accounting Services Insights",
        image: images.Christ_the_Redeemer_Image,
        items: [

  {
    "title": "",
    "description": "Brazilian GAAP differs significantly from IFRS."
  },
  {
    "title": "",
    "description": "Electronic invoicing (NFe) is mandatory for most transactions."
  },
  {
    "title": "",
    "description": "Receita Federal audits are comprehensive and frequent."
  },
  {
    "title": "",
    "description": "Transfer pricing rules apply to related party transactions."
  }


        ]
      },
      "Australia": {
        heading: "Hidden Australia Accounting Services Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

   
  {
    "title": "GST & Payroll",
    "description": "Hiring people in different states can mean extra GST reporting and payroll tax."
  },
  {
    "title": "R&D Rebates",
    "description": "Startups often lose R&D tax benefits because they don’t keep good records."
  },
  {
    "title": "Employee Shares",
    "description": "Giving staff shares or options needs correct valuation and reports, or it can cause surprise taxes."
  }




        ]
      }
    },
        "Tax Services": {
      "United States": {
        heading: "Hidden US Tax Services Insights",
        image: insightImages.liberty,
        items: [

  {
    "title": "Economic Nexus Thresholds",
    "description": "Remote sales can trigger tax obligations at $100k-500k, depending on the state."
  },
  {
    "title": "SALT Cap Impact",
    "description": "$10k state and local tax deduction cap affects high-tax states disproportionately."
  },
  {
    "title": "Quarterly Estimate Penalties",
    "description": "Underpayment penalties apply even if you're owed a refund at year-end."
  }


        ]
      },
      "UAE": {
        heading: "Hidden UAE Tax Services Insights",
        image: images.Burj_Khalifa_Image,
        items: [

  {
    "title": "",
    "description": "Corporate Tax Effective Date: The UAE's corporate tax system applies to financial years starting on or after 1 June 2023."
  },
  {
    "title": "",
    "description": "Small Business Relief: Businesses with revenue below AED 3 million may qualify for 0% tax and simpler compliance rules."
  },
  {
    "title": "",
    "description": "Transfer Pricing Enforcement: TP disclosures are mandatory when thresholds are met; documentation must be FTA-ready."
  },
  {
    "title": "",
    "description": "DMTT: A 15% top-up tax applies from January 2025 for qualifying multinationals under OECD rules."
  },
  {
    "title": "",
    "description": "FTA Expectation: Companies must register for CT promptly, file returns within 9 months of the fiscal year-end, and retain all tax records for 7 years."
  }


        ]
      },
      "Singapore": {
        heading: "Hidden Singapore Tax Services Insights",
        image: images.Merlion_Image,
        items: [

  {
    "title": "",
    "description": "Late filling penalties range from S$200 to S$1,000."
  },
  {
    "title": "",
    "description": "Transfer pricing rules apply to Cross-border deals."
  }
        ]
      },
      "Qatar": {
        heading: "Hidden Qatar Tax Services Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [
  {
    "title": "",
    "description": "Corporate tax is 10% flat (except in free zones)."
  },
  {
    "title": "",
    "description": "Withholding tax applies to non-resident payments (5 to7%)."
  },
  {
    "title": "",
    "description": "Transfer pricing compliance is new but expanding."
  },
  {
    "title": "",
    "description": "VAT is planned but not yet implemented."
  },
  {
    "title": "",
    "description": "Zakat ( religious tax) applies to Qatari-owned businesses."
  }
        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia Tax Services Insights",
        image: images.Petronas_Twin_Towers_Image,
        items: [
  {
    "title": "",
    "description": "Corporate tax is 24%, but incentives like Pioneer Status or ITA can lower it."
  },
  {
    "title": "",
    "description": "Corporate tax is due 7 months after the year-end."
  },
  {
    "title": "",
    "description": "Late or incorrect WHT payments can incur 10% penalties."
  },
  {
    "title": "",
    "description": "Tax laws change often; stay updated to stay compliant."
  }
        ]
      },
      "India": {
        heading: "Hidden India Tax Services Insights",
        image: images.Taj_mahal_Image,
        items: [
  {
    "title": "Advance Tax Deadlines",
    "description": "Four quarterly payments required with specific percentages (15%, 45%, 75%, 100%)."
  },
  {
    "title": "Minimum Alternate Tax",
    "description": "MAT at 15% applies even when the regular tax is lower."
  },
  {
    "title": "Domestic Transfer Pricing",
    "description": "Now applicable for transactions > ₹20 crores with Indian-related parties."
  }
        ]
      },
      "France": {
        heading: "Hidden France Tax Services Insights",
        image: images.Eiffel_Tower_Image,
        items: [

  {
    "title": "",
    "description": "Corporate tax in France is gradually reducing, but remains high compared to many EU states."
  },
  {
    "title": "",
    "description": "VAT refunds are common but slowly processed; planning a cash flow is essential."
  },
  {
    "title": "",
    "description": "In France, many businesses miss the local business tax, which is the CFE tax and end up paying penalties."
  },
  {
    "title": "",
    "description": "Note: France is strict on transfer pricing documentation; even small subsidiaries can be looked over."
  }


        ]
      },
      "Canada": {
        heading: "Hidden Canada Tax Services Insights",
        image: images.CN_tower_Image,
        items: [
 {
    "title": "Corporate tax rates",
    "description": "Federal tax is 15%, plus provincial rates (8% to 16%), with small business rates as low as 9% federal + provincial portion."
  },
  {
    "title": "Deadlines",
    "description": "Corporate returns (T2) are due 6 months after year-end; balances owing are due 2 to 3 months after fiscal year-end."
  },
  {
    "title": "Withholding taxes",
    "description": "Payments to non-residents may be subject to 15 to 25% withholding, depending on tax treaties."
  },
  {
    "title": "Frequent updates",
    "description": "Tax credits and incentives are often revised in annual federal and provincial budgets; stay updated to maximise benefits."
  },
  {
    "title": "Digital compliance",
    "description": "CRA increasingly requires electronic filing and payments for faster processing and fewer penalties."
  }


        ]
      },
      "Brazil": {
        heading: "Hidden Brazil Tax Services Insights",
        image: images.Christ_the_Redeemer_Image,
        items: [
{
    "title": "",
    "description": "Tax complexity varies dramatically between federal, state, and municipal levels."
  },
  {
    "title": "",
    "description": "Simples Nacional can reduce tax burden by 60%+ for eligible companies."
  },
  {
    "title": "",
    "description": "ICMS rates differ by state, creating interstate commerce complications."
  },
  {
    "title": "",
    "description": "Tax litigation is common and can take years to resolve."
  },
  {
    "title": "",
    "description": "Deemed profit taxation may be more favourable than actual profit."
  }


        ]
      },
      "Australia": {
        heading: "Hidden Australia Tax Services Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

   {
    "title": "GST Rule",
    "description": "If your business makes over $75,000 a year, you must sign up for GST, even for online sales."
  },
  {
    "title": "Payroll Tax",
    "description": "If you hire people in different states, you may have to pay extra payroll tax, even with low profits."
  },
  {
    "title": "BAS Mistakes",
    "description": "If you make errors or pay less in your quarterly BAS, the ATO can fine you, even if it balances out later."
  }


        ]
      }
    },
        "Compliance Services": {
      "United States": {
        heading: "Hidden US Compliance Services Insights",
        image: insightImages.liberty,
        items: [
  {
    "title": "Multi-State Complexity",
    "description": "Each state has different break requirements, overtime rules, and termination procedures."
  },
  {
    "title": "Contractor Misclassification",
    "description": "IRS and DOL are increasing audits, which can result in back taxes and penalties."
  },
  {
    "title": "Whistleblower Protection",
    "description": "Federal and state laws create complex reporting and investigation requirements."
  }
        ]
      },
      "UAE": {
        heading: "Hidden UAE Compliance Services Insights",
        image: images.Burj_Khalifa_Image,
        items: [
{
    "title": "",
    "description": "Overtime is capped at two hours per day unless authorised, with pay calculated at 1.25 to 1.5× standard rates."
  },
  {
    "title": "",
    "description": "Minimum leave entitlement is 30 calendar days per year after one year of service."
  },
  {
    "title": "",
    "description": "Free zones have different compliance timelines; missing deadlines can lead to suspension or hefty fines."
  },
  {
    "title": "",
    "description": "Government portals (MOHRE, FTA, ESR) are interconnected, making discrepancies easily traceable."
  }
        ]
      },
      "Singapore": {
        heading: "Hidden Singapore Compliance Services Insights",
        image: images.Merlion_Image,
        items: [

   {
    "title": "",
    "description": "Must appoint a Company secretary within 6 months."
  },
  {
    "title": "",
    "description": "AGM minutes required unless exempt."
  }
        ]
      },
      "Qatar": {
        heading: "Hidden Qatar Compliance Services Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [

  {
    "title": "",
    "description": "Immigration and labour inspections are more frequent before big events (like FIFA, Expo)."
  },
  {
    "title": "",
    "description": "AML/CFT rules are strict for financial institutions."
  },
  {
    "title": "",
    "description": "Board meetings and minutes must be recorded formally."
  },
  {
    "title": "",
    "description": "Mainland companies must renew trade licenses annually."
  }


        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia Compliance Services Insights",
        image: images.Petronas_Twin_Towers_Image,
        items: [
  {
    "title": "",
    "description": "Employees can work up to 8 hours per day and 45 hours per week, with a mandatory 30-minute break after 5 hours, and overtime is limited to 104 hours per month."
  },
  {
    "title": "",
    "description": "Overtime pay is 1.5× the hourly rate on weekdays, 2× on rest days, and 3× on public holidays."
  },
  {
    "title": "",
    "description": "The minimum wage is RM 1,500 per month, and salaries must be paid within 7 days after the salary period ends."
  },
  {
    "title": "",
    "description": "Employees earning above RM 4,000 per month (except manual labour roles) are often not covered by overtime and termination protections."
  }
        ]
      },
      "India": {
        heading: "Hidden India Compliance Services Insights",
        image: images.Taj_mahal_Image,
        items: [
  {
    "title": "State vs Central Laws",
    "description": "Labor laws have both central and state components, with different requirements."
  },
  {
    "title": "Factory License Requirements",
    "description": "Manufacturing units need multiple clearances from pollution, fire, and electrical departments."
  },
  {
    "title": "Contract Labor Regulations",
    "description": "Principal employer responsibilities for contractor employees."
  }
        ]
      },
      "France": {
        heading: "Hidden France Compliance Services Insights",
        image: images.Eiffel_Tower_Image,
        items: [
  {
    "title": "",
    "description": "Labour inspections are frequent and can be unannounced."
  },
  {
    "title": "",
    "description": "Employee handbooks and policies must be aligned with French labour codes and collective agreements."
  },
  {
    "title": "",
    "description": "GDPR enforcement in France is strict; CNIL (a data authority) actively issues fines."
  },
  {
    "title": "",
    "description": "Annual statutory filings, like accounts, board decisions, are not optional even for small entities."
  }


        ]
      },
      "Canada": {
        heading: "Hidden Canada Compliance Services Insights",
        image: images.CN_tower_Image,
        items: [

  {
    "title": "Working Hours",
    "description": "Standard hours are 8 hours/day or 40 hours/week, with overtime pay starting after 44 hours/week in most provinces."
  },
  {
    "title": "Overtime Pay",
    "description": "Typically 1.5× hourly wage, though rules vary by province."
  },
  {
    "title": "Minimum Wage",
    "description": "Ranges from $15.00 to $17.30/hour depending on the province or territory."
  },
  {
    "title": "Record-Keeping",
    "description": "Employers must retain payroll and compliance records for at least 6 years for CRA and labour audits."
  },
  {
    "title": "Termination Rules",
    "description": "Notice or pay-in-lieu depends on length of service; severance applies in certain provinces like Ontario."
  }


        ]
      },
      "Brazil": {
        heading: "Hidden Brazil Compliance Services Insights",
        image: images.Christ_the_Redeemer_Image,
        items: [

  {
    "title": "",
    "description": "Labour inspections can result in significant fines and business closure."
  },
  {
    "title": "",
    "description": "Environmental compliance varies by state and can be very strict."
  },
  {
    "title": "",
    "description": "LGPD violations can result in fines up to 2% of revenue."
  },
  {
    "title": "",
    "description": "Multiple regulatory bodies often have overlapping jurisdiction."
  },
  {
    "title": "",
    "description": "Compliance calendars are complex with federal, state, and municipal deadlines."
  }


        ]
      },
      "Australia": {
        heading: "Hidden Australia Compliance Services Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

   {
    "title": "State Rules",
    "description": "Breaks, overtime, and termination rules change from state to state, which can be confusing for employers."
  },
  {
    "title": "Contractor or Employee",
    "description": "The ATO checks if workers are labelled as contractors when they should be employees. Getting it wrong can mean extra tax, super, and fines."
  },
  {
    "title": "Whistleblower Laws",
    "description": "Companies must follow rules that protect staff who report wrongdoing and handle their reports properly."
  }


        ]
      }
    },
        "M&A Services": {
      "United States": {
        heading: "Hidden US M&A Services Insights",
        image: insightImages.liberty,
        items: [
  {
    "title": "HSR Filing Thresholds",
    "description": "Deals over $101M (2023) require federal antitrust review, adding 30+ days."
  },
  {
    "title": "State Notification Laws",
    "description": "Some states require advance notice for large layoffs post-acquisition."
  },
  {
    "title": "Tax Structure Impact",
    "description": "Asset vs stock deals have dramatically different tax implications for sellers."
  }
        ]
      },
      "UAE": {
        heading: "Hidden UAE M&A Services Insights",
        image: images.Burj_Khalifa_Image,
        items: [
{
    "title": "",
    "description": "Competition Law compliance is mandatory for larger deals; violations can cost up to AED 5 million."
  },
  {
    "title": "",
    "description": "Certain sectors (banking, telecom, energy) require Central Bank or TRA approvals for M&A."
  },
  {
    "title": "",
    "description": "Family-owned businesses dominate many sectors; cultural understanding is key for negotiations."
  },
  {
    "title": "",
    "description": "Pre-deal restructuring in free zones can reduce tax and regulatory burdens."
  }
        ]
      },
      "Singapore": {
        heading: "Hidden Singapore M&A Services Insights",
        image: images.Merlion_Image,
        items: [

  {
    "title": "",
    "description": "CCCS may review large mergers for competition impact."
  },
  {
    "title": "",
    "description": "Restrictions exist in sectors like media and transport."
  }
        ]
      },
      "Qatar": {
        heading: "Hidden Qatar M&A Services Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [
 {
    "title": "",
    "description": "Government approvals are needed in regulated industries."
  },
  {
    "title": "",
    "description": "Valuation is often linked to oil/gas exposure."
  },
  {
    "title": "",
    "description": "Post-merger integration is often underestimated in Qatar."
  }
        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia M&A Services Insights",
        image: images.Petronas_Twin_Towers_Image,
        items: [
  {
    "title": "New Merger Rules Coming",
    "description": "A cross-sector regime will soon require pre-merger notifications, with fines up to 10% of deal value and reviews of up to 120 days."
  },
  {
    "title": "Sector Notifications",
    "description": "In aviation (MAVCOM) and telecom (MCMC), notifications are optional but may trigger reviews if revenue or market share thresholds are met."
  },
  {
    "title": "Competition Risks Remain",
    "description": "Even without formal reviews, anti-competitive practices post-merger can face action under the Competition Act."
  }
        ]
      },
      "India": {
        heading: "Hidden India M&A Services Insights",
        image: images.Taj_mahal_Image,
        items: [
 {
    "title": "Competition Commission Thresholds",
    "description": "Deals above ₹2,000 crores require CCI approval, adding 210 days."
  },
  {
    "title": "Foreign Investment Approval",
    "description": "Certain sectors require government approval, adding 4 to 8 weeks."
  },
  {
    "title": "Stamp Duty Variations",
    "description": "Different states have varying stamp duty rates (0.1% to 8%)."
  }
        ]
      },
      "France": {
        heading: "Hidden France M&A Services Insights",
        image: images.Eiffel_Tower_Image,
        items: [

   {
    "title": "",
    "description": "Certain sectors like defence, energy, and transport require government approval for foreign acquisition."
  },
  {
    "title": "",
    "description": "Social partners like unions, work councils have a legal right to be consulted before M&A closes."
  },
  {
    "title": "",
    "description": "Due diligence in France must cover labour law obligations, like unpaid leave, etc."
  }


        ]
      },
      "Canada": {
        heading: "Hidden Canada M&A Services Insights",
        image: images.CN_tower_Image,
        items: [

  {
    "title": "Mandatory Notifications",
    "description": "Large transactions may require pre-merger notification under the Competition Act, with reviews taking 30 to 45 days, or longer for complex cases."
  },
  {
    "title": "Foreign Investment Reviews",
    "description": "Significant acquisitions involving non-Canadian buyers may require Investment Canada Act approval for economic benefit and national security reasons."
  },
  {
    "title": "Sector-Specific Oversight",
    "description": "Industries such as banking, telecom, energy, and transportation often face additional scrutiny from federal or provincial regulators."
  },
  {
    "title": "Cultural Integration",
    "description": "Misaligned corporate cultures are a leading cause of post-merger failure; early integration planning is critical."
  }


        ]
      },
      "Brazil": {
        heading: "Hidden Brazil M&A Services Insights",
        image: images.Christ_the_Redeemer_Image,
        items: [

  {
    "title": "",
    "description": "CADE approval is required for transactions above certain thresholds."
  },
  {
    "title": "",
    "description": "Labour liabilities often exceed initial estimates."
  },
  {
    "title": "",
    "description": "Tax contingencies are common and material."
  },
  {
    "title": "",
    "description": "Environmental liabilities can be significant, especially in manufacturing."
  },
  {
    "title": "",
    "description": "Cultural integration challenges are often underestimated."
  }


        ]
      },
      "Australia": {
        heading: "Hidden Australia M&A Services Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

   {
    "title": "ACCC Check",
    "description": "Big business deals may need approval from ACCC, which can slow things down."
  },
  {
    "title": "FIRB OK",
    "description": "Foreign buyers often need FIRB approval before buying Australian companies or assets."
  },
  {
    "title": "Tax Impact",
    "description": "Selling assets and selling shares are taxed differently, which changes how much tax sellers pay."
  }


        ]
      }
    },
        "Software Solutions": {
      "United States": {
        heading: "Hidden US Software Solutions Insights",
        image: insightImages.liberty,
        items: [
  {
    "title": "Integration Costs",
    "description": "Connecting multiple software systems often costs 2-3x the license fees."
  },
  {
    "title": "Data Migration Complexity",
    "description": "Moving from legacy systems can take 6-18 months and significant resources."
  },
  {
    "title": "Compliance Requirements",
    "description": "Healthcare and finance sectors require specialised security certifications (HIPAA, SOX)."
  }
        ]
      },
      "UAE": {
        heading: "Hidden UAE Software Solutions Insights",
        image: images.Burj_Khalifa_Image,
        items: [
  {
    "title": "",
    "description": "ERP use is growing fast, with more businesses choosing cloud-based systems because they are faster, cheaper, and easier to manage."
  },
  {
    "title": "",
    "description": "SaaS (Software as a Service) is becoming the most popular choice, as companies prefer flexible, subscription-based tools they can scale up or down as needed."
  },
  {
    "title": "",
    "description": "Data security and compliance are becoming more important with PDPL rules and TDRA checks to make sure companies handle data safely."
  },
  {
    "title": "",
    "description": "Mobile-friendly and bilingual software is now a must to support the UAE’s diverse and multilingual workforce."
  },
  {
    "title": "",
    "description": "Local software platforms like Compass ERP are popular because they are made for the GCC market and support both Arabic and English."
  }
        ]
      },
      "Singapore": {
        heading: "Hidden Singapore Software Solutions Insights",
        image: images.Merlion_Image,
        items: [

 {
    "title": "",
    "description": "IMDA grants incentives for cloud adoption"
  },
  {
    "title": "",
    "description": "API connectors needed for CPF/ IRAS Integration"
  }
        ]
      },
      "Qatar": {
        heading: "Hidden Qatar Software Solutions Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [
   {
    "title": "",
    "description": "The government encourages digital adoption via “Smart Qatar” (TASMU)."
  },
  {
    "title": "",
    "description": "Data hosting is often preferred in-country."
  },
  {
    "title": "",
    "description": "Integration with WPS payroll systems is in demand."
  },
  {
    "title": "",
    "description": "Security standards often align with ISO."
  }
        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia Software Solutions Insights",
        image: images.Petronas_Twin_Towers_Image,
        items: [
  {
    "title": "Integration Costs",
    "description": "Linking multiple platforms can cost 2 to 3 times the license fee."
  },
  {
    "title": "Data Migration Challenges",
    "description": "Shifting from legacy systems may take 6 to 12 months and significant resources."
  },
  {
    "title": "Local Compliance Needs",
    "description": "Sectors like banking, healthcare, and e-commerce require strict data protection measures to comply with PDPA and industry rules."
  }
        ]
      },
      "India": {
        heading: "Hidden India Software Solutions Insights",
        image: images.Taj_mahal_Image,
        items: [
  {
    "title": "Data Localization Requirements",
    "description": "Critical data must be stored within India (banking, telecom, etc.)."
  },
  {
    "title": "GST on Software",
    "description": "18% GST applicable on most software licenses and services."
  },
  {
    "title": "Import Duty Considerations",
    "description": "Software imports may attract customs duty in certain cases."
  }
        ]
      },
      "France": {
        heading: "Hidden France Software Solutions Insights",
        image: images.Eiffel_Tower_Image,
        items: [

  {
    "title": "",
    "description": "France enforces strict data residency rules, and some require data storage inside the EU."
  },
  {
    "title": "",
    "description": "Cybersecurity is a priority, with CNIL, ANSSI regulating sensitive IT operations."
  },
  {
    "title": "",
    "description": "Open-source adoption is strong, but enterprises lean toward GDPR-certified SaaS tools."
  },
  {
    "title": "",
    "description": "And for workforce adoption, bilingual software solutions are preferred."
  }


        ]
      },
      "Canada": {
        heading: "Hidden Canada Software Solutions Insights",
        image: images.CN_tower_Image,
        items: [

     {
    "title": "Integration Costs",
    "description": "Combining multiple platforms can cost 2 to 3× the software license fees due to customisation and support needs."
  },
  {
    "title": "Data Migration Risks",
    "description": "Moving from legacy systems can take 6 to 12 months and requires careful planning to avoid compliance gaps or data loss."
  },
  {
    "title": "Regulatory Sensitivities",
    "description": "Industries like banking, healthcare, and e-commerce have stringent data security requirements under PIPEDA and provincial privacy laws (e.g., Quebec’s Bill 25)."
  }


        ]
      },
      "Brazil": {
        heading: "Hidden Brazil Software Solutions Insights",
        image: images.Christ_the_Redeemer_Image,
        items: [

     {
    "title": "",
    "description": "The Brazilian government promotes digital transformation via \"Brasil Digital\"."
  },
  {
    "title": "",
    "description": "Data localisation requirements are increasing for sensitive sectors."
  },
  {
    "title": "",
    "description": "eSocial integration complexity requires specialised vendors."
  },
  {
    "title": "",
    "description": "LGPD compliance features are becoming standard in enterprise software."
  },
  {
    "title": "",
    "description": "Portuguese language support is essential for user adoption."
  }


        ]
      },
      "Australia": {
        heading: "Hidden Australia Software Solutions Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

     {
    "title": "High Setup Costs",
    "description": "Connecting different software programs can cost 2 to 3 times more than buying the software itself."
  },
  {
    "title": "Data Transfer Time",
    "description": "Moving data from old systems to new ones can take 6 to 18 months and lots of effort."
  },
  {
    "title": "Security Rules",
    "description": "Sectors like healthcare and finance must follow strict security standards (like APRA CPS 234, ISO 27001)."
  }



        ]
      }
    },
        "MSP (Managed Service Provider)": {
      "United States": {
        heading: "Hidden US MSP Insights",
        image: insightImages.liberty,
        items: [
     {
    "title": "SLA Penalty Gaps",
    "description": "Many MSP contracts have weak penalty clauses for service-level failures."
  },
  {
    "title": "Vendor Lock-in Risk",
    "description": "Custom configurations can make switching MSPs expensive and time-consuming."
  },
  {
    "title": "Cybersecurity Insurance",
    "description": "MSP cyber incidents can void your company's insurance coverage."
  }
        ]
      },
      "UAE": {
        heading: "Hidden UAE MSP Insights",
        image: images.Burj_Khalifa_Image,
        items: [
 {
    "title": "",
    "description": "The UAE managed services market was worth around USD 1.2 billion in 2024 and is expected to grow to over USD 1.6 billion by 2026, with about 18% growth every year."
  },
  {
    "title": "",
    "description": "The cloud-managed services sector is growing fast and could reach USD 8.3 billion by 2030."
  },
  {
    "title": "",
    "description": "Managed security services are in high demand because of increasing cyber threats and the wider use of cloud technology."
  },
  {
    "title": "",
    "description": "AI-powered managed services (like AIOps and CaaS) are becoming popular for automating IT processes and quickly detecting and stopping threats."
  },
  {
    "title": "",
    "description": "Big global players like Microsoft, Google, Accenture, DXC, and Infosys are active in the UAE, offering customised solutions for local businesses."
  }
        ]
      },
      "Singapore": {
        heading: "Hidden Singapore MSP Insights",
        image: images.Merlion_Image,
        items: [

  {
    "title": "",
    "description": "Data residency requirements apply to sensitive sectors."
  },
  {
    "title": "",
    "description": "MoM audits sometimes extend into payroll IT systems."
  }
        ]
      },
      "Qatar": {
        heading: "Hidden Qatar MSP Insights",
        image: images.Museum_of_Islamic_Art_Image,
        items: [
  {
    "title": "",
    "description": "Cybersecurity law is strict on critical infrastructure."
  },
  {
    "title": "",
    "description": "Energy & finance sectors face the highest compliance standards."
  },
  {
    "title": "",
    "description": "SIEM (Security Information & Event Management) tools are often required for audits."
  },
  {
    "title": "",
    "description": "An outsourced SOC (Security Operations Centre) is more cost-effective than in-house teams."
  }
        ]
      },
      "Malaysia": {
        heading: "Hidden Malaysia MSP Insights",
        image: images.Petronas_Twin_Towers_Image,
        items: [
  {
    "title": "Weak SLA Clauses",
    "description": "Many contracts don’t cover penalties for downtime or slow response times."
  },
  {
    "title": "Vendor Lock-in Risks",
    "description": "Customised setups can make switching providers costly and complex."
  },
  {
    "title": "Cyber Insurance Gaps",
    "description": "MSP-related breaches may not be covered under standard policies without proper clauses."
  }
        ]
      },
      "India": {
        heading: "Hidden India MSP Insights",
        image: images.Taj_mahal_Image,
        items: [
  {
    "title": "Data Residency Requirements",
    "description": "Critical business data must remain within Indian borders."
  },
  {
    "title": "Vendor Due Diligence",
    "description": "Enhanced due diligence is required for foreign MSP providers."
  },
  {
    "title": "Service Tax Implications",
    "description": "Different GST rates for different types of services (18% to 28%)."
  }
        ]
      },
      "France": {
        heading: "Hidden France MSP Insights",
        image: images.Eiffel_Tower_Image,
        items: [

  {
    "title": "",
    "description": "France has a dedicated cybersecurity agency (ANSSI) that sets national standards, and compliance with their framework builds credibility."
  },
  {
    "title": "",
    "description": "Ransomware attacks are rising sharply, with SMEs often being the most targeted."
  },
  {
    "title": "",
    "description": "Many French corporations now demand cyber insurance, which reduces risk exposure."
  },
  {
    "title": "",
    "description": "Many French corporations now demand ISO 27001-certified vendors for IT partnerships."
  }


        ]
      },
      "Canada": {
        heading: "Hidden Canada MSP Insights",
        image: images.CN_tower_Image,
        items: [

    {
    "title": "Weak SLA Clauses",
    "description": "Many MSP agreements lack clear downtime penalties or performance guarantees."
  },
  {
    "title": "Vendor Lock-In Risks",
    "description": "Proprietary solutions can make switching providers expensive and complex."
  },
  {
    "title": "Cyber Insurance Gaps",
    "description": "Breaches caused by MSP systems may not be covered unless specific clauses are added to policies."
  }



        ]
      },
      "Brazil": {
        heading: "Hidden Brazil MSP Insights",
        image: images.Christ_the_Redeemer_Image,
        items: [

    {
    "title": "",
    "description": "LGPD compliance requirements are complex and evolving."
  },
  {
    "title": "",
    "description": "Financial services and healthcare face the strictest security standards."
  },
  {
    "title": "",
    "description": "Cybersecurity incidents must be reported to ANPD within specific timeframes."
  },
  {
    "title": "",
    "description": "Local data residency requirements are increasing in regulated sectors."
  },
  {
    "title": "",
    "description": "Portuguese-speaking technical staff are essential for user support."
  }


        ]
      },
      "Australia": {
        heading: "Hidden Australia MSP Insights",
        image: images.Sydney_Opera_House_Image,
        items: [

      {
    "title": "Weak Rules",
    "description": "Some MSP contracts don’t clearly punish bad service."
  },
  {
    "title": "Hard to Switch",
    "description": "Using one MSP’s setup can make changing to another costly and slow."
  },
  {
    "title": "Insurance Risk",
    "description": "If your MSP is hacked, your cyber insurance may not pay."
  }


        ]
      }
    },
  },

  getInsights: function (service, country) {
    try {
      const serviceData = this.services[service] || this.services["EOR/PEO/AOR"];
      const countryData = serviceData[country] || serviceData["United States"];
      return countryData;
    } catch (error) {
      console.error("Error getting insights:", error);
      return {
        heading: "Default Insights",
        image: insightImages.global,
        items: []
      };
    }
  }
};

export const employmentRequirements = {
  services: {
    "EOR/PEO/AOR": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "At-Will Employment:",
            text: "Most US states allow termination without cause (Montana exception)"
          },
          {
            subtitle: "COBRA Continuation:",
            text: "Employees can extend health benefits for 18-36 months post-termination"
          },
          {
            subtitle: "Stock Option Complexity:",
            text: "EOR arrangements can complicate equity compensation for startups"
          },
          {
            subtitle: "Multi-State Workers:",
            text: "Remote employees create a nexus in their home states for tax purposes"
          },
          {
            subtitle: "PEO Accreditation:",
            text: " Look for ESAC or IRS-certified PEOs for better compliance protection"
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Standard work week:",
            text: "Monday to Friday (40 to 48 hours/week)."
          },
          {
            subtitle: "",
            text: "Public holidays vary by the Islamic calendar and are announced annually."
          },
          {
            subtitle: "Personal income tax:",
            text: "0%, but corporate tax of 9% applies above AED 375,000 profit."
          },
          {
            subtitle: "End-of-service gratuity:",
            text: "21 days’ basic salary per year (first 5 years), 30 days thereafter."
          },
          {
            subtitle: "",
            text: " Bilingual contracts (English & Arabic) are preferred for legal clarity."
          }
        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Central Provident Fund (CPF):",
            text: "Employees\' contribution can be up to 17% of wages for Singapore citizens and permanent residents (rates vary by age)"
          },
          {
            subtitle: "Employment Act Protection:",
            text: "Covers working hours, overtime, rest days, and leave entitlement."
          },
          {
            subtitle: "Public Holiday:",
            text: "11 gazetted holidays, work these days requires extra time."
          },
          {
            subtitle: "WSH (Workplace safety & health):",
            text: "Employers are legally responsible for providing a safe work environment."
          },
          {
            subtitle: "Uniform Regulations Nationwide:",
            text: " Unlike a federated system, employment laws are consistent across Singapore."
          }
        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Employers are required to register salaries under the Wage Protection System (WPS)."
          },
          {
            subtitle: "",
            text: "EOSB (End of Service Benefit) is a minimum of 3 weeks’ pay per year of service."
          },
          {
            subtitle: "",
            text: "The sponsorship model is legally mandatory in Qatar."
          },
          {
            subtitle: "",
            text: "Labour contracts must be in Arabic (bilingual preferred)."
          },

        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Payroll is monthly, and Malaysia’s financial year runs Jan to Dec."
          },
          {
            subtitle: "",
            text: "Employment contracts must include English and Malay language versions, duties, salary, and termination terms."
          },
          {
            subtitle: "",
            text: "Max work hours are ~9 h/day (5-day week) or ~8 h/day (6-day week), with Friday prayer breaks common."
          },
          {
            subtitle: "",
            text: "Personal income tax rates go up to ~30%."
          },
        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Notice Period Requirements:",
            text: "Most employment contracts require a 30 to 90-day notice period."
          },
          {
            subtitle: "Gratuity Obligation:",
            text: "Employees with 5+ years of service are entitled to gratuity payment."
          },
          {
            subtitle: "Maternity Benefits:",
            text: "26 weeks of paid maternity leave are mandated under law."
          },
          {
            subtitle: "State-Specific Variations:",
            text: "Labor laws vary significantly between states like Karnataka, Maharashtra, and Tamil Nadu."
          },
          {
            subtitle: "Shop & Establishment Act:",
            text: " Registration is required in each state of operation."
          }
        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Payroll and benefits under an EOR are still tied to French law, so termination must follow strict rules."
          },
          {
            subtitle: "",
            text: "Equity or stock options through an EOR can get complex, and one must plan carefully before offering."
          },
          {
            subtitle: "",
            text: "All EOR contracts and payslips must be in French by law."
          },

        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Bilingual requirements:",
            text: "In Quebec, employment contracts and workplace communications must comply with French language laws."
          },
          {
            subtitle: "Employment laws:",
            text: "Governed at provincial levels, meaning vacation, leave policies, and termination rules differ by region."
          },
          {
            subtitle: "Healthcare coverage:",
            text: "Basic healthcare is provincial; many employers top up with private health and dental plans."
          },
          {
            subtitle: "Notice and severance:",
            text: "Employees may be entitled to 1 to 8 weeks’ notice and statutory severance based on tenure and province."
          },
          {
            subtitle: "Remote hiring:",
            text: " Canada is ideal for remote workforce models with strong internet penetration and digital infrastructure."
          },
          {
            subtitle: "Cultural tip:",
            text: "Canada values work-life balance; offering flexible schedules or remote options can boost retention."
          }
        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Employment contracts must comply with Consolidação das Leis do Trabalho (CLT)."
          },
          {
            subtitle: "",
            text: "FGTS withdrawal is only allowed in specific circumstances (termination, home purchase)."
          },
          {
            subtitle: "",
            text: "Labour unions are active, and collective bargaining agreements are common."
          },
          {
            subtitle: "",
            text: "The probation period maximum is 90 days."
          },
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "National Employment Standards (NES):",
            text: "All employees are covered by 11 minimum workplace entitlements, including leave, public holidays, and maximum weekly hours."
          },
          {
            subtitle: "Fair Work Compliance:",
            text: "Employers must adhere to Modern Awards, which set industry-specific pay rates and conditions."
          },
          {
            subtitle: "Superannuation Guarantee:",
            text: "Employers must contribute 11.5% of an employee’s earnings to super (rising to 12% in July 2025)."
          },
          {
            subtitle: "Termination Rules:",
            text: "Notice periods and redundancy payments are strictly regulated; “at-will” termination doesn’t exist in Australia."
          },
          {
            subtitle: "Work Health and Safety (WHS) Duties:",
            text: " Employers must provide a safe workplace, with compliance enforced at both state and federal levels."
          }
        ]
      }
    },

    "Incorporation/Entity Setup": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "83(b) Election:",
            text: "Founders must file within 30 days of the stock grant to avoid future tax complications."
          },
          {
            subtitle: "Blue Sky Laws:",
            text: "Each state has different securities regulations for stock issuance."
          },
          {
            subtitle: "Banking Challenges:",
            text: "Many banks require a US business address and SSN/ITIN for account opening."
          },
          {
            subtitle: "Series LLC Option:",
            text: "Delaware and Texas allow \"series\" LLCs for multiple business lines."
          },
          {
            subtitle: "Annual Report Requirements:",
            text: " Most states require annual filings with penalties for late submission."
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "100% foreign ownership is allowed in a private limited company."
          },
          {
            subtitle: "",
            text: "One resident director is mandatory."
          },

        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "100% foreign ownership is allowed in a private limited company."
          },
          {
            subtitle: "",
            text: "One resident director is mandatory."
          },

        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Trade licenses vary by activity (commercial, industrial, professional)."
          },
          {
            subtitle: "",
            text: "Certain sectors (oil, media, telecom) face strict rules."
          },
          {
            subtitle: "",
            text: "Local registered office address is mandatory."
          },

        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "The Companies Act 2016 governs incorporation."
          },
          {
            subtitle: "",
            text: "LLPs require a local compliance officer."
          },
          {
            subtitle: "",
            text: "SSM is the regulatory authority."
          },
          {
            subtitle: "",
            text: "Digital-friendly policies: Malaysia is pushing the MyDigital blueprint with MDEC incentives."
          },
        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Digital Signature Certificate:",
            text: "Mandatory for all directors and required for online filings."
          },
          {
            subtitle: "PAN & TAN Registration:",
            text: "Separate tax registrations are required for different purposes."
          },
          {
            subtitle: "GST Registration:",
            text: "Mandatory if turnover exceeds ₹20 lakhs (₹10 lakhs for special states)."
          },
          {
            subtitle: "Annual Compliance:",
            text: "Multiple annual filings, including AOC-4, MGT-7, and board resolutions."
          },
          {
            subtitle: "Foreign Exchange Regulations:",
            text: "FEMA compliance required for foreign-funded entities."
          }

        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "France has one of Europe’s lowest minimum share capital (€1), but banks may still expect higher deposits."
          },
          {
            subtitle: "",
            text: "Publishing your entity in the official Gazette is mandatory for registration."
          },
          {
            subtitle: "",
            text: "Virtual offices are accepted for registration."
          },
          {
            subtitle: "",
            text: "Regional grants and hiring subsidies can offset some startup costs."
          }


        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Corporation (Ltd./Inc.):",
            text: "Most common for startups and SMEs."
          },
          {
            subtitle: "Partnerships:",
            text: "Easy setup, but no liability protection."
          },
          {
            subtitle: "Sole Proprietorship:",
            text: "Best for freelancers or early testing phases."
          },
          {
            subtitle: "",
            text: "The CRA (Canada Revenue Agency) handles tax registration and compliance for federal accounts."
          },
          {
            subtitle: "",
            text: "Many provinces provide tax credits and incentives for R&D, green energy, or tech startups."
          },
          {
            subtitle: "",
            text: "Annual compliance includes minute book maintenance, which is legally required for corporations."
          },
          {
            subtitle: "",
            text: "Quebec businesses must comply with French language laws for names, documents, and customer-facing communication."
          }

        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "An LTDA (Limited Liability Company) is most common for foreign investors."
          },
          {
            subtitle: "",
            text: "Certain sectors require special authorisations (finance, healthcare)."
          },
          {
            subtitle: "",
            text: "Registered office address must be in Brazil."
          },
          {
            subtitle: "",
            text: "Annual financial statements must be filed with the Junta Comercial."
          },
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "No Minimum Capital Requirement:",
            text: "You can incorporate a proprietary limited company with zero paid-up capital, making the setup simpler and more accessible."
          },
          {
            subtitle: "Flexible Business Entity Options:",
            text: "A Pty Ltd (private company) offers limited liability and is scalable. Other structures, like sole traders or partnerships, are easier but expose you to higher personal risk."
          },
          {
            subtitle: "Complex Constant Compliance:",
            text: "After setup, expect responsibilities such as annual ASIC filings, record-keeping, and corporate tax returns under the Corporations Act 2001."
          },
          {
            subtitle: "Intellectual Property Needs:",
            text: "Protecting your brand via trademarks through IP Australia early on is important for scaling and avoiding future disputes."
          },
          {
            subtitle: "",
            text: "From 2025, Director IDs must be verified before company incorporation is accepted."
          }

        ]
      }
    },
    "Staffing/Talent Acquisition": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Right-to-Work States:",
            text: "27 states prohibit requiring union membership as an employment condition."
          },
          {
            subtitle: "Salary History Bans:",
            text: "21+ jurisdictions prohibit asking about previous salary in interviews."
          },
          {
            subtitle: "Remote Work Nexus:",
            text: "Employees working remotely can create tax obligations in their home state."
          },
          {
            subtitle: "I-9 Verification:",
            text: "All employees must provide work authorisation within 3 days of hire."
          },
          {
            subtitle: "FLSA Exemptions:",
            text: " Salary thresholds for overtime exemption are updated regularly by the DOL."
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Recruitment timelines:",
            text: "2 to 4 weeks for standard roles; 6 to 10 weeks for specialised roles."
          },
          {
            subtitle: "Emiratization quotas:",
            text: "Companies with over 50 employees must hire UAE nationals (starting at 2% of skilled roles)."
          },
          {
            subtitle: "Work visa processing:",
            text: "Typically 2 to 3 weeks if documentation is complete."
          },
          {
            subtitle: "Language advantage:",
            text: "English is the primary business language; Arabic is beneficial for public sector and legal roles."
          },
          {
            subtitle: "Probation periods:",
            text: " Up to 6 months are allowed under the UAE Labour Law."
          }
        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Expats often expect relocation and housing benefits."
          },
          {
            subtitle: "",
            text: "Strong focus on hiring locals to balance foreign talent."
          },
          {
            subtitle: "",
            text: "Fair Consideration Framework requires jobs to be listed on the MyCareersFuture portal before EP applications."
          },

        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Bilingual (Arabic/English) hiring is strongly preferred."
          },
          {
            subtitle: "",
            text: "Background checks can be slower for overseas hires."
          },
          {
            subtitle: "",
            text: "Visa sponsorship is the employer's responsibility."
          },


        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Malaysia enforces PDPA (2010):",
            text: " >20,000 individuals’ data = mandatory Data Protection Officer by June 2025."
          },
          {
            subtitle: "",
            text: "Misclassification of contractors is heavily scrutinised."
          },
        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Probation Period Limits:",
            text: "A maximum of 6 months probation period allowed by law."
          },
          {
            subtitle: "Bonus Payments:",
            text: "Annual bonus mandatory for employees earning up to ₹21,000/month."
          },
          {
            subtitle: "Leave Entitlements:",
            text: "12 days casual leave, 12 days sick leave minimum per year."
          },
          {
            subtitle: "Notice Period Buyouts:",
            text: "Common practice to pay salary in lieu of notice period."
          },
          {
            subtitle: "Background Verification:",
            text: "Criminal checks, education verification, typically required."
          }

        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Employers cannot charge candidates recruitment fees; it's illegal."
          },
          {
            subtitle: "",
            text: "Work permits for non-EU hires must be secured before arrival."
          },
          {
            subtitle: "",
            text: "Hiring locals can help with contracts and government tenders."
          }


        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Employment Laws:",
            text: "Standards for wages, hours, leave, and termination differ across provinces."
          },
          {
            subtitle: "Anti-Discrimination Laws:",
            text: "Apply at both federal and provincial levels; hiring practices must align with the Canadian Human Rights Act."
          },
          {
            subtitle: "Work-Life Balance:",
            text: "Canada emphasises flexibility and balance; offering hybrid or remote roles boosts retention."
          },
          {
            subtitle: "Public Holidays and Overtime:",
            text: "Vary by province; always verify region-specific compliance."
          },
          {
            subtitle: "Bilingual Regions:",
            text: "In Quebec, employment contracts and workplace communications must meet French language requirements."
          }

        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Portuguese proficiency is essential for most roles."
          },
          {
            subtitle: "",
            text: "Background checks can take 2 to 4 weeks."
          },
          {
            subtitle: "",
            text: "Work permits are required for all foreign nationals."
          },
          {
            subtitle: "",
            text: "CLT provides extensive employee protections."
          },
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "Modern Awards",
            text: "Many workers are covered by special industry rules (called awards) that decide the minimum pay and basic work conditions."
          },
          {
            subtitle: "National Employment Standards (NES)",
            text: "Every employee has 11 basic rights, such as leave, work hours, and rules for ending a job."
          },
          {
            subtitle: "Casual Loading",
            text: "Casual employees get about 25% extra pay because they don’t receive benefits like paid leave."
          },
          {
            subtitle: "Visa Work Restrictions",
            text: "Students and working holidaymakers can only work a set number of hours, and employers must make sure these limits are followed."
          },
          {
            subtitle: "Superannuation Guarantee",
            text: "Employers must pay at least 11% of a worker’s normal wages into their retirement fund (super). This will rise to 12% by 2025."
          },
          {
            subtitle: "Fair Work Information Statement",
            text: "Employers must give all new employees a simple guide about their workplace rights when they are hired."
          },
          {
            subtitle: "",
            text: "Fair Work introduced new rules in 2025 on casual conversion; long-term casuals may request permanent status."
          }

        ]
      }
    },
    "Global Payroll": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Bi-weekly Standard:",
            text: "Most US states allow termination without cause (Montana exception)"
          },
          {
            subtitle: "State Disability Insurance:",
            text: "CA, HI, NJ, NY, and RI require additional employee deductions."
          },
          {
            subtitle: "Wage Garnishment Laws:",
            text: "Federal and state laws limit how much can be garnished from wages."
          },
          {
            subtitle: "Overtime Threshold:",
            text: "Non-exempt employees earn 1.5x pay for hours over 40/week."
          },
          {
            subtitle: "Year-End Tax Forms:",
            text: " W-2s must be provided by January 31st following the tax year."
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Standard payroll frequency:",
            text: "monthly."
          },
          {
            subtitle: "Gratuity pay (for non-DEWS systems):",
            text: "calculated per UAE labour law, about 21 days' wage per year."
          },
          {
            subtitle: "WPS compliance:",
            text: "payroll must be routed through approved banks."
          },
          {
            subtitle: "",
            text: "Watch for different rules across free zones vs. mainland setups."
          },
          {
            subtitle: "",
            text: " Accurate payroll calculation is essential for visa renewals and audit readiness."
          }
        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Payslips are mandatory under the Employment Act."
          },
          {
            subtitle: "",
            text: "Overtime rules apply to staff earning below S$2,600/ month."
          },
          {
            subtitle: "",
            text: "Employers must issue itemised payslips and keep records of salary, leave, and overtime for at least 2 years."
          },

        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Salaries must be paid in Qatari Riyal."
          },
          {
            subtitle: "",
            text: "Wage delays are closely monitored by the Ministry of Labour."
          },
          {
            subtitle: "",
            text: "Payroll outsourcing helps reduce compliance risks."
          },
          {
            subtitle: "",
            text: "Employers must provide health insurance under the new reforms."
          },

        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Probation:",
            text: "Usually 3 to 6 months."
          },
          {
            subtitle: "Statutory Contributions:",
            text: "EPF, SOCSO, and EIS are mandatory for employers and employees."
          },
          {
            subtitle: "Overtime:",
            text: "Applies to employees earning &lt;RM4,000/month."
          },
          {
            subtitle: "Working Hours:",
            text: "8 hours/day or 48 hours/week."
          },
          {
            subtitle: "Leave:",
            text: "8 to 16 annual leave days based on service; sick leave 14 to 22 days."
          },
          {
            subtitle: "Maternity & Paternity:",
            text: "98 days maternity, 7 days paternity."
          },
          {
            subtitle: "Public Holidays::",
            text: "At least 11 paid holidays annually."
          },
          {
            subtitle: "Termination Notice:",
            text: "4 to 8 weeks based on years of service."
          },
          {
            subtitle: "Minimum Wage:",
            text: "RM1,500/month."
          },
        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Salary Payment Timeline:",
            text: "Salaries must be paid by the 7th of the following month by law."
          },
          {
            subtitle: "Form 16 Requirement:",
            text: "Annual tax certificate must be provided by July 15th."
          },
          {
            subtitle: "Arrear Salary Taxation:",
            text: "Arrears are taxed separately with relief provisions."
          },
          {
            subtitle: "Reimbursement Policies:",
            text: "Fuel, mobile, and internet allowances are common and partially tax-exempt."
          },
          {
            subtitle: "Dearness Allowance:",
            text: "Some companies provide DA linked to inflation (government sector practice)."
          }

        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Salaries must be paid in Euros from a French bank account."
          },
          {
            subtitle: "",
            text: "Payslips have a standardised format where non-compliance is fined."
          },
          {
            subtitle: "",
            text: "Employers must provide a mutuelle (a supplementary health insurance) to all staff."
          },
          {
            subtitle: "",
            text: "Overtime rules are rigid, which cap hours and require premium pay rates."
          }


        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Probation:",
            text: "Typically 3 months, but can vary by employer policy."
          },
          {
            subtitle: "Statutory Deductions:",
            text: "CPP/QPP, EI, and income tax must be remitted on schedule to avoid penalties."
          },
          {
            subtitle: "Working Hours:",
            text: "Standard is 40 hours/week; overtime applies after 8 hours/day or 40 hours/week, depending on the province."
          },
          {
            subtitle: "Leave Entitlements:",
            text: "Minimum 2 weeks paid vacation, increasing to 3 weeks after 5 years in most provinces."
          },
          {
            subtitle: "Maternity & Parental Leave:",
            text: "Up to 18 months combined leave with EI benefits for qualifying employees."
          }

        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Salaries must be paid in Brazilian Reais (BRL)."
          },
          {
            subtitle: "",
            text: "Monthly salary payments are standard."
          },
          {
            subtitle: "",
            text: "eSocial compliance is mandatory for all employers."
          },
          {
            subtitle: "",
            text: "Payroll complexity makes outsourcing highly recommended."
          },
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "Pay Cycle:",
            text: "In Australia, most employers pay wages every two weeks or once a month, though weekly pay is also quite common."
          },
          {
            subtitle: "Fair Work Minimums:",
            text: "Employers must follow award or enterprise agreement pay rates, which are often higher than the national minimum wage."
          },
          {
            subtitle: "Leave Entitlements:",
            text: "Full-time employees get at least 4 weeks of annual leave and 10 days of paid sick/personal leave each year."
          },
          {
            subtitle: "Overtime Rules:",
            text: "Overtime pay depends on the award or agreement, but usually applies when someone works more than 38 hours a week."
          },
          {
            subtitle: "Payslips:",
            text: "Employers must give workers a clear payslip (online or paper) within one business day after paying them."
          },
          {
            subtitle: "Year-End Forms:",
            text: "At the end of the year, employees get an Income Statement (through myGov/ATO) that shows their total pay and taxes, instead of the US-style W-2 form."
          }

        ]
      }
    },
    "HRIS (Human Resources Information System)": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "SOC 2 Compliance:",
            text: "Most enterprise HRIS vendors provide SOC 2 Type II security audits."
          },
          {
            subtitle: "Mobile-First Design:",
            text: "60%+ of HR interactions now happen on mobile devices."
          },
          {
            subtitle: "API Limitations:",
            text: "Not all HRIS systems offer robust APIs for custom integrations."
          },
          {
            subtitle: "Reporting Capabilities:",
            text: "Advanced analytics often require separate BI tools or add-on modules."
          },
          {
            subtitle: "User Adoption Rates:",
            text: " Typical HRIS adoption takes 6-12 months to reach 80% employee usage."
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "The HR software market is growing rapidly, projected global value of USD 44.3 billion by 2032."
          },
          {
            subtitle: "",
            text: "Cloud and AI HR tools can reduce payroll/HR errors by up to 80% and improve decision-making."
          },
          {
            subtitle: "",
            text: "Arabic and English bilingual interfaces are essential due to a diverse workforce and regulatory needs."
          },
          {
            subtitle: "",
            text: "Employee portals greatly cut HR workload while improving satisfaction."
          },
          {
            subtitle: "",
            text: "Mobile-accessible HR systems are highly valued in the UAE’s digital-first environment."
          }
        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Popular local vendors include Justlogin and BIPO."
          },
          {
            subtitle: "",
            text: "CPF filing must sync monthly."
          },
        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Many HRIS vendors are now pre-integrated with WPS."
          },
          {
            subtitle: "",
            text: "Mobile-friendly tools are gaining higher adoption."
          },
          {
            subtitle: "",
            text: "Qatar's labour law mandates accurate employee records."
          },
          {
            subtitle: "",
            text: "Biometric attendance systems are common in construction."
          },

        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "AI and automation in Malaysian HR systems can reduce payroll errors by up to 80%, while 81% of payroll professionals say automating pay processing is much more efficient."
          },
          {
            subtitle: "",
            text: "Malaysia’s core HR software sector is expanding fast, with a projected CAGR of 9.7% between 2024 to 2030."
          },
          {
            subtitle: "",
            text: "Malaysia’s core HR software sector is expanding fast, with a projected CAGR of 9.7% between 2024 to 2030."
          },
          {
            subtitle: "",
            text: "AI-powered features, such as recruitment automation, predictive analytics, and chatbots, are now mainstream."
          },
          {
            subtitle: "",
            text: "The broader enterprise software market is also on the rise, expected to approach US$1.58 billion by 2030."
          },
        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Data Localization:",
            text: "Personal data of Indian employees must be stored in India (DPDP Act)."
          },
          {
            subtitle: "Statutory Report Generation:",
            text: "System must generate PF, ESI, bonus, and gratuity reports."
          },
          {
            subtitle: "Mobile Adoption:",
            text: "80%+ of Indian employees prefer mobile-first HR applications."
          },
          {
            subtitle: "Integration Challenges:",
            text: "Many legacy systems don't integrate well with Indian payroll requirements."
          },
          {
            subtitle: "Biometric Integration:",
            text: "Attendance systems often require biometric or RFID integration."
          }

        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "HRIS helps calculate end-of-service benefits automatically."
          },
          {
            subtitle: "",
            text: "Bilingual interfaces are preferred in global teams."
          },
          {
            subtitle: "",
            text: "HRIS adoption is strongly supported by France's digitalisation drive."
          },
          {
            subtitle: "",
            text: "Many providers offer employee self-service portals for payslips, leave, and insurance."
          }


        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "AI and automation in Canadian HR platforms can cut payroll errors by up to 80%, saving significant administrative time."
          },
          {
            subtitle: "",
            text: "Canada’s HR tech sector is growing rapidly, driven by the demand for hybrid and remote workforce solutions."
          },
          {
            subtitle: "",
            text: "Predictive analytics and AI-driven recruitment are now standard in enterprise-level platforms."
          },
          {
            subtitle: "",
            text: "Popular Canadian payroll and HR software markets are projected to grow at an 8 to 10% CAGR through 2030, reflecting increased adoption by SMEs."
          },
          {
            subtitle: "",
            text: "Integration with accounting tools (like QuickBooks or Xero) and banking systems is standard in most Canadian platforms."
          }

        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Many HRIS vendors offer eSocial pre-integration."
          },
          {
            subtitle: "",
            text: "Mobile apps increase employee engagement significantly."
          },
          {
            subtitle: "",
            text: "CLT mandates detailed employee record-keeping."
          },
          {
            subtitle: "",
            text: "Time tracking systems are popular in the manufacturing sector."
          },
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "STP Link:",
            text: "HRIS must work with Single Touch Payroll (STP) to send pay info to the ATO."
          },
          {
            subtitle: "Super Payments:",
            text: "Many HRIS can send superannuation money straight through SuperStream."
          },
          {
            subtitle: "Mobile Use:",
            text: "Staff often check rosters, payslips, and leave on their phones."
          },
          {
            subtitle: "System Links:",
            text: "Some HRIS don’t connect well with other tools like rostering or safety software."
          },
          {
            subtitle: "Reports:",
            text: "Basic payroll reports are included, but detailed insights need extra tools."
          },
          {
            subtitle: "Setup Time:",
            text: "It can take 6 to 9 months before most employees start using the system fully."
          }

        ]
      }
    },
    "Accounting Services": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "GAAP vs Cash Basis:",
            text: "Companies with >$25M revenue generally must use accrual accounting. "
          },
          {
            subtitle: "Section 174 Changes:",
            text: "R&D expenses must now be capitalised over 5 years (US) or 15 years (foreign)."
          },
          {
            subtitle: "Beneficial Ownership Reporting:",
            text: "New FinCEN requirements for entity ownership disclosure by 2024."
          },
          {
            subtitle: "State Franchise Taxes:",
            text: "Many states impose franchise taxes regardless of profitability."
          },
          {
            subtitle: "Foreign Bank Account Reporting:",
            text: "FBAR filings required for foreign accounts &gt;$10,000."
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Corporate Tax Filing Deadline:",
            text: "Must be filed within 9 months after the financial year-end; applicable for mainland and relevant free zone entities."
          },
          {
            subtitle: "Audit Requirements:",
            text: "Mainland companies must conduct annual audits and submit financials for license renewals; some free zones require similar compliance."
          },
          {
            subtitle: "No Withholding Tax:",
            text: "The UAE doesn’t impose WHT on dividends, royalties, or interest, simplifying cross-border payments."
          },
          {
            subtitle: "Double Tax Treaties:",
            text: "The UAE has DTAs to prevent double taxation, beneficial for international operations"
          },
          {
            subtitle: "Digital Accounting Incentives:",
            text: " While not yet universal, the UAE is encouraging digital transformation, and cloud and integrated accounting systems help streamline compliance and reporting.."
          }
        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "XBRL format filling is mandatory for many firms."
          },
          {
            subtitle: "",
            text: "Small companies may be exempt from audit if thresholds are met."
          },

        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "VAT is not yet implemented, but is expected to be implemented soon."
          },
          {
            subtitle: "",
            text: "Free zone entities are often exempt from certain filings."
          },
          {
            subtitle: "",
            text: "Small firms still need external auditors if turnover is high."
          },
          {
            subtitle: "",
            text: "Cloud-based bookkeeping is gaining traction."
          },

        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Small companies earning less than RM100,000 with fewer than 5 employees don’t need yearly audits. This helps startups save money and focus on growth."
          },
          {
            subtitle: "",
            text: "Companies must submit tax returns within 7 months after their financial year ends to stay compliant and avoid penalties."
          },
          {
            subtitle: "",
            text: "Payments to non-residents are taxed at 10 to 15%, ensuring fair revenue collection for the government."
          },
          {
            subtitle: "",
            text: "The government provides up to RM5,000 to encourage businesses to switch to digital accounting tools, making financial management easier."
          },
          {
            subtitle: "",
            text: "Over 65% of SMEs now use cloud-based platforms for real-time tracking, easier collaboration, and better financial planning."
          },
        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "GST Registration Threshold:",
            text: "₹20 lakhs for goods, ₹10 lakhs for services (lower in special states)."
          },
          {
            subtitle: "Digital Invoice Requirements:",
            text: "E-invoicing mandatory for businesses with turnover >₹5 crores."
          },
          {
            subtitle: "Books of Accounts:",
            text: "Must be maintained in English or the local official language."
          },
          {
            subtitle: "Audit Thresholds:",
            text: "Companies with a turnover of >₹1 crore require a tax audit."
          },
          {
            subtitle: "Foreign Exchange Reporting:",
            text: "FEMA compliance reports are required for foreign transactions."
          }

        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Bookkeeping must be kept in French and in the EUR currency."
          },
          {
            subtitle: "",
            text: "Electronic invoicing will be mandatory from 2026."
          },
          {
            subtitle: "",
            text: "Statutory auditors are required once thresholds are crossed."
          },
          {
            subtitle: "",
            text: "Payroll and tax data must align with bookkeeping records."
          }


        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Audit Thresholds:",
            text: "Small private corporations may not need annual audits unless required by investors, lenders, or internal policies."
          },
          {
            subtitle: "Tax Filing Deadlines:",
            text: "Corporate returns are due 6 months after the fiscal year-end; payments are due 2 to 3 months after year-end, depending on size."
          },
          {
            subtitle: "Withholding Taxes:",
            text: "Payments to non-residents may be subject to 15 to 25% withholding, unless reduced by a tax treaty."
          },
          {
            subtitle: "Cloud Adoption:",
            text: "Over 70% of Canadian SMEs now use cloud-based accounting for real-time data, collaboration, and easier compliance."
          },
          {
            subtitle: "Provincial Nuances:",
            text: "GST/HST rates vary by province, and some territories may have different reporting requirements."
          }

        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "SPED (Digital Bookkeeping System) compliance required."
          },
          {
            subtitle: "",
            text: "Independent audits are mandatory for larger companies."
          },
          {
            subtitle: "",
            text: "Tax complexity varies significantly by state."
          },
          {
            subtitle: "",
            text: "Cloud accounting adoption is growing rapidly."
          },
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "Accrual Accounting:",
            text: "Bigger companies must record income and expenses when they happen, not just when money is paid."
          },
          {
            subtitle: "R&D Tax:",
            text: "Businesses can get tax benefits for R&D spending, but the rules change if turnover is above or below $20M."
          },
          {
            subtitle: "Director ID:",
            text: "Every company director must have a Director ID number as per ASIC rules."
          },
          {
            subtitle: "Payroll Tax:",
            text: "States and territories charge payroll tax at different rates, even if the business isn’t making a profit."
          },
          {
            subtitle: "Super Guarantee:",
            text: "Employers must add 11.5% super on top of employee wages."
          },
          {
            subtitle: "Overseas Reporting:",
            text: "Companies with overseas income or bank accounts may need to report them to the ATO."
          }

        ]
      }
    },
    "Tax Services": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Safe Harbour Rules:",
            text: "Pay 100% (110% for high earners) of prior year tax to avoid penalties."
          },
          {
            subtitle: "Bonus Depreciation:",
            text: "Many business assets can be 100% deducted in the year of purchase."
          },
          {
            subtitle: "Pass-Through Entity Tax:",
            text: "Many states now impose entity-level taxes on partnerships and S-Corps."
          },
          {
            subtitle: "International Tax Complexity:",
            text: "GILTI and BEAT provisions affect companies with foreign operations."
          },
          {
            subtitle: "Cryptocurrency Reporting:",
            text: " Digital assets now require detailed reporting on tax returns."
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Filing Deadline:",
            text: "Corporate tax returns must be filed within nine months of the relevant financial year-end."
          },
          {
            subtitle: "Documentation Retention:",
            text: "Mandatory maintenance of all tax-related documents for 7 years for audit readiness"
          },
          {
            subtitle: "VAT Complementarity:",
            text: "VAT (5%) and Excise Tax compliance are handled separately, but must align with corporate tax systems"
          },
          {
            subtitle: "No Withholding Tax:",
            text: "The UAE does not impose withholding tax on dividends, interest, or royalties, simplifying cross-border payments"
          },
          {
            subtitle: "Double Tax Treaties (DTA):",
            text: " The UAE has multiple DTAs, beneficial for international businesses."
          }
        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Corporate tax is 17%, but effective rates are often <10%."
          },
          {
            subtitle: "",
            text: "GST is 9% (as of 2024) and applies if annual turnover exceeds SG$1 million."
          },
          {
            subtitle: "",
            text: "Startups enjoy 75% tax exemption on the first SG$100,000 of chargeable income for the first 3 years (if conditions met)."
          },

        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Free zones often grant tax holidays (up to 20 years)."
          },
          {
            subtitle: "",
            text: "Qatar has 80+ double tax treaties."
          },
          {
            subtitle: "",
            text: "A tax card is required for all registered companies."
          },

        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Withholding Tax (WHT):",
            text: "Payments to non-residents are taxed  15% on interest, 10% on royalties/technical fees, and 10% + 3% on contract services. Must be paid to LHDN within 1 month."
          },
          {
            subtitle: "Double Tax Relief:",
            text: "Countries with a DTA (Double Tax Agreement) can enjoy lower WHT rates (5 to 10%). A Tax Residency Certificate is required to claim relief."
          },
          {
            subtitle: "Digital Services Tax (DST):",
            text: "Foreign digital service providers earning RM500,000+ annually from Malaysian customers must register and pay 8% DST quarterly."
          },

        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Tax Regime Options:",
            text: "Companies can choose between the old regime (with deductions) or the new regime (lower rates)."
          },
          {
            subtitle: "Dividend Distribution Tax:",
            text: "Abolished, but dividends are now taxable in the hands of shareholders."
          },
          {
            subtitle: "Angel Tax Provisions:",
            text: "Startup investments above fair value may attract angel tax."
          },
          {
            subtitle: "Equalization Levy:",
            text: "2% tax on digital services by non-residents."
          },
          {
            subtitle: "Vivad Se Vishwas:",
            text: "Periodic tax dispute settlement schemes with reduced penalties."
          }

        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Electronic invoicing will be mandatory for all B2B transactions by 2026."
          },
          {
            subtitle: "",
            text: "Tax deadlines are strictly enforced; even a single day's delay can lead to fines."
          },
          {
            subtitle: "",
            text: "France requires filing in the French language and the EUR currency."
          }


        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "SR&ED Tax Credits:",
            text: "Refundable credits for eligible research and development expenses can reduce tax liability or generate cash refunds."
          },
          {
            subtitle: "Provincial Incentives:",
            text: "Certain provinces (e.g., Ontario, Quebec, BC) offer extra tax credits for innovation, digital adoption, or green initiatives."
          },
          {
            subtitle: "Double Tax Agreements:",
            text: "Canada has treaties with 90+ countries, allowing businesses to reduce withholding taxes and avoid double taxation."
          },
          {
            subtitle: "Foreign Affiliate Rules:",
            text: "Canadian companies with international operations need to comply with complex FAPI (Foreign Accrual Property Income) reporting rules."
          }

        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Brazil has one of the world's most complex tax systems."
          },
          {
            subtitle: "",
            text: "Tax incentives are available in certain regions (SUDENE, SUDAM)."
          },
          {
            subtitle: "",
            text: "Electronic tax filing is mandatory for most obligations."
          },
          {
            subtitle: "",
            text: "Professional tax advisory is essential for compliance."
          },
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "PAYG Tax:",
            text: "Businesses often need to pay some tax early every quarter to avoid ATO fines."
          },
          {
            subtitle: "Asset Write-Off:",
            text: "Some businesses can claim the cost of new tools or equipment straight away (within limits)."
          },
          {
            subtitle: "Franking Credits:",
            text: "Companies can share the tax they’ve already paid with shareholders, so profit isn’t taxed twice."
          },
          {
            subtitle: "Overseas Income:",
            text: "If a business makes money overseas, it must follow ATO rules for foreign earnings."
          },
          {
            subtitle: "Crypto Tax:",
            text: "The ATO asks for clear records of all crypto buying, selling, and profits."
          }

        ]
      }
    },
    "Compliance Services": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Ban the Box Laws:",
            text: "35+ states  restrict criminal background check timing in hiring."
          },
          {
            subtitle: "Predictive Scheduling:",
            text: "Several cities require advance work schedule posting with penalty pay."
          },
          {
            subtitle: "Pay Equity Audits:",
            text: "California and other states require pay data reporting by race/gender."
          },
          {
            subtitle: "E-Verify Requirements:",
            text: "Federal contractors and some states mandate electronic work authorisation verification."
          },
          {
            subtitle: "Break Law Variations:",
            text: " Meal and rest break requirements vary significantly by state."
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Heavy fines:",
            text: "Non-compliance with ESR or AML laws can reach up to AED 400,000."
          },
          {
            subtitle: "Strict deadlines:",
            text: "Late license renewals attract daily penalties."
          },
          {
            subtitle: "",
            text: "MOHRE inspections are increasing, targeting labour law violations."
          },
          {
            subtitle: "",
            text: "New quotas and skill-based visa categories impact hiring strategies."
          },
          {
            subtitle: "",
            text: " Most compliance filings are moving online; missed online filings carry higher penalties."
          }
        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "PDPA governs data protection."
          },
          {
            subtitle: "",
            text: "MoM requires employee records to be kept for 2 years"
          }
        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Companies must appoint a local representative."
          },
          {
            subtitle: "",
            text: "Sponsorship changes require government approval."
          },
          {
            subtitle: "",
            text: "Using outsourced compliance services saves in-house legal time."
          },
          {
            subtitle: "",
            text: "Data protection laws are tightening."
          },

        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Widespread Issues:",
            text: "Over 13,700 employers missed timely EPF contributions in early 2023."
          },
          {
            subtitle: "Heavy Penalties:",
            text: "Non-compliance can cost up to RM50,000 per violation."
          },
          {
            subtitle: "Tighter Enforcement:",
            text: "In 2024, RM18.9 million in fines were issued for anti-money laundering breaches."
          },
          {
            subtitle: "Strict Deadlines:",
            text: "Late annual return filings can lead to penalties or license suspension."
          },
        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Annual Return Filings:",
            text: "Multiple returns required - ROC, EPFO, ESIC, Factory Act, Shops Act."
          },
          {
            subtitle: "Sexual Harassment Policy:",
            text: "Internal Committee mandatory for organizations with 10+ employees."
          },
          {
            subtitle: "Corporate Social Responsibility:",
            text: "2% of the average net profit to be spent on CSR activities (if eligible)."
          },
          {
            subtitle: "Whistleblower Policy:",
            text: "Mandatory for listed companies and large unlisted companies."
          },
          {
            subtitle: "Board Meeting Requirements:",
            text: "Minimum 4 board meetings per year, with specific gap requirements."
          }

        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "All employment contracts must be in French, even for foreign staff."
          },
          {
            subtitle: "",
            text: "Industry-specific compliance, like healthcare, finance, or transport, has extra licensing layers."
          },
          {
            subtitle: "",
            text: "Anti-discrimination and equal pay laws are strictly enforced in hiring."
          }


        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Strict Deadlines:",
            text: "Late corporate return filings can result in penalties or loss of good standing."
          },
          {
            subtitle: "Heavy Penalties:",
            text: "Misclassifying employees or failing to remit CPP/EI contributions can lead to costly CRA audits and fines."
          },
          {
            subtitle: "Tighter Enforcement:",
            text: "Privacy regulators are actively auditing businesses for PIPEDA compliance and issuing penalties for breaches."
          },
          {
            subtitle: "Provincial Variations:",
            text: "Employment laws vary widely; what’s compliant in Ontario may not meet standards in BC or Quebec."
          }

        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Companies must maintain a registered office in Brazil."
          },
          {
            subtitle: "",
            text: "Regulatory changes are frequent and require constant monitoring."
          },
          {
            subtitle: "",
            text: "Compliance management systems are highly recommended."
          },
          {
            subtitle: "",
            text: "A legal representative (procurador) is often required for dealings."
          },
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "Fair Work Laws:",
            text: "All workers have basic rights like leave, work hours, and rules for ending a job."
          },
          {
            subtitle: "Awards & Agreements:",
            text: "Different industries have extra rules for pay and conditions."
          },
          {
            subtitle: "Pay Equity:",
            text: "Big companies must report the pay gap between men and women."
          },
          {
            subtitle: "Work Rights:",
            text: "Employers must check that workers are allowed to work in Australia (e.g., visa checks)."
          },
          {
            subtitle: "Breaks:",
            text: "Break times change depending on the industry rules, not the same everywhere."
          }

        ]
      }
    },
    "M&A Services": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Delaware Court Advantage:",
            text: "The Delaware Chancery Court provides specialised M&A dispute resolution."
          },
          {
            subtitle: "FIRPTA Withholding:",
            text: "Foreign sellers may face 15% withholding on US real estate sales."
          },
          {
            subtitle: "Earnout Structures:",
            text: "Performance-based payments help bridge valuation gaps."
          },
          {
            subtitle: "Representation & Warranty Insurance:",
            text: "R&W insurance is increasingly common to reduce escrow requirements."
          },
          {
            subtitle: "CFIUS Review:",
            text: "Foreign investments in sensitive industries face national security review."
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "UAE M&A activity is booming in tech, fintech, logistics, and renewable energy."
          },
          {
            subtitle: "",
            text: "Tax incentives often apply to deals that drive innovation or economic diversification."
          },
          {
            subtitle: "",
            text: "Golden Visa benefits can be extended to investors and senior executives post-deal."
          },
          {
            subtitle: "",
            text: "Free zone mergers may have shorter approval timelines than mainland mergers."
          },
          {
            subtitle: "",
            text: "Government initiatives, like the NextGenFDI program, make cross-border acquisitions smoother."
          },
          {
            subtitle: "",
            text: "ESG (Environmental, Social, and Governance) compliance is becoming a due diligence priority."
          }
        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Stamp duty applies to share transfers."
          },
          {
            subtitle: "",
            text: "Many MNCs structure holding companies here for tax treaties."
          }
        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Government approval is required in strategic industries."
          },
          {
            subtitle: "",
            text: "Local sponsors must be part of deal negotiations for mainland firms."
          },
          {
            subtitle: "",
            text: "Free zones offer more flexibility for share transfers."
          },
          {
            subtitle: "",
            text: "Professional advisors (legal, audit) are essential in Qatari M&A."
          },

        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Malaysia is increasingly active in cross-border M&A, especially in technology, manufacturing, and renewable energy sectors."
          },
          {
            subtitle: "",
            text: "Deals that promote innovation or foreign investment are often supported with tax incentives and regulatory guidance."
          },
          {
            subtitle: "",
            text: "Staying compliant with MyCC and sector-specific rules helps avoid costly delays or fines."
          },
        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Share vs Asset Deal Structure:",
            text: "Asset deals may require individual state registrations and approvals."
          },
          {
            subtitle: "Escrow Regulations:",
            text: "RBI approval is required for foreign currency escrow arrangements."
          },
          {
            subtitle: "Earnout Structures:",
            text: "Complex due to foreign exchange regulations and tax implications."
          },
          {
            subtitle: "Employee Protection:",
            text: "Transfer of undertaking rules protect employee rights in acquisitions."
          },
          {
            subtitle: "Tax Structuring:",
            text: "Capital gains tax optimization through holding company structures."
          },

        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "France's antitrust regulator closely monitors large deals."
          },
          {
            subtitle: "",
            text: "Tax structuring is key; France offers reliefs but requires complex planning."
          },
          {
            subtitle: "",
            text: "Language matters; contracts must be in French only."
          }

        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Active Market:",
            text: "Canada is seeing rising M&A activity, especially in technology, natural resources, financial services, and renewable energy sectors."
          },
          {
            subtitle: "Tax Benefits:",
            text: "Structuring deals strategically can unlock tax efficiencies and incentives, particularly for innovation and green investments."
          },
          {
            subtitle: "Cross-Border Expertise:",
            text: "U.S. and international buyers frequently enter the Canadian market; understanding cross-border tax treaties and compliance rules can reduce risk."
          }

        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Foreign investment restrictions exist in strategic sectors."
          },
          {
            subtitle: "",
            text: "Labour court contingencies must be carefully evaluated."
          },
          {
            subtitle: "",
            text: "Tax optimisation structures are complex but valuable."
          },
          {
            subtitle: "",
            text: "Professional advisors are essential for successful transactions."
          },
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "Takeovers Panel:",
            text: "A special group that solves takeover and shareholder problems instead of using the courts."
          },
          {
            subtitle: "Stamp Duty:",
            text: "Some states add an extra tax when selling business assets, property, or certain company shares."
          },
          {
            subtitle: "Earnouts:",
            text: "Sellers can get extra money later if the business does well after the deal."
          },
          {
            subtitle: "W&I Insurance:",
            text: "A type of insurance that protects sellers and reduces the need to keep money aside."
          },
          {
            subtitle: "Foreign Investment Rules:",
            text: "FIRB must approve foreign investments in important areas like land, infrastructure, and key industries."
          }

        ]
      }
    },
    "Software Solutions": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Cloud-First Preference:",
            text: "85% of new enterprise software deployments are cloud-based."
          },
          {
            subtitle: "Security Compliance:",
            text: "SOC 2 Type II certification standard for B2B software vendors."
          },
          {
            subtitle: "API-First Architecture:",
            text: "Modern software emphasises integration capabilities from day one."
          },
          {
            subtitle: "Subscription Model Dominance:",
            text: "Most business software now uses the SaaS recurring revenue model."
          },
          {
            subtitle: "Mobile Optimisation:",
            text: "60% of business software interactions now happen on mobile devices."
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "The SaaS market is growing very fast and is expected to reach USD 30.5 billion by 2029."
          },
          {
            subtitle: "",
            text: "Spending on cloud computing is also rising, with forecasts showing it could hit USD 53.6 billion by 2030."
          },
          {
            subtitle: "",
            text: "Odoo ERP is becoming very popular in both government and private sectors because it’s flexible and easy to customise."
          },
          {
            subtitle: "",
            text: "The UAE government’s focus on digital transformation and AI is creating more demand for smart, tech-driven systems in every industry."
          },
          {
            subtitle: "",
            text: "Government-backed tech hubs like Hub71 are helping businesses innovate and adopt advanced software faster."
          }
        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "SMEs can claim up to 70% subsidies under PSG ."
          },
          {
            subtitle: "",
            text: "Cybersecurity Act enforces strict compliance. "
          }
        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Cybersecurity certifications boost client trust."
          },
          {
            subtitle: "",
            text: "Cloud usage is expanding, but is regulated in some industries."
          },
          {
            subtitle: "",
            text: "Open-source solutions are growing in SMEs."
          },
          {
            subtitle: "",
            text: "Government-backed grants may support IT innovation."
          },

        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Over 70% of Malaysian businesses are adopting cloud-first solutions for scalability and cost savings."
          },
          {
            subtitle: "",
            text: "SaaS (Software-as-a-Service) models dominate, making upgrades and maintenance simpler."
          },
          {
            subtitle: "",
            text: "Mobile-friendly solutions are in demand, with over 65% of users accessing business platforms via smartphones."
          },
          {
            subtitle: "",
            text: "Government incentives under MDEC’s Digital Transformation programs support SMEs adopting advanced technologies."
          },
        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Local Vendor Preference: ",
            text: "Government and PSU contracts often prefer local software vendors."
          },
          {
            subtitle: "Multi-Language Support:",
            text: "Software often needs to support Hindi and regional languages."
          },
          {
            subtitle: "Integration with Indian Systems:",
            text: "Must integrate with GST Network, banking APIs, and Aadhaar."
          },
          {
            subtitle: "Cloud vs On-Premise:",
            text: "Many organizations still prefer on-premise due to data concerns."
          },
          {
            subtitle: "Startup Ecosystem:",
            text: " Strong local software development ecosystem with cost advantages. "
          }
        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "One good thing about France is that it provides innovation tax credits (CIR) for R&D and tech investments."
          },
          {
            subtitle: "",
            text: "IT contracts must follow French commercial law for enforceability."
          },
          {
            subtitle: "",
            text: "Digital transformation is supported by government grants for SMEs."
          }


        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Cloud-first Adoption:",
            text: "Over 75% of Canadian businesses are moving to cloud-based solutions for better scalability and cost-efficiency."
          },
          {
            subtitle: "SaaS Dominance:",
            text: "SaaS platforms simplify maintenance, compliance updates, and remote accessibility."
          },
          {
            subtitle: "Mobile-First Demand:",
            text: "With a highly mobile workforce, solutions optimised for smartphones and tablets are increasingly preferred."
          },
          {
            subtitle: "Government Support:",
            text: "Grants and incentives from programs like the Canada Digital Adoption Program (CDAP) and provincial innovation funds help SMEs upgrade digital infrastructure."
          }

        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "LGPD compliance certificates boost client confidence."
          },
          {
            subtitle: "",
            text: "Cloud adoption is accelerating, but regulatory compliance is critical."
          },
          {
            subtitle: "",
            text: "Open-source solutions are popular among startups and SMEs."
          },
          {
            subtitle: "",
            text: "Government incentives are available for technology innovation."
          },
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "Cloud Use:",
            text: "Most new software is on the cloud, not on local computers."
          },
          {
            subtitle: "Security Rules:",
            text: "Many providers follow ISO 27001 and ASD Essential Eight to keep data safe."
          },
          {
            subtitle: "Easy Connections:",
            text: "New software is built with APIs to link with other systems."
          },
          {
            subtitle: "SaaS:",
            text: "Most business software is subscription-based, with regular payments."
          },
          {
            subtitle: "Mobile Access:",
            text: "Many workers use business software on their phones, especially for HR and finance."
          }

        ]
      }
    },
    "MSP (Managed Service Provider)": {
      "United States": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "SOC 2 Requirement:",
            text: "Enterprise MSPs must maintain SOC 2 Type II compliance for security."
          },
          {
            subtitle: "NIST Framework Adoption:",
            text: "Leading MSPs align cybersecurity practices with NIST standards."
          },
          {
            subtitle: "Hybrid Work Support:",
            text: "MSPs increasingly provide endpoint management for remote workers."
          },
          {
            subtitle: "Ransomware Protection:",
            text: "MSPs now offer specialised backup and recovery services for ransomware."
          },
          {
            subtitle: "Regulatory Compliance:",
            text: "MSPs in healthcare/finance must meet HIPAA/SOX requirements."
          }
        ]
      },
      "UAE": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "The UAE managed services market is the fastest-growing in the GCC, driven by cloud, cybersecurity, and ERP adoption."
          },
          {
            subtitle: "",
            text: "Blockchain, AI, and IoT-focused MSPs are in high demand, supported by initiatives like the Dubai Blockchain Strategy and Abu Dhabi Digital Authority programs."
          },
          {
            subtitle: "",
            text: "There’s a shortage of skilled cybersecurity experts, making managed threat detection and response services very valuable."
          },
          {
            subtitle: "",
            text: "SMEs, startups, and government organisations are increasingly choosing MSP services to stay flexible and competitive."
          },
          {
            subtitle: "",
            text: "Many MSPs now include eco-friendly practices, such as green data centres and energy-efficient IT solutions."
          },
          {
            subtitle: "",
            text: "Clear contracts and flexible terms are important to avoid vendor lock-in and ensure the best service in a fast-changing IT market."
          }
        ]
      },
      "Singapore": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "ISO 27001 is common for IT providers."
          },
          {
            subtitle: "",
            text: "Cyber insurance is often bundled in MSP contracts."
          }
        ]
      },
      "Qatar": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "ISO 27001 certification expected for vendors."
          },
          {
            subtitle: "",
            text: "Cybersecurity awareness training is mandatory in many industries."
          },
          {
            subtitle: "",
            text: "Managed IT services ensure faster response to system downtime."
          },
          {
            subtitle: "",
            text: "Cloud backup and disaster recovery are highly recommended in Qatar’s business climate."
          },

        ]
      },
      "Malaysia": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Demand for cloud-first MSP services is growing rapidly, especially among SMEs."
          },
          {
            subtitle: "",
            text: "PDPA compliance is now a must-have for MSP agreements, particularly in banking, healthcare, and e-commerce."
          },
          {
            subtitle: "",
            text: "Many MSPs integrate ransomware protection and zero-trust frameworks as part of their standard offerings."
          },
          {
            subtitle: "",
            text: "Government incentives through MDEC’s digital adoption programs help businesses modernise their IT infrastructure affordably."
          },
        ]
      },
      "India": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "ISO Certifications:",
            text: "Most enterprise clients require ISO 27001, ISO 9001 certifications."
          },
          {
            subtitle: "Time Zone Advantage:",
            text: " India provides 24/7 support coverage for global operations."
          },
          {
            subtitle: "Talent Availability:",
            text: "Large pool of English-speaking technical professionals."
          },
          {
            subtitle: "Cost Arbitrage:",
            text: " Significant cost savings compared to the US/Europe (40 to 60% lower)."
          },
          {
            subtitle: "Regulatory Expertise:",
            text: "Local MSPs understand Indian compliance requirements better."
          }
        ]
      },
      "France": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "Data sovereignty matters; sensitive data often must stay within EU borders."
          },
          {
            subtitle: "",
            text: "France offers government-backed grants for SMEs' cybersecurity upgrades."
          },
          {
            subtitle: "",
            text: "Incident reporting is mandatory for regulated industries like finance and healthcare."
          }


        ]
      },
      "Canada": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "Cloud-First Growth:",
            text: "Over 70% of Canadian firms are migrating to cloud-first MSP solutions for scalability and cost control."
          },
          {
            subtitle: "PIPEDA Compliance is Critical:",
            text: "Especially in finance, healthcare, and retail, ensuring data protection compliance is a must."
          },
          {
            subtitle: "Zero-Trust & Ransomware Protection:",
            text: "Many providers now include these frameworks as standard security offerings."
          },
          {
            subtitle: "Government Support:",
            text: "Programs like the Canada Digital Adoption Program (CDAP) and provincial grants help businesses upgrade IT infrastructure affordably."
          }

        ]
      },
      "Brazil": {
        title: "Good to Know ",
        image: insightImages.global,
        points: [
          {
            subtitle: "",
            text: "ISO 27001 certification is increasingly expected by clients."
          },
          {
            subtitle: "",
            text: "LGPD awareness training is mandatory for many industries."
          },
          {
            subtitle: "",
            text: "Managed IT services ensure faster response to system issues."
          }
        ]
      },
      "Australia": {
        title: "Good to Know",
        image: insightImages.global,
        points: [
          {
            subtitle: "Security Rules",
            text: "Many MSPs follow Australian security standards."
          },
          {
            subtitle: "ACSC Guidelines",
            text: "Top MSPs follow advice from the Australian Cyber Security Centre."
          },
          {
            subtitle: "Remote Work Help",
            text: "MSPs manage devices and networks for staff working from home."
          },
          {
            subtitle: "Ransomware Protection",
            text: "MSPs provide backups and recovery to stop ransomware damage."
          },
          {
            subtitle: "Industry Rules",
            text: "MSPs working with finance, healthcare, or government must follow strict rules."
          }

        ]
      }
    },

  },

  getRequirements: function (service, country) {
    try {
      const serviceData = this.services[service] || this.services["EOR/PEO/AOR"];
      const countryData = serviceData[country] || serviceData["United States"];
      return countryData;
    } catch (error) {
      console.error("Error getting requirements:", error);
      return {
        title: "Global Employment Basics",
        image: insightImages.global,
        points: []
      };
    }
  }
};


export const matchButtonConfig = {
  serviceDisplayNames: {
    "EOR/PEO/AOR": "EOR/PEO",
    "Incorporation/Entity Set-up": "Incorporation",
    "Staffing/Talent Acquisition": "Staffing",
    "Global Payroll": "Payroll",
    "HRIS": "HRIS",
    "Accounting": "Accounting",
    "Tax": "Tax",
    "Compliance": "Compliance",
    "M&A services": "M&A",
    "Software": "Software",
    "MSP (Managed Service Provider)": "MSP"
  },

  countrySpecificText: {
    "United States": {
      prefix: "Get Matched with",
      suffixes: {
        "EOR/PEO/AOR": "Providers",
        "Incorporation/Entity Set-up": "Partners",
        "Staffing/Talent Acquisition": "Experts",
        "Global Payroll": "Solutions",
        "HRIS": "Platforms",
        "Accounting": "Firms",
        "Tax": "Specialists",
        "Compliance": "Consultants",
        "M&A services": "Advisors",
        "Software": "Vendors",
        "MSP (Managed Service Provider)": "Providers",
        "default": "Providers"
      }
    },
    "India": {
      prefix: "Get Matched with",
      suffixes: {
        "EOR/PEO/AOR": "Services",
        "Incorporation/Entity Set-up": "Partners",
        "Staffing/Talent Acquisition": "Agencies",
        "Global Payroll": "Solutions",
        "HRIS": "Platforms",
        "Accounting": "Firms",
        "Tax": "Consultants",
        "Compliance": "Experts",
        "M&A services": "Advisors",
        "Software": "Vendors",
        "MSP (Managed Service Provider)": "Providers",
        "default": "Services"
      }
    },
    "default": {
      prefix: "Get Matched with",
      suffixes: {
        "EOR/PEO/AOR": "Experts",
        "Incorporation/Entity Set-up": "Partners",
        "Staffing/Talent Acquisition": "Specialists",
        "Global Payroll": "Solutions",
        "HRIS": "Providers",
        "Accounting": "Firms",
        "Tax": "Consultants",
        "Compliance": "Experts",
        "M&A services": "Advisors",
        "Software": "Vendors",
        "MSP (Managed Service Provider)": "Providers",
        "default": "Experts"
      }
    }
  },

  getButtonText: function (service, country) {
    const displayName = this.serviceDisplayNames[service] || service;
    const template = this.countrySpecificText[country] || this.countrySpecificText.default;
    const suffix = template.suffixes[service] || template.suffixes.default;
    return `${template.prefix} ${country} ${displayName} ${suffix}`;
  },

  serviceBenefits: {
    "EOR/PEO/AOR": "Access pre-vetted employers of record",
    "Incorporation/Entity Set-up": "Find legal experts for company formation",
    "Staffing/Talent Acquisition": "Connect with specialized recruiters",
    "Global Payroll": "Discover payroll solutions",
    "HRIS": "Find HR technology providers",
    "Accounting": "Match with accounting firms",
    "Tax": "Connect with tax specialists",
    "Compliance": "Find compliance experts",
    "M&A services": "Get matched with M&A advisors",
    "Software": "Discover software solutions",
    "MSP (Managed Service Provider)": "Find managed service providers"
  }
};



/* ================
Features Page
==================*/

export const heroData = {
  backgroundImage: FeatureHeroImg,
  title: "Features that Power Smarter Global Expansion",
  subtitle: "Core Value Proposition & Key Capabilities",
  description:
    "Our mission is simple – make global expansion faster, smarter, and safer by connecting businesses with the right partners through verified data and expert insights.",
  highlight: "Thhiya",
};


export const howItWorksData = {
  title: "How It Works",
  steps: [
    {
      id: 1,
      heading: "Finding the Right Partners",
      text: "Access a global network of vetted vendors for EOR, PEO, AOR, Payroll, HRIS, Compliance, and more."
    },
    {
      id: 2,
      heading: "Making Informed Decisions",
      text: "Leverage verified reviews, performance data, and real-time market benchmarks."
    },
    {
      id: 3,
      heading: "Reducing Risk & Cost",
      text: "Ensure compliance, protect privacy, and optimize ROI with a transparent, data-backed vendor selection process."
    }
  ]
};

export const featuresData = {
  title: "Key Capabilities at a Glance",
  features: [
    {
      id: 1,
      text: "Intelligent vendor matching based on your service needs, budget, and target market",
    },
    {
      id: 2,
      text: "Real-time compliance and cost data for over countries",
    },
    {
      id: 3,
      text: "Verified client reviews with multi-dimensional performance scoring",
    },
    {
      id: 4,
      text: "Detailed partner profiles with service scope, experience, and success stories",
    },
  ],
};


export const featuresExplore = {
  title: "Explore the Tools That Help You Hire Globally, Faster and Smarter",
  subtitle: "Thhiya combines intelligent technology with expert insights to simplify global partner discovery. Explore features designed to make your expansion journey faster, smarter, and more reliable.",
  steps: [
    {
      id: 1,
      head: "⭐ Verified Reviews",
      subhead: "Make smarter choices with confidence.",
      text: "All reviews are from verified businesses and cover service quality, communication, timelines, pricing accuracy, and compliance — so you know what to expect before you engage.",
    },
    {
      id: 2,
      head: "📊 Transparent Data",
      subhead: "Decisions powered by real data, not guesswork.",
      text: "Get access to live benchmarks, compliance rules, partner metrics, and readiness guides. No hidden gaps — just clear insights you can act on.",
    },
    {
      id: 3,
      head: "🧩 Vendor Profiles",
      subhead: "Explore complete, credibility-backed partner profiles.",
      text: "Each includes services, geographies, industries served, credentials, case studies, compliance records, and pricing structures — everything you need at a glance.",
    },
    {
      id: 4,
      head: "🛠 Easy Search & Filters",
      subhead: "Find the right partner, fast.",
      text: "Use filters by service, region, budget, size, and timelines. Compare partners side by side, save shortlists, and let AI suggest your best fit.",
    },
  ]
}


export const featuresFive = {
  title: "Why These Features Matter",
  subtitle: "Smarter Tools. Tangible Results.",
  cards: [
    {
      id: 1,
      title: "Save Time",
      desc: "Evaluate partners in minutes, not hours.",
      icon: clock
    },
    {
      id: 2,
      title: "Save Money",
      desc: "Access pricing benchmarks to negotiate smarter.",
      icon: banknotes
    },
    {
      id: 3,
      title: "Reduce Risk",
      desc: "Work only with verified, experienced vendors.",
      icon: decrease
    },
    {
      id: 4,
      title: "Ensure Quality",
      desc: "Use real reviews and data to avoid underperformers.",
      icon: goodquality
    }
  ],
  ctaTitle: "Ready to Experience These Features?",
  ctaDesc:
    "Start your smarter global expansion journey today. Compare vendors, review real data, and make confident decisions with",
  highlight: "Thhiya",
  buttons: [
    { id: 1, label: "Get Started", type: "primary" },
    { id: 2, label: "Schedule a Demo", type: "secondary" },
    { id: 3, label: "Contact Our Team", type: "secondary" }
  ],
  disclaimer:
    "Disclaimer: Your data privacy is our priority. We share information only with your concern."
};


/*============================
About Page
==============================*/


export const aboutData = {
  title: "Thhiya",
  subtitle: "A Global Workforce Solutions & Employer Infrastructure Platform",
  tagline: "Powering Smarter, Faster Global Expansion",
  description:
    "helps organizations discover, evaluate, and connect with trusted partners for seamless international workforce and infrastructure enablement. From startups exploring new markets to enterprises optimizing global operations, we bring precision, transparency, and speed to every expansion journey.",
  backgroundImage: AvatarNetwork,
};


export const aboutData2 = {
  vision: {
    title: "Our Vision",
    description:
      "To become the most trusted platform for discovering, evaluating, and engaging with global workforce solution providers, enabling seamless international expansion for businesses of all sizes.",
    image: AdobeStock,
  },
  mission: {
    title: "Our Mission",
    description:
      "To help companies make smarter partner decisions through transparency, verified reviews, and decision-ready insights connections while building a platform that delivers real results for both businesses and partners.",
    image: AdobeStock_2,
  },
  difference: {
    title: "What Makes Thhiya Different",
    subtitle:
      "Our approach is built on core principles that guide every feature and interaction:",
    tagline: "Beyond Traditional Marketplaces",
    points: [
      "Expert Insights: Decision-ready data backed by real market intelligence",
      "Verified Partners: Thoroughly vetted service providers across all regions",
      "Intelligent Matching: AI-driven connections based on your specific needs",
      "Transparent Benchmarking: Real-time cost and compliance data for informed decisions",
    ],
  },
};


export const whoWeHelpData = [
  {
    id: 1,
    title: "Growth Leaders & Expansion Teams",
    description:
      "Save time and reduce risk with decision-ready data and pre-qualified partner recommendations.",
    icon: growthIcon,
  },
  {
    id: 2,
    title: "Startups Entering New Markets",
    description:
      "Access cost-effective, scalable solutions without needing in-house legal or HR teams.",
    icon: startupIcon,
  },
  {
    id: 3,
    title: "Enterprises Scaling Global Operations",
    description:
      "Optimize vendor performance, stay compliant across regions, and unify fragmented processes.",
    icon: enterpriseIcon,
  },
];


export const coreValuesData = [
  {
    id: 1,
    type: "image",
    image: corevalue1,
  },
  {
    id: 2,
    type: "text",
    title: "Quality Over Quantity",
    description:
      "We focus on meaningful connections between businesses and partners who can deliver real results, not just volume.",
  },
  {
    id: 3,
    type: "image",
    image: corevalue2,
  },
  {
    id: 4,
    type: "text",
    title: "Transparency First",
    description:
      "We believe in complete transparency in pricing, capabilities, and performance metrics. Every decision should be informed by accurate, real-time data.",
  },
  {
    id: 5,
    type: "image",
    image: corevalue3,
  },
  {
    id: 6,
    type: "text",
    title: "Privacy Protection",
    description:
      "Your data is protected and shared only with your explicit consent, in accordance with India's Data Privacy Act and GDPR standards.",
  },
  {
    id: 7,
    type: "image",
    image: corevalue4,
  },
  {
    id: 8,
    type: "text",
    title: "Continuous Innovation",
    description:
      "We constantly evolve our platform to provide better insights, smarter matching, and more valuable connections.",
  },
  {
    id: 9,
    type: "image",
    image: corevalue5,
  },
];


export const thhiyaAdvantageData = [
  {
    id: 1,
    title: "For Businesses Seeking Solutions:",
    points: [
      "Save Time and Money: Complete one form, get matched to top vendors, and no endless research.",
      "Make Confident Choices: Compare real costs, compliance data, and capabilities.",
      "Maintain Full Control: Choose who contacts you, when, and how. No sales pressure.",
    ],
  },
  {
    id: 2,
    title: "For Partners:",
    points: [
      "Access Qualified Demand: Only decision-ready leads from vetted businesses.",
      "Get Discovered: Enhanced visibility through advanced listings and performance reviews.",
      "Expand Globally: Tap into new markets and sectors where your services are needed.",
    ],
  },
];


/*=================================================
                 GTM Toolkit
======================================== */




const toolkitData = [
  {
    id: 1,
    title: "List Your Business",
    description:
      "Create a verified vendor profile and showcase your capabilities to global buyers.",
    icon: ChartNoAxesCombined,
  },
  {
    id: 2,
    title: "BANT Form (MEDDIC)",
    description:
      "Qualify buyers and vendors with structured Budget, Authority, Need, and Timeline insights.",
    icon: Rocket,
  },
  {
    id: 3,
    title: "Tools & Templates",
    description:
      "Access checklists, RFP templates, compliance guides, and comparison frameworks tailored to global expansion and workforce services.",
    icon: Building,
  },
];

export default toolkitData;


/*=================================================
        GTM Component 5 (List Your Business)
======================================== */

const gtmData5 = {
  title: "List Your Business",
  description:
    "Stand out in Thhiya’s marketplace with a verified profile designed to attract the right clients.",
  subDescription:
    "Highlight your services, pricing models, and unique capabilities.",
  cards: [
    {
      id: 1,
      text: "Build trust with verified reviews and transparent performance data.",
     
    },
    {
      id: 2,
      text: "Gain visibility with decision-makers actively seeking solutions in your region or sector.",
     
    },
  ],
  buttonText: "Get Started",
};

export { gtmData5 };


const gtmData1 = {
  topText: "Expand smarter with Thhiya’s GTM Toolkit. Whether you’re a buyer seeking the right partner or a vendor showcasing services.",
  title: "GTM Toolkit.",
  title2: "Accelerate Your Global Growth",
  description: "",
};

export { gtmData1 };



const gtmData2 = [
  {
    title: "List Your Business",
    description:
      "Create a verified vendor profile and showcase your capabilities to global buyers.",
  },
  {
    title: "BANT Form (MEDDIC)",
    description:
      "Qualify buyers and vendors with structured Budget, Authority, Need, and Timeline insights.",
  },
  {
    title: "Tools & Templates",
    description:
      "Access checklists, RFP templates, compliance guides, and comparison frameworks tailored to global expansion and workforce services.",
  },
];

export { gtmData2 };





export const gtm3Data = [
  {
    title: "Vendors",
    description:
      "Save time by connecting only with decision-ready buyers.",
    icon: vendorIcon,
  },
  {
    title: "Buyers",
    description:
      "Get matched with pre-qualified vendors who understand your requirements.",
    icon: buyersIcon,
  },
  {
    title: "Marketplace",
    description:
      "Reduce wasted cycles and increase conversion efficiency.",
    icon: marketplaceIcon,
  },
];




export const gtm4Data = {
  title: "Tools & Templates for Buyers & Vendors",
  forVendors: {
    heading: "For Vendors",
    items: [
      "Proposal Templates – Pre-formatted proposals aligned to Thhiya buyer expectations.",
      "Lead Nurturing Toolkit – Email, follow-up, and demo scripts optimized for B2B service sales.",
      "Benchmark Playbooks – Insights on average pricing, win rates, and service expectations in each category."
    ]
  },
  forBuyers: {
    heading: "For Buyers",
    items: [
      "Vendor Comparison Matrix – Compare multiple vendors side-by-side on price, features, and compliance.",
      "RFP Templates – Standardized request for proposal formats across EOR, Payroll, HRIS, and other services.",
      "Market Intelligence Reports – Benchmark costs, timelines, and compliance requirements by country."
    ]
  },
  buttonText: "Download Tools & Templates"
};

/**======================= 
 Thhiyapedia
 =========================**/



export const countries = [
  {
    id: 1,
    name: "USA",
    flag: flagUSA,
    region: "USA",
    currency: "USD ($)",
    contribution: "~10 to 15% of payroll",
    wage: "$7.25/hour",
  },
  {
    id: 2,
    name: "India",
    flag: flagIndia,
    region: "India",
    currency: "INR (₹)",
    contribution: "~15 to 20% of payroll",
    wage: "₹178 to ₹500 per day",
  },
  {
    id: 3,
    name: "Australia",
    flag: flagAustralia,
    region: "Australia",
    currency: "AUD ($)",
    contribution: "~11%",
    wage: "AUD $24.10/hour",
  },
  {
    id: 4,
    name: "Singapore",
    flag: flagSingapore,
    region: "Asia",
    currency: "SGD ($)",
    contribution: "~17% CPF",
    wage: "No national min.",
  },
  {
    id: 5,
    name: "Malaysia",
    flag: flagMalaysia,
    region: "Asia",
    currency: "MYR (RM)",
    contribution: "~14 to 16% of payroll",
    wage: "RM 1,500/month",
  },
  {
    id: 6,
    name: "Qatar",
    flag: flagQatar,
    region: "Asia",
    currency: "QAR (ر.ق)",
    contribution: "~10%",
    wage: "QAR 300–1,000/month",
  },
  {
    id: 7,
    name: "UAE",
    flag: flagUAE,
    region: "Asia",
    currency: "AED (د.إ)",
    contribution: "~12.5 to 15%",
    wage: "No federal min. wage",
  },
  {
    id: 8,
    name: "France",
    flag: flagFrance,
    region: "Europe",
    currency: "EUR (€)",
    contribution: "~30 to 45% of salary",
    wage: "€11.65/hour",
  },
  {
    id: 9,
    name: "Canada",
    flag: flagCanada,
    region: "Canada",
    currency: "CAD ($)",
    contribution: "~7.37%",
    wage: "CAD $16 to 17/hr",
  },
  {
    id: 10,
    name: "Brazil",
    flag: flagBrazil,
    region: "South America",
    currency: "BRL (R$)",
    contribution: "~26.8 to 28.8%",
    wage: "R$1,502/month",
  },
];



/*==============================
       Blog Page
================================ */

export const blogData = {
  title: "Blog of the week",
  description:
    "Struggling to convert traffic into paying customers? Discover the exact framework top-performing businesses use to capture high-quality leads — without increasing ad spend.",
  buttonText: "Read full blog",
  image: "",
  link: "#", 
};



export const blogcomp2Data = [
  {
    id: 1,
    title: "Why 78% of Businesses Fail at Lead Nurturing",
    image: "https://via.placeholder.com/300x200", 
  },
  {
    id: 2,
    title: "Why 78% of Businesses Fail at Lead Nurturing",
    image: "https://via.placeholder.com/300x200",
  },
  {
    id: 3,
    title: "Why 78% of Businesses Fail at Lead Nurturing",
    image: "https://via.placeholder.com/300x200",
  },
  {
    id: 4,
    title: "Why 78% of Businesses Fail at Lead Nurturing",
    image: "https://via.placeholder.com/300x200",
  },
  {
    id: 5,
    title: "Why 78% of Businesses Fail at Lead Nurturing",
    image: "https://via.placeholder.com/300x200",
  },
  {
    id: 6,
    title: "Why 78% of Businesses Fail at Lead Nurturing",
    image: "https://via.placeholder.com/300x200",
  },
  {
    id: 7,
    title: "The Ultimate Lead Generation Playbook",
    image: "https://via.placeholder.com/300x200",
  },
  {
    id: 8,
    title: "The Ultimate Lead Generation Playbook",
    image: "https://via.placeholder.com/300x200",
  },
  {
    id: 9,
    title: "The Ultimate Lead Generation Playbook",
    image: "https://via.placeholder.com/300x200",
  },
  {
    id: 10,
    title: "The Ultimate Lead Generation Playbook",
    image: "https://via.placeholder.com/300x200",
  },
  {
    id: 11,
    title: "The Ultimate Lead Generation Playbook",
    image: "https://via.placeholder.com/300x200",
  },
  {
    id: 12,
    title: "The Ultimate Lead Generation Playbook",
    image: "https://via.placeholder.com/300x200",
  },


];

export const articleData = {
  title: "ARTICLES",
  buttonText: "Get Updates",
  buttonLink: "/updates", 
};



export const article2Data = [
  {
    id: 1,
    title: "AMAZON – “THE DOOR DESK” TRADITION",
    description:
      "Jeff Bezos famously made desks out of wooden doors to save money in the early days. The frugality turned into a quirky tradition — some Amazonians still use them.",
    buttonText: "Read full Newsletter",
    image: article_img_2,
  },
  {
    id: 2,
    title: "AMAZON GLOBAL MARKETPLACE SPOTLIGHT: EUROPE",
    description:
      "Struggling to convert traffic into paying customers? Discover the exact framework top-performing businesses use to capture high-quality leads — without increasing ad spend.",
    buttonText: "Read full Newsletter",
    image: article_img_3,
  },
  {
    id: 3,
    title: "LEAD GENERATION",
    description:
      "Struggling to convert traffic into paying customers? Discover the exact framework top-performing businesses use to capture high-quality leads — without increasing ad spend.",
    buttonText: "Read full Newsletter",
    image: article_img_4,
  },
  {
    id: 4,
    title: "AMAZON BUSINESS STRATEGY",
    description:
      "Learn how Amazon built scalable strategies to dominate the global marketplace, with insights businesses can adapt for their own growth.",
    buttonText: "Read full Newsletter",
    image: article_img_5,
  },
];
